import type { CommodityItem } from './commodities';

// Generated file — do not edit by hand.
// Steady-state: edit via the long CSV and re-run commodities-load-csv.ts
// (dump with commodities-dump-csv.ts). The round-trip is byte-identical.

export const COMMODITIES_GENERATED: CommodityItem[] = [
  {
    value: "GENERAL GOODS",
    label: "General Goods",
    sortPosition: 1,
    isGeneric: true,
    airline: [
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "General Pharma",
    label: "General Pharma",
    sortPosition: 1,
    airline: [
      { airline: "EK", commodityCode: "E0108", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "VEGETABLES",
    label: "Vegetables",
    sortPosition: 1,
    airline: [
      { airline: "EK", commodityCode: "0800", product: "PXS" },
      { airline: "EK", commodityCode: "0800", product: "PXD" },
    ],
  },
  {
    value: "MACHINE TOOLS",
    label: "Machine Tools",
    sortPosition: 2,
    airline: [
      { airline: "EK", commodityCode: "4811", product: "GCR" },
      { airline: "EK", commodityCode: "4811", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4811", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VITAMINS,ANTIBIOTICS",
    label: "Vitamins, Antibiotics",
    sortPosition: 2,
    airline: [
      { airline: "EK", commodityCode: "6103", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "MACHINE PARTS",
    label: "Machine Parts",
    sortPosition: 3,
    airline: [
      { airline: "EK", commodityCode: "4711", product: "GCR" },
      { airline: "EK", commodityCode: "4711", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4711", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHARMACEUTICALS",
    label: "Pharmaceuticals",
    sortPosition: 3,
    airline: [
      { airline: "EK", commodityCode: "6500", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "PLANTS",
    label: "Plants",
    sortPosition: 3,
    airline: [
      { airline: "EK", commodityCode: "1475", product: "PXD" },
      { airline: "EK", commodityCode: "1475", product: "PXS" },
    ],
  },
  {
    value: "CRABS,CRAWFISH,LOBSTERS",
    label: "Crabs, Crawfish, Lobsters",
    sortPosition: 4,
    airline: [
      { airline: "EK", commodityCode: "0315", product: "PXS" },
      { airline: "EK", commodityCode: "0315", product: "PXD" },
    ],
  },
  {
    value: "ELECTRIC EQUIPMENT",
    label: "Electrical Equipment",
    sortPosition: 4,
    airline: [
      { airline: "EK", commodityCode: "4401", product: "GCR" },
      { airline: "EK", commodityCode: "4401", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MEDICINES, PHARMACEUTICALS",
    label: "Medicines, Pharmaceuticals",
    sortPosition: 4,
    airline: [
      { airline: "EK", commodityCode: "6501", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "CHEMICAL REAGENTS",
    label: "Chemical Reagents",
    sortPosition: 5,
    airline: [
      { airline: "EK", commodityCode: "6010", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "FISH, FISH PRODUCTS",
    label: "Fish, Fish Products",
    sortPosition: 5,
    airline: [
      { airline: "EK", commodityCode: "0306", product: "PXS" },
      { airline: "EK", commodityCode: "0306", product: "PXD" },
    ],
  },
  {
    value: "SHIP SPARES",
    label: "Ship Spares",
    sortPosition: 5,
    airline: [
      { airline: "EK", commodityCode: "E0062", product: "GCR" },
      { airline: "EK", commodityCode: "E0062", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4234", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT PARTS",
    label: "Aircraft Parts",
    sortPosition: 6,
    airline: [
      { airline: "EK", commodityCode: "4119", product: "GCR" },
      { airline: "EK", commodityCode: "4119", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "4119", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "4119", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CUT FLOWERS  EXCL ORCHIDS",
    label: "Cut Flowers excluding Orchids",
    sortPosition: 6,
    airline: [
      { airline: "EK", commodityCode: "1430", product: "PXD" },
      { airline: "EK", commodityCode: "1430", product: "PXS" },
    ],
  },
  {
    value: "CHERRIES",
    label: "Cherries",
    sortPosition: 7,
    airline: [
      { airline: "EK", commodityCode: "0477", product: "PXS" },
      { airline: "EK", commodityCode: "0477", product: "PXD" },
    ],
  },
  {
    value: "CONSOLIDATION",
    label: "Consolidation",
    sortPosition: 7,
    isGeneric: true,
    airline: [
      { airline: "EK", commodityCode: "E0068", product: "GCR" },
      { airline: "EK", commodityCode: "E0068", product: "AXS", productSHC: "PIL" },
      { airline: "EK", commodityCode: "E0068", product: "PXD" },
      { airline: "EK", commodityCode: "E0068", product: "PXS" },
      { airline: "EK", commodityCode: "E0068", product: "AOG", productSHC: "AOG" },
      { airline: "EK", commodityCode: "E0068", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GRAPES",
    label: "Grapes",
    sortPosition: 8,
    airline: [
      { airline: "EK", commodityCode: "0445", product: "PXS" },
      { airline: "EK", commodityCode: "0445", product: "PXD" },
    ],
  },
  {
    value: "METAL PRODUCTS  MISCELLANEOUS",
    label: "Metal Products Miscellaneous",
    sortPosition: 8,
    airline: [
      { airline: "EK", commodityCode: "3900", product: "GCR" },
      { airline: "EK", commodityCode: "3900", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3900", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COMPUTERS",
    label: "Computers",
    sortPosition: 9,
    airline: [
      { airline: "EK", commodityCode: "4306", product: "GCR" },
      { airline: "EK", commodityCode: "4306", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4308", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MEAT  FRESH OR FROZEN",
    label: "Meat, Fresh or Frozen",
    sortPosition: 9,
    airline: [
      { airline: "EK", commodityCode: "0601", product: "PXS" },
      { airline: "EK", commodityCode: "0601", product: "PXD" },
    ],
  },
  {
    value: "DRILLING EQUIPMENT",
    label: "Drilling Equipment",
    sortPosition: 10,
    airline: [
      { airline: "EK", commodityCode: "4748", product: "GCR" },
      { airline: "EK", commodityCode: "4748", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4748", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEMICALS",
    label: "Chemicals",
    sortPosition: 11,
    airline: [
      { airline: "EK", commodityCode: "6200", product: "GCR" },
      { airline: "EK", commodityCode: "6200", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOUSEHOLD GOODS, PERSONAL EFFECTS",
    label: "Household Goods, Personal Effects",
    sortPosition: 12,
    airline: [
      { airline: "EK", commodityCode: "9998", product: "GCR" },
      { airline: "EK", commodityCode: "9998", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9998", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FILTERS, PUMPS",
    label: "Filters, Pumps",
    sortPosition: 13,
    airline: [
      { airline: "EK", commodityCode: "4754", product: "GCR" },
      { airline: "EK", commodityCode: "4754", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4754", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MINING EQUIPMENT",
    label: "Mining Equipment",
    sortPosition: 14,
    airline: [
      { airline: "EK", commodityCode: "4750", product: "GCR" },
      { airline: "EK", commodityCode: "4750", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4750", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS OF AUTOMOBILE INCL ACCESSORIES /REPAIR EQUIPT",
    label: "Parts of Automobile including Accessories/Repair Equipment",
    sortPosition: 15,
    airline: [
      { airline: "EK", commodityCode: "4211", product: "GCR" },
      { airline: "EK", commodityCode: "4211", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4211", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PET FOOD",
    label: "Pet Food",
    sortPosition: 15,
    airline: [
      { airline: "EK", commodityCode: "0902", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "0902", product: "GCR" },
      { airline: "EK", commodityCode: "0902", product: "PXS" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC ARTICLES",
    label: "Plastic Articles",
    sortPosition: 16,
    airline: [
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6810", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTING INK",
    label: "Printing Ink",
    sortPosition: 17,
    airline: [
      { airline: "EK", commodityCode: "6226", product: "GCR" },
      { airline: "EK", commodityCode: "6226", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6226", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RUBBER GOODS",
    label: "Rubber Goods",
    sortPosition: 18,
    airline: [
      { airline: "EK", commodityCode: "7420", product: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7420", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "***** CLOTH BLANKETS,CLOTH SLEEPING BAGS",
    label: "Cloth Blankets, Cloth Sleeping Bags",
    airline: [
      { airline: "EK", commodityCode: "2949", product: "GCR" },
      { airline: "EK", commodityCode: "2949", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2949", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "***** RECORD COVERS",
    label: "Record Covers",
    airline: [
      { airline: "EK", commodityCode: "7163", product: "GCR" },
      { airline: "EK", commodityCode: "7163", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7000", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "***** WOODEN FURNITURE  NOT ASSMBLED/EXCL OBJECTS OF ART",
    label: "Wooden Furniture Not Assembled, Excluding Objects",
    airline: [
      { airline: "EK", commodityCode: "7629", product: "GCR" },
      { airline: "EK", commodityCode: "7629", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7629", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****BATIK TEXTILES",
    label: "Batik Textiles",
    airline: [
      { airline: "EK", commodityCode: "2183", product: "GCR" },
      { airline: "EK", commodityCode: "2183", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2183", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****CIGARETTES, CIGARS AND/OR TOBACCO",
    label: "Cigarettes, Cigars, and/or Tobacco",
    airline: [
      { airline: "EK", commodityCode: "1563", product: "GCR" },
      { airline: "EK", commodityCode: "1563", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****COCKLES",
    label: "Cockles",
    airline: [
      { airline: "EK", commodityCode: "0311", product: "PXS" },
      { airline: "EK", commodityCode: "0311", product: "PXD" },
    ],
  },
  {
    value: "*****CUT FLOWERS,FOLIAGE, INCL MIMOSA",
    label: "Cut Flowers, Foliage, Including",
    airline: [
      { airline: "EK", commodityCode: "1421", product: "PXS" },
      { airline: "EK", commodityCode: "1421", product: "PXD" },
    ],
  },
  {
    value: "*****FRANKINCESE AND GUMS",
    label: "Frankincense and",
    airline: [
      { airline: "EK", commodityCode: "1353", product: "PXS" },
      { airline: "EK", commodityCode: "1353", product: "PXD" },
    ],
  },
  {
    value: "*****MEAT FRESH-FROZEDN INCL HORSE MEAT AND POULTRY",
    label: "Meat Fresh - Frozen, Including Horse Meat and Parts",
    airline: [
      { airline: "EK", commodityCode: "0650", product: "PXS" },
      { airline: "EK", commodityCode: "0650", product: "PXD" },
    ],
  },
  {
    value: "*****PEPPER STEMS",
    label: "Pepper Stems",
    airline: [
      { airline: "EK", commodityCode: "1526", product: "PXD" },
      { airline: "EK", commodityCode: "1526", product: "PXS" },
    ],
  },
  {
    value: "*****SEAFOOD",
    label: "Seafood",
    airline: [
      { airline: "EK", commodityCode: "0302", product: "PXS" },
      { airline: "EK", commodityCode: "0302", product: "PXD" },
    ],
  },
  {
    value: "*****SHRIMPS AND/OR PRAWNS",
    label: "Shrimps and/or",
    airline: [
      { airline: "EK", commodityCode: "0382", product: "PXS" },
      { airline: "EK", commodityCode: "0382", product: "PXD" },
    ],
  },
  {
    value: "*****TANNED AND/OR PROCESSED LEATHER, SYNTHETIC LEATHER CUT TO",
    label: "Tanned and/or Processed Leather, Synthetic Leather Cut to Shape",
    airline: [
      { airline: "EK", commodityCode: "1214", product: "GCR" },
      { airline: "EK", commodityCode: "1214", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1214", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****WOOD MANUFACTURES",
    label: "Wood Manufactures",
    airline: [
      { airline: "EK", commodityCode: "7620", product: "GCR" },
      { airline: "EK", commodityCode: "7620", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7620", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****WOOLLEN KNITTED SWEATERS AND DRESSES",
    label: "Woolen Knitted Sweaters and",
    airline: [
      { airline: "EK", commodityCode: "2451", product: "GCR" },
      { airline: "EK", commodityCode: "2451", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2451", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "*****YEAST - INACTIVE",
    label: "Yeast - Inedible",
    airline: [
      { airline: "EK", commodityCode: "0898", product: "PXS" },
      { airline: "EK", commodityCode: "0898", product: "PXD" },
    ],
  },
  {
    value: "****FRUITS AND VEGETABLES EXCL BANANAS",
    label: "Fruits and Vegetables Excluding Bananas",
    airline: [
      { airline: "EK", commodityCode: "0014", product: "PXS" },
      { airline: "EK", commodityCode: "0014", product: "PXD" },
    ],
  },
  {
    value: "****FRUITS,VEGETABLES-FRESH-",
    label: "Fruits, Vegetables - Fresh",
    airline: [
      { airline: "EK", commodityCode: "0008", product: "PXS" },
      { airline: "EK", commodityCode: "0008", product: "PXD" },
    ],
  },
  {
    value: "***FISH, LIVE, INEDIBLE",
    label: "Fish, Live, Inedible",
    airline: [
      { airline: "EK", commodityCode: "1026", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "***OIL RESEARCHANDDRILLING EQPT, SUPPLIES AND ACCESSORIES",
    label: "Oil Research and Drilling Equipment, Supplies, and Accessories",
    airline: [
      { airline: "EK", commodityCode: "9972", product: "GCR" },
      { airline: "EK", commodityCode: "9972", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9972", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "A: YARN, THREAD, FIBRES, CLOTH - NOT FURTHER PROCESSED OR MANUFACTURED/EXCLUSIVELY IN BALES, BOLTS,",
    label: "Yarn, thread, fibers, cloth - not further processed or manufactured, exclusively in bales.",
    airline: [
      { airline: "EK", commodityCode: "2195", product: "GCR" },
      { airline: "EK", commodityCode: "2195", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2195", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "A: YARN, THREAD, FIBRES, TEXTILES, B: TEXTILE MANUFACTURES, C: GARMENTS, WEARING APPAREL",
    label: "Yarn, Thread, Fibers, Textiles, Textile Manufactures, Garments",
    airline: [
      { airline: "EK", commodityCode: "2199", product: "GCR" },
      { airline: "EK", commodityCode: "2199", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2199", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "A/CRAFT ENGNS,PARTS EXCL TAIL ASSMBLS,STABLISRS,WINGS,FUSELA",
    label: "Aircraft Engines, Parts excluding Tail Assemblies, Stabilizers, etc.",
    airline: [
      { airline: "EK", commodityCode: "4109", product: "GCR" },
      { airline: "EK", commodityCode: "4109", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9724", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "A/CRAFT ENGNS/PARTS INCL ACCESSRS EXCL OVRHAUL/MAINT TOOLS,S",
    label: "Aircraft Engines and Parts, Including Accessories, Excluding Overhaul",
    airline: [
      { airline: "EK", commodityCode: "4112", product: "GCR" },
      { airline: "EK", commodityCode: "4112", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9724", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ABALONE",
    label: "Abalone",
    airline: [
      { airline: "EK", commodityCode: "0314", product: "PXS" },
      { airline: "EK", commodityCode: "0314", product: "PXD" },
    ],
  },
  {
    value: "ABRASIVE TOOLS, CUTTING TOOLS",
    label: "Abrasive Tools, Cutting Tools",
    airline: [
      { airline: "EK", commodityCode: "4813", product: "GCR" },
      { airline: "EK", commodityCode: "4813", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4813", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ABRASIVES,ABRASIVE PRODUCTS,GRINDING WHEELS",
    label: "Abrasives, Abrasive Products, Grinding",
    airline: [
      { airline: "EK", commodityCode: "5050", product: "GCR" },
      { airline: "EK", commodityCode: "5050", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5050", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ABRASIVESADHESIVE ARTCLSRUBBERPLASTIC MISCITEMS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9790", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ABRASIVESAMMUNITIONCIGARS MISC ITEMS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9795", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ACCESSORIES",
    label: "Accessories",
    airline: [
      { airline: "EK", commodityCode: "9623", product: "GCR" },
      { airline: "EK", commodityCode: "9623", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9623", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ACTIVATING ANODES FOR PAPER MAKING MACHINERY",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "4761", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ADDG/CALCULATG MACHNS,CASH REGSTERS,MACHN FR DUPL DOCS TAPE,",
    label: "Adding/Calculating Machines, Cash Registers, Machine For Duplicating",
    airline: [
      { airline: "EK", commodityCode: "4318", product: "GCR" },
      { airline: "EK", commodityCode: "4318", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4318", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADDG/CALCULATG MACHNS,CASH RGSTERS,MACHNSFOR DUPLCTNG DOCS",
    label: "Adding and Calculating Machines, Cash Registers, Machines for Duplicating",
    airline: [
      { airline: "EK", commodityCode: "4312", product: "GCR" },
      { airline: "EK", commodityCode: "4312", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4312", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADDING MACHINES COMPUTING MACHINES",
    label: "Adding, Computing, Typewriting Machines, Document, Letter Duplicating Machines",
    airline: [
      { airline: "QR", commodityCode: "4310", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4311", product: "GCR" },
      { airline: "EK", commodityCode: "4311", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ADDING/CALCULATNG MACHNS,CASH REGSTR,DUPLCTG DOCMTS,TYPEWRTR",
    label: "Adding/Calculating Machines, Cash Register, Duplicating Documents",
    airline: [
      { airline: "EK", commodityCode: "4309", product: "GCR" },
      { airline: "EK", commodityCode: "4309", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4309", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADDING/COMPUTING/TYPEWRTG MACHNS,DOCUMT/LTR DUPLCTG MACHNS",
    label: "Adding, Computing, Typewriting Machines, Document, Letter Duplicating Machines",
    airline: [
      { airline: "EK", commodityCode: "4311", product: "GCR" },
      { airline: "EK", commodityCode: "4311", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4311", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADHESIVE TAPE, ADHESIVE TAPE DISPENSERS",
    label: "Adhesive Tape, Adhesive Tape Dispensers",
    airline: [
      { airline: "EK", commodityCode: "7039", product: "GCR" },
      { airline: "EK", commodityCode: "7039", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7039", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADHESIVES,SMALL ARMS,ETCHINGS  MISCELLANEOUS ITEMS",
    label: "Adhesives, Small Arms, Etchings, Miscellaneous Items",
    airline: [
      { airline: "EK", commodityCode: "9796", product: "GCR" },
      { airline: "EK", commodityCode: "9796", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9796", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADMINISTRATIVE REPORTS",
    label: "Administrative Reports",
    airline: [
      { airline: "EK", commodityCode: "7108", product: "GCR" },
      { airline: "EK", commodityCode: "7108", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ADVTG ARTCLES, DISPLAY EQPT - NOT FOR SALE",
    label: "Advertising Articles, Display Equipment - Not for Sale",
    airline: [
      { airline: "EK", commodityCode: "9576", product: "GCR" },
      { airline: "EK", commodityCode: "9576", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9576", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AGARBATHIS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "6682", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AGRICULTURAL EQUIPMENT",
    label: "Agricultural Equipment",
    airline: [
      { airline: "EK", commodityCode: "4704", product: "GCR" },
      { airline: "EK", commodityCode: "4704", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4704", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIR CONDITIONERS",
    label: "Air Conditioners",
    airline: [
      { airline: "EK", commodityCode: "4483", product: "GCR" },
      { airline: "EK", commodityCode: "4483", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4483", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIR COOLERS",
    label: "Air Conditioners",
    airline: [
      { airline: "QR", commodityCode: "4471", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4483", product: "GCR" },
      { airline: "EK", commodityCode: "4483", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AIRCRAFT",
    label: "Aircraft",
    airline: [
      { airline: "EK", commodityCode: "4105", product: "GCR" },
      { airline: "EK", commodityCode: "4105", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9717", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT ENGINES,AIRCRAFT PARTS EXCL.FUSELAGES, WINGS",
    label: "Aircraft Engines, Aircraft Parts Excluding Fuselages, Wings",
    airline: [
      { airline: "EK", commodityCode: "4110", product: "GCR" },
      { airline: "EK", commodityCode: "4110", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "4110", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9724", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT ENGINES,AIRCRAFT,PARTS EXCL FUSELAGES,WINGS,A/CRAFT",
    label: "Aircraft Engines, Aircraft Parts Excluding Fuselages, Wings, Aircraft",
    airline: [
      { airline: "EK", commodityCode: "9717", product: "GCR" },
      { airline: "EK", commodityCode: "9717", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9717", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT PARTS  EXCL AIRCRAFT ENGINES",
    label: "Aircraft Parts, Excluding Aircraft Engines",
    airline: [
      { airline: "EK", commodityCode: "4108", product: "GCR" },
      { airline: "EK", commodityCode: "4108", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "4108", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9724", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT PARTS  INCL ACCESSORIES",
    label: "Aircraft Parts, Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "9724", product: "GCR" },
      { airline: "EK", commodityCode: "9724", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9724", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AIRCRAFT PARTS  INCLDG ACCESSORIES",
    label: "Aircraft Parts Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "4123", product: "GCR" },
      { airline: "EK", commodityCode: "4123", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "4123", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "4123", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ALUMINIUM MANUFACTURES",
    label: "Aluminium Manufactures",
    airline: [
      { airline: "EK", commodityCode: "3060", product: "GCR" },
      { airline: "EK", commodityCode: "3060", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3060", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ALUMINIUM TUBINGS PLASTIC TUBINGS",
    label: "Plastic Articles",
    airline: [
      { airline: "QR", commodityCode: "3051", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AMETHYST,MALCHITE,MICA,SILICA,QUARTZ,SEMI-PRECIOUS STONS-RAW",
    label: "Amethyst, Malachite, Mica, Silica, Quartz, Semi-Precious",
    airline: [
      { airline: "EK", commodityCode: "5710", product: "GCR" },
      { airline: "EK", commodityCode: "5710", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5708", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AMMUNITION FOR SPORTING GUNS",
    label: "Ammunition for Sporting Guns",
    airline: [
      { airline: "EK", commodityCode: "9311", product: "GCR" },
      { airline: "EK", commodityCode: "9311", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9311", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AMPLIFIERS,SPEAKERS,RHYTHM BOXES,RADIOS",
    label: "Amplifiers, Speakers, Rhythm Boxes",
    airline: [
      { airline: "EK", commodityCode: "4429", product: "GCR" },
      { airline: "EK", commodityCode: "4429", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4429", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ANALYTICAL MEASURING INSTRMTS FOR MED/SCIENTIFIC PURPOSES",
    label: "Analytical Measuring Instruments for Medical/Scientific Purposes",
    airline: [
      { airline: "EK", commodityCode: "8610", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ANIMAL HUNTING TROPHIES  EXCLUDING MORY",
    label: "Animal Hunting Trophies Excluding Ivory",
    airline: [
      { airline: "EK", commodityCode: "1993", product: "GCR" },
      { airline: "EK", commodityCode: "1993", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ANIMAL IDENTIFICATION EAR TAGS MARKING DYES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9661", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ANTI CORROSIONSEALING PRODS FOR PROTCTN OF METALC STRUCTURE",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "6910", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ARTICHOKES",
    label: "Artichokes",
    airline: [
      { airline: "EK", commodityCode: "0801", product: "PXS" },
      { airline: "EK", commodityCode: "0801", product: "PXD" },
    ],
  },
  {
    value: "ARTICLES OF BAGGAGE USEDOWNED BY INDIVCONSIGNED BY TRANSPO",
    label: "Unaccompanied Baggage, Personal Effects Not For Resale",
    airline: [
      { airline: "QR", commodityCode: "9987", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9986", product: "GCR" },
      { airline: "EK", commodityCode: "9986", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ARTIFICIAL GUMS/RESINS, PLASTIC MANUFS. IN SHEETS, SLABS,ROD",
    label: "Artificial Gums/Resins, Plastic Manufactures in Sheets",
    airline: [
      { airline: "EK", commodityCode: "6805", product: "GCR" },
      { airline: "EK", commodityCode: "6805", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6805", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ARTIFICIAL LEATHER",
    label: "Leather, leather products",
    airline: [
      { airline: "QR", commodityCode: "1220", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1201", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1201", product: "GCR" },
    ],
  },
  {
    value: "ARTIFICIAL TEETH,RAW MTRL FOR ARTFCL TEETH, MFD FELDSPAR",
    label: "Artificial Teeth, Raw Materials for Artificial Teeth",
    airline: [
      { airline: "EK", commodityCode: "8181", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ARTIFICIAL/GLASS STONES, GLASS/PLASTIC PEARS,UNSET,UNMOUNTED",
    label: "Artificial and Glass Stones, Glass and Plastic Pearls, Unset",
    airline: [
      { airline: "EK", commodityCode: "5858", product: "GCR" },
      { airline: "EK", commodityCode: "5858", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5858", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ASAFOETIDA",
    label: "Asafoetida",
    airline: [
      { airline: "EK", commodityCode: "0737", product: "GCR" },
      { airline: "EK", commodityCode: "0737", product: "PXS" },
      { airline: "EK", commodityCode: "0737", product: "PXD" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ASBESTOS PRODUCTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5100", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ASPARAGUS",
    label: "Asparagus, Maracuya",
    airline: [
      { airline: "EK", commodityCode: "0805", product: "PXS" },
      { airline: "EK", commodityCode: "0805", product: "PXD" },
    ],
  },
  {
    value: "ASPARAGUS,MARACUYA",
    label: "Asparagus, Maracuya",
    airline: [
      { airline: "EK", commodityCode: "0018", product: "PXS" },
      { airline: "EK", commodityCode: "0018", product: "PXD" },
    ],
  },
  {
    value: "ATHLETIC EQUIPMENT,SPORTING GOODS",
    label: "Athletic Equipment, Sporting Goods",
    airline: [
      { airline: "EK", commodityCode: "9200", product: "GCR" },
      { airline: "EK", commodityCode: "9200", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUDIO/VIDEO APPARATUS,COMPUTERS-FOR DOMESTIC USE ONLY",
    label: "Audio/Video Apparatus, Computers - For Domestic Use Only",
    airline: [
      { airline: "EK", commodityCode: "4451", product: "GCR" },
      { airline: "EK", commodityCode: "4451", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUSTRALIAN GOVT DIPLOMATIC POUCHES",
    label: "Diplomatic Cargo, Diplomatic Mail",
    airline: [
      { airline: "QR", commodityCode: "9946", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
      { airline: "EK", commodityCode: "9945", product: "GCR" },
      { airline: "EK", commodityCode: "9945", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AUTOMATIC CONTROL FOR MEASURG/REGULATG FLOW TEMP,HUMIDITY,TI",
    label: "Automatic control for measuring or regulating flow temperature, humidity, and time",
    airline: [
      { airline: "EK", commodityCode: "8551", product: "GCR" },
      { airline: "EK", commodityCode: "8551", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8551", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMATIC DOOR CLOSERS",
    label: "Automatic Door Closers",
    airline: [
      { airline: "EK", commodityCode: "4955", product: "GCR" },
      { airline: "EK", commodityCode: "4955", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4955", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMBL RADIOS,DICTATN MACHNS,HEARING AIDS,RECORDS,RCRDG TAP",
    label: "Automobile Radios, Dictation Machines, Hearing Aids, Records, etc.",
    airline: [
      { airline: "EK", commodityCode: "4426", product: "GCR" },
      { airline: "EK", commodityCode: "4426", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMBL RADIOS,SPEED CONTROL AMPLIFIERS,GRAPHIC EQLIZERS,PRE",
    label: "Automobile Radios, Speed Control Amplifiers, Graphic Equalizers",
    airline: [
      { airline: "EK", commodityCode: "4457", product: "GCR" },
      { airline: "EK", commodityCode: "4457", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMBL-RADIOS, DICTATN MACHNS,HEARG AIDS,RECORDS,RCRDG TAPE",
    label: "Automobile Radios, Dictation Machines, Hearing Aids, Recording",
    airline: [
      { airline: "EK", commodityCode: "4443", product: "GCR" },
      { airline: "EK", commodityCode: "4443", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMOBILE GAUGES",
    label: "Automobile Temperature Gauges",
    airline: [
      { airline: "QR", commodityCode: "4217", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4242", product: "GCR" },
      { airline: "EK", commodityCode: "4242", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AUTOMOBILE TEMPERATURE GAUGES",
    label: "Automobile Temperature Gauges",
    airline: [
      { airline: "EK", commodityCode: "4242", product: "GCR" },
      { airline: "EK", commodityCode: "4242", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4242", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUTOMOBILE TRANSMISSIONS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4216", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "AUTOMOBL PARTS INCL ACCESRS MOTORSCOOTRS,MTR/BICYCLES,AGRI M",
    label: "Automobile Parts including Accessories for Motorcycles, Motor or Bicycles",
    airline: [
      { airline: "EK", commodityCode: "4232", product: "GCR" },
      { airline: "EK", commodityCode: "4232", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4232", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AUXLRY UNITX,CABLE-FORMS/CONN,FORMS,PACKS,RELAYS,SELECTORS,S",
    label: "Auxiliary Units, Cable Forms, Connectors, Forms, Packs, Relays",
    airline: [
      { airline: "EK", commodityCode: "4490", product: "GCR" },
      { airline: "EK", commodityCode: "4490", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4490", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "AVOCADOS,PINEAPPLES",
    label: "Avocados, Pineapples",
    airline: [
      { airline: "EK", commodityCode: "0025", product: "PXS" },
      { airline: "EK", commodityCode: "0025", product: "PXD" },
    ],
  },
  {
    value: "AVOCADOS,PINEAPPLES,PAPAYA,MELONS,TAMARIND,CHAYOTE",
    label: "Avocados, Pineapples, Papaya, Melons, Tamarind",
    airline: [
      { airline: "EK", commodityCode: "0024", product: "PXS" },
      { airline: "EK", commodityCode: "0024", product: "PXD" },
    ],
  },
  {
    value: "BACON",
    label: "Bacon",
    airline: [
      { airline: "EK", commodityCode: "0655", product: "PXS" },
      { airline: "EK", commodityCode: "0655", product: "PXD" },
    ],
  },
  {
    value: "BAGS,BELTS,BILLFOLDS,BRUSHES,CLASPS,SEWING KITS,SHAVING KITS",
    label: "Bags, Belts, Billfolds, Brushes, Clasps, Sewing Kits, Shaving Kits",
    airline: [
      { airline: "EK", commodityCode: "1295", product: "GCR" },
      { airline: "EK", commodityCode: "1295", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1295", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BAGSHANDBAGSBILLFOLDSPURSESWALLETS MADE OF CANVASLEATHE",
    label: "HANDBAGS POCKETBOOKS WALLETS PURSES",
    airline: [
      { airline: "QR", commodityCode: "1239", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1231", product: "GCR" },
      { airline: "EK", commodityCode: "1231", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BAKERY PRODUCTS",
    label: "Bakery Products",
    airline: [
      { airline: "EK", commodityCode: "0510", product: "PXS" },
      { airline: "EK", commodityCode: "0510", product: "PXD" },
    ],
  },
  {
    value: "BALL BEARINGS, ROLLER BEARINGS",
    label: "Ball Bearings, Roller Bearings",
    airline: [
      { airline: "EK", commodityCode: "4911", product: "GCR" },
      { airline: "EK", commodityCode: "4911", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4911", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BANANAS",
    label: "Bananas",
    airline: [
      { airline: "EK", commodityCode: "0420", product: "PXS" },
      { airline: "EK", commodityCode: "0420", product: "PXD" },
    ],
  },
  {
    value: "BASEBALLS",
    label: "Baseballs",
    airline: [
      { airline: "EK", commodityCode: "9213", product: "GCR" },
      { airline: "EK", commodityCode: "9213", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9213", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BASKETWARE",
    label: "Basketware",
    airline: [
      { airline: "EK", commodityCode: "7382", product: "GCR" },
      { airline: "EK", commodityCode: "7382", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7382", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BATHROOM SHOWER SETS",
    label: "Bathroom Shower Sets",
    airline: [
      { airline: "EK", commodityCode: "3341", product: "GCR" },
      { airline: "EK", commodityCode: "3341", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3341", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BATTERIES",
    label: "Batteries",
    airline: [
      { airline: "EK", commodityCode: "4405", product: "GCR" },
      { airline: "EK", commodityCode: "4405", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4405", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BEANS",
    label: "Beans",
    airline: [
      { airline: "EK", commodityCode: "0810", product: "PXS" },
      { airline: "EK", commodityCode: "0810", product: "PXD" },
    ],
  },
  {
    value: "BEANS,CORN,CAPSICUM",
    label: "Beans, Corn, Capsicum",
    airline: [
      { airline: "EK", commodityCode: "0030", product: "PXS" },
      { airline: "EK", commodityCode: "0030", product: "PXD" },
    ],
  },
  {
    value: "BEDSHEETS PILLOW CASES AND TOWELS",
    label: "Blankets, Bedsheets/Spreads, Pillow Cases, Mosquito Nets",
    airline: [
      { airline: "QR", commodityCode: "2810", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2811", product: "GCR" },
      { airline: "EK", commodityCode: "2811", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BEES",
    label: "Bees",
    airline: [
      { airline: "EK", commodityCode: "1061", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BEESWAS",
    label: "Beeswax",
    airline: [
      { airline: "EK", commodityCode: "1904", product: "GCR" },
      { airline: "EK", commodityCode: "1904", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1904", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BERRIES",
    label: "Berries",
    airline: [
      { airline: "EK", commodityCode: "0401", product: "PXS" },
      { airline: "EK", commodityCode: "0401", product: "PXD" },
    ],
  },
  {
    value: "BERRIES, MELONS",
    label: "Berries, Melons",
    airline: [
      { airline: "EK", commodityCode: "0400", product: "PXS" },
      { airline: "EK", commodityCode: "0400", product: "PXD" },
    ],
  },
  {
    value: "BETEL LEAVES",
    label: "Betel Leaves",
    airline: [
      { airline: "EK", commodityCode: "1535", product: "PXD" },
      { airline: "EK", commodityCode: "1535", product: "PXS" },
    ],
  },
  {
    value: "BEVERAGES",
    label: "Beverages",
    airline: [
      { airline: "EK", commodityCode: "0110", product: "PXS" },
      { airline: "EK", commodityCode: "0110", product: "PXD" },
    ],
  },
  {
    value: "BEVERAGES,SYRUPS,FLAVOURS",
    label: "Beverages, Syrups, Flavors",
    airline: [
      { airline: "EK", commodityCode: "0190", product: "PXS" },
      { airline: "EK", commodityCode: "0190", product: "PXD" },
    ],
  },
  {
    value: "BIOLOGICALS, SEMEN SAMPLES, URINE SAMPLES, BACTERIAL CULTURES",
    label: "Biologicals, Semen Samples, Urine Samples, Bacterial Cultures",
    airline: [
      { airline: "EK", commodityCode: "6100", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "BIRDEYE CHILLIES  DRIED",
    label: "Birdseye Chillies",
    airline: [
      { airline: "EK", commodityCode: "0750", product: "PXS" },
      { airline: "EK", commodityCode: "0750", product: "PXD" },
    ],
  },
  {
    value: "BISMUTH, CADMIUM",
    label: "Bismuth, Cadmium",
    airline: [
      { airline: "EK", commodityCode: "6511", product: "GCR" },
      { airline: "EK", commodityCode: "6511", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6511", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BLANKETS,BEDSHEETS/SPREADS,PILLOW CASES,MOSQUITO NETS,TOWELS",
    label: "Blankets, Bedsheets/Spreads, Pillow Cases, Mosquito Nets",
    airline: [
      { airline: "EK", commodityCode: "2811", product: "GCR" },
      { airline: "EK", commodityCode: "2811", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2811", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BLDG EQPT ENGG CONSTRUCTION EQPT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9970", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BLDG MTRL,DISPLAY MTRL-FOR EXHIBITION/TRADE FAIRS",
    label: "Building Material, Display Material for Exhibition/Trade Fairs",
    airline: [
      { airline: "EK", commodityCode: "9991", product: "GCR" },
      { airline: "EK", commodityCode: "9991", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9991", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BLOOD SERUM, HAEMODERIVATIVES, BLOODPLASMA",
    label: "Blood Serum, Hemoderivatives, Blood Plasma",
    airline: [
      { airline: "EK", commodityCode: "6107", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "BLOODSERUM",
    label: "Blood Serum",
    airline: [
      { airline: "EK", commodityCode: "6108", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "BLOUSES,JACKETS,JEAN,SKIRT,TROUSER,WAISTCOAT-MADE OF COTTON",
    label: "Blouses, Jackets, Jeans, Skirts, Trousers, Waistcoats",
    airline: [
      { airline: "EK", commodityCode: "2292", product: "GCR" },
      { airline: "EK", commodityCode: "2292", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2292", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BODY SUPPORTING GARMENTSSWIMWEAR",
    label: "Underwear, Swimwear, Body Supporting Garments",
    airline: [
      { airline: "QR", commodityCode: "2305", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2461", product: "GCR" },
      { airline: "EK", commodityCode: "2461", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BONE ANDOR BEADS JEWELLERY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9015", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BOOKS",
    label: "Books",
    airline: [
      { airline: "EK", commodityCode: "7119", product: "GCR" },
      { airline: "EK", commodityCode: "7119", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BOOKS CATALOGUES, PAMPHLETS",
    label: "Books, Catalogues, Pamphlets",
    airline: [
      { airline: "EK", commodityCode: "7105", product: "GCR" },
      { airline: "EK", commodityCode: "7105", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BOOKS, MAGAZINES, CATALOGUES",
    label: "Books, Magazines, Catalogues",
    airline: [
      { airline: "EK", commodityCode: "7115", product: "GCR" },
      { airline: "EK", commodityCode: "7115", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BRAKE LININGS",
    label: "Brake Linings",
    airline: [
      { airline: "EK", commodityCode: "4246", product: "GCR" },
      { airline: "EK", commodityCode: "4246", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4246", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BRASS MANUFACTURS",
    label: "Brass Manufactures",
    airline: [
      { airline: "EK", commodityCode: "3050", product: "GCR" },
      { airline: "EK", commodityCode: "3050", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3050", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BREAD",
    label: "Bread",
    airline: [
      { airline: "EK", commodityCode: "0515", product: "PXS" },
      { airline: "EK", commodityCode: "0515", product: "PXD" },
    ],
  },
  {
    value: "BRISTLES",
    label: "Bristles",
    airline: [
      { airline: "EK", commodityCode: "1915", product: "GCR" },
      { airline: "EK", commodityCode: "1915", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1915", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BROCCOLI",
    label: "Broccoli",
    airline: [
      { airline: "EK", commodityCode: "0802", product: "PXS" },
      { airline: "EK", commodityCode: "0802", product: "PXD" },
    ],
  },
  {
    value: "BRUSHES",
    label: "Brushes",
    airline: [
      { airline: "EK", commodityCode: "9540", product: "GCR" },
      { airline: "EK", commodityCode: "9540", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9540", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BRUSHWARE INCLUDING ACCESSORIES",
    label: "ACCESSORIES",
    airline: [
      { airline: "QR", commodityCode: "9544", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9623", product: "GCR" },
      { airline: "EK", commodityCode: "9623", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BUILDING FIXTURES AND FITTINGS",
    label: "Building Materials, Fixtures, Fittings, etc.",
    airline: [
      { airline: "QR", commodityCode: "3320", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3321", product: "GCR" },
      { airline: "EK", commodityCode: "3321", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BUILDING MATERIAL/TOOLS/FIXTURES/FITTINGS",
    label: "Building Material, Tools, Fixtures, Fittings",
    airline: [
      { airline: "EK", commodityCode: "9973", product: "GCR" },
      { airline: "EK", commodityCode: "9973", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9973", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BUILDING MTRLS, FIXTURS, FITTNGS, EXCLDG TOOLS",
    label: "Building Materials, Fixtures, Fittings, etc.",
    airline: [
      { airline: "EK", commodityCode: "3321", product: "GCR" },
      { airline: "EK", commodityCode: "3321", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3321", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BULBS, TUBERS",
    label: "Bulbs",
    airline: [
      { airline: "EK", commodityCode: "1409", product: "PXS" },
      { airline: "EK", commodityCode: "1409", product: "PXD" },
    ],
  },
  {
    value: "BUSI/OFC MACHI INCL TOOLS,SURFC VHCLS EXCL STEAM/MOTORSHIP M",
    label: "Business and Office Machines Including Tools, Surface Vehicles Excluding Steam",
    airline: [
      { airline: "EK", commodityCode: "4010", product: "GCR" },
      { airline: "EK", commodityCode: "4010", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4010", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BUSINESS AND OFFICE MACHINERY, PARTS, ACCESSORIES",
    label: "Business and Office Machinery, Parts, Accessories",
    airline: [
      { airline: "EK", commodityCode: "4316", product: "GCR" },
      { airline: "EK", commodityCode: "4316", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4316", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "BUTTER",
    label: "Butter",
    airline: [
      { airline: "EK", commodityCode: "0210", product: "PXS" },
      { airline: "EK", commodityCode: "0210", product: "PXD" },
    ],
  },
  {
    value: "BUTTONS",
    label: "BUTTONS BUCKLES",
    airline: [
      { airline: "QR", commodityCode: "9521", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9526", product: "GCR" },
      { airline: "EK", commodityCode: "9526", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "BUTTONS, BUCKLES",
    label: "Buttons, Buckles",
    airline: [
      { airline: "EK", commodityCode: "9526", product: "GCR" },
      { airline: "EK", commodityCode: "9526", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9526", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CABLE INSULATION PAPER TAPE",
    label: "Cable Insulation Paper Tape",
    airline: [
      { airline: "EK", commodityCode: "7032", product: "GCR" },
      { airline: "EK", commodityCode: "7032", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7032", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CABLES FOR ELECTRCITY POWER PLANTSTELEGRAPHTEL INSTALLNS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4408", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CABLES,MESH,RIVET,SHEETS,TUBNGS,WIRE EXCL GOLD,SILVER,PLATIN",
    label: "Cables, Mesh, Rivets, Sheets, Tubing, Wire, excluding Gold.",
    airline: [
      { airline: "EK", commodityCode: "3991", product: "GCR" },
      { airline: "EK", commodityCode: "3991", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3991", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAKE DECORATIONS  MADE OF SUGAR,PLASTIC",
    label: "Cake Decorations Made of Sugar, Plastic",
    airline: [
      { airline: "EK", commodityCode: "9533", product: "GCR" },
      { airline: "EK", commodityCode: "9533", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9533", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CALCULATING MACHINES",
    label: "Adding/Calculating Machines, Cash Register, Duplicating Documents",
    airline: [
      { airline: "QR", commodityCode: "4308", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4309", product: "GCR" },
      { airline: "EK", commodityCode: "4309", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CAMERA SUPPLIES NAMELY: FLASH BULBS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8406", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CAMERAS, INSTRUMENTS FOR DENTISTRY, SURGERY, MEASURING, CALIBRATING, TESTING, DRAWING, ANALYSING SCA",
    label: "Cameras, instruments for dentistry, surgery, measuring, calibrating, testing, drawing, analyzing.",
    airline: [
      { airline: "EK", commodityCode: "8549", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, OPTICAL GOODS, PHOTOGRAPHIC EQUIPMENT, PROJECTION EQUIPMENT - INCLUDING SUPPLIES - FILMS EX",
    label: "Cameras, Optical Goods, Photographic Equipment, Projection Equipment - Including Supplies - Films Excluding",
    airline: [
      { airline: "EK", commodityCode: "8393", product: "GCR" },
      { airline: "EK", commodityCode: "8393", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8393", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, OPTICAL GOODS, PHOTOGRAPHIC EQUIPMENT, PROJECTION EQUIPMENT - INCLUDING SUPPLIES -, PUBLICI",
    label: "Cameras, Optical Goods, Photographic Equipment, Projection Equipment - Including Supplies -, Publications",
    airline: [
      { airline: "EK", commodityCode: "8398", product: "GCR" },
      { airline: "EK", commodityCode: "8398", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8398", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, OPTICAL GOODS, PHOTOGRAPHIC EQUIPMENT, PROJECTION EQUIPMENT - INCLUDING SUPPLIES -EXCLUDIN",
    label: "Cameras, optical goods, photographic equipment, projection equipment - including supplies - excluding",
    airline: [
      { airline: "EK", commodityCode: "8392", product: "GCR" },
      { airline: "EK", commodityCode: "8392", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8392", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, OPTICAL GOODS, PHOTOGRAPHIC EQUIPMENT, PROJECTION EQUIPMENT - INCLUDING SUPPLIES, ACCESSORI",
    label: "Cameras, optical goods, photographic equipment, projection equipment including supplies, and accessories.",
    airline: [
      { airline: "EK", commodityCode: "8391", product: "GCR" },
      { airline: "EK", commodityCode: "8391", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8391", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, OPTICAL GOODS, PHOTOGRAPHIC INSTRUMENTS, PROJECTIONINSTRUMENTS - INCLUDING APPARATUS, SUPPL",
    label: "Cameras, Optical Goods, Photographic Instruments, Projection Instruments - Including Apparatus, Supplies",
    airline: [
      { airline: "EK", commodityCode: "8401", product: "GCR" },
      { airline: "EK", commodityCode: "8401", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8401", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9708", product: "GCR" },
      { airline: "EK", commodityCode: "9708", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9708", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, PHOTOGRAPHIC EQUIPMENT (INCLUDING ACCESSORIES)",
    label: "Cameras, Photographic Equipment (Including Accessories)",
    airline: [
      { airline: "EK", commodityCode: "8405", product: "GCR" },
      { airline: "EK", commodityCode: "8405", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8405", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, PHOTOGRAPHIC INSTRUMENTS, PROJECTION INSTRUMENTS - INCLUDING APPARATUS, SUPPLIES, ACCESSORI",
    label: "Cameras, Photographic Instruments, Projection Instruments - Including Apparatus, Supplies, Accessories",
    airline: [
      { airline: "EK", commodityCode: "8400", product: "GCR" },
      { airline: "EK", commodityCode: "8400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8400", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAMERAS, SPECTACLES, BINOCULARS, MICROSCOPES, TELESCOPES, PHOTOGRAPHIC INSTRUCTIONS, PROJECTION INST",
    label: "Cameras, Spectacles, Binoculars, Microscopes, Telescopes, Photographic Instruments, Projection",
    airline: [
      { airline: "EK", commodityCode: "8396", product: "GCR" },
      { airline: "EK", commodityCode: "8396", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8372", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CANDY",
    label: "Candy",
    airline: [
      { airline: "EK", commodityCode: "0055", product: "PXS" },
      { airline: "EK", commodityCode: "0055", product: "PXD" },
    ],
  },
  {
    value: "CANOES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9231", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CANVAS ARTICLES",
    label: "Canvas Articles",
    airline: [
      { airline: "EK", commodityCode: "2920", product: "GCR" },
      { airline: "EK", commodityCode: "2920", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2920", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CAR SEAT COVERS,RUGS-MADE OF HIDE OR SHEEPSKIN",
    label: "Car Seat Covers, Rugs made of Hide or Sheep-Skin",
    airline: [
      { airline: "EK", commodityCode: "1251", product: "GCR" },
      { airline: "EK", commodityCode: "1251", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1251", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CARACUL, ASTRAKHAN SKINS",
    label: "Caracul, Astrakhan Skins",
    airline: [
      { airline: "EK", commodityCode: "1188", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1188", product: "GCR" },
      { airline: "QR", commodityCode: "1188", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CARBON PAPERHOT STAMPING PAPER",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "7022", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CARDAMOM",
    label: "Cardamom",
    airline: [
      { airline: "EK", commodityCode: "0728", product: "PXS" },
      { airline: "EK", commodityCode: "0728", product: "PXD" },
    ],
  },
  {
    value: "CARDBOARD PACKAGING MATERIAL",
    label: "PAPER PACKAGING MATERIAL",
    airline: [
      { airline: "QR", commodityCode: "7201", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7021", product: "GCR" },
      { airline: "EK", commodityCode: "7021", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CARDS/CHECKS/TKTS/TKTROLLS/LBLS OF PAPER,METAL,PLASTIC",
    label: "Cards, Checks, Tickets, Ticket Rolls, Labels of Paper",
    airline: [
      { airline: "EK", commodityCode: "7067", product: "GCR" },
      { airline: "EK", commodityCode: "7067", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7067", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CARGO AIRCRAFT ONLY CARGO",
    label: "Aircraft",
    airline: [
      { airline: "QR", commodityCode: "9990", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
      { airline: "EK", commodityCode: "4105", product: "GCR" },
      { airline: "EK", commodityCode: "4105", product: "AOG", productSHC: "AOG" },
    ],
  },
  {
    value: "CARNATION CUTTINGS, CHRYSANTHEMUM CUTTINGS, GLADIOLI",
    label: "Carnation Cuttings, Chrysanthemum Cuttings, Gladioli Cuttings, and Other Live Plants",
    airline: [
      { airline: "EK", commodityCode: "1436", product: "PXD" },
      { airline: "EK", commodityCode: "1436", product: "PXS" },
    ],
  },
  {
    value: "CARPETS, RUGS",
    label: "Carpets, Rugs",
    airline: [
      { airline: "EK", commodityCode: "2865", product: "GCR" },
      { airline: "EK", commodityCode: "2865", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2865", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CASH REGISTERS",
    label: "Adding and Calculating Machines, Cash Registers, Machines for Duplicating",
    airline: [
      { airline: "QR", commodityCode: "4325", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4312", product: "GCR" },
      { airline: "EK", commodityCode: "4312", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CASINGS  MADE OF ANIMAL INTESTINES, GUT",
    label: "Casings made of animal intestines, gut",
    airline: [
      { airline: "EK", commodityCode: "1925", product: "GCR" },
      { airline: "EK", commodityCode: "1925", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CASSETTE TAPES",
    label: "Cassette Tapes",
    airline: [
      { airline: "EK", commodityCode: "8285", product: "GCR" },
      { airline: "EK", commodityCode: "8285", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8285", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CATTLE",
    label: "Cattle",
    airline: [
      { airline: "EK", commodityCode: "1053", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CATTLE HIDES, SHEEP SKINS, GOAT SKINS",
    label: "I need the value from the previous column to clean it.",
    airline: [
      { airline: "EK", commodityCode: "1164", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1164", product: "GCR" },
      { airline: "QR", commodityCode: "1164", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CERAMICS",
    label: "POTTERY CERAMICS",
    airline: [
      { airline: "QR", commodityCode: "5292", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5295", product: "GCR" },
      { airline: "EK", commodityCode: "5295", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CERAMICS,POTTERY,CHINA/EARTHEN/STONE/CRYSTALWARE,PORCELAIN C",
    label: "Ceramics, Pottery, China, Earthenware, Stoneware, Crystalware",
    airline: [
      { airline: "EK", commodityCode: "5296", product: "GCR" },
      { airline: "EK", commodityCode: "5296", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5296", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CERAMICS,POTTERY,CHINA/EARTHEN/STONE/GLASS/CRYSTALWARE,PORCE",
    label: "Ceramics, Pottery, China, Earthenware, Stoneware, Glassware, Crystalware, Porcelain",
    airline: [
      { airline: "EK", commodityCode: "9714", product: "GCR" },
      { airline: "EK", commodityCode: "9714", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9714", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CEREAL FOODS  READY TO EAT",
    label: "Cereal Foods Ready to Eat",
    airline: [
      { airline: "EK", commodityCode: "0552", product: "PXS" },
      { airline: "EK", commodityCode: "0552", product: "PXD" },
    ],
  },
  {
    value: "CHAIN LOCKS",
    label: "Locks",
    airline: [
      { airline: "QR", commodityCode: "4903", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3969", product: "GCR" },
      { airline: "EK", commodityCode: "3969", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CHEESE",
    label: "Cheese",
    airline: [
      { airline: "EK", commodityCode: "0220", product: "PXS" },
      { airline: "EK", commodityCode: "0220", product: "PXD" },
    ],
  },
  {
    value: "CHEM,CHEM PRODS,DRUGS,COSMETCS,PHARMA,ESSENTIAL OILS,PLASTIC",
    label: "Chemicals, Chemical Products, Drugs, Cosmetics, Pharmaceuticals, Essential Oils",
    airline: [
      { airline: "EK", commodityCode: "9709", product: "GCR" },
      { airline: "EK", commodityCode: "9709", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEM,CHEM PRODS,DRUGS,COSMETICS,PARMA,OIL EXCL PLASTIC/TOILE",
    label: "Chemicals, Chemical Products, Drugs, Cosmetics, Pharma, Oil, excluding Plastic",
    airline: [
      { airline: "EK", commodityCode: "9736", product: "GCR" },
      { airline: "EK", commodityCode: "9736", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEM/CHEM PDTS/DRUGS/COSMETCS/PHARMA/ESSENTL  OILS/PLASTIC",
    label: "Chemicals, Chemical Products, Drugs, Cosmetics, Pharmaceuticals, Essential",
    airline: [
      { airline: "EK", commodityCode: "6009", product: "GCR" },
      { airline: "EK", commodityCode: "6009", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEM/DRUGS/PHARMA/MEDICINES/SURGICAL GAUZE/BANDAGES/PAINTS/V",
    label: "Chemicals, Drugs, Pharmaceuticals, Medicines, Surgical Gauze, Bandages",
    airline: [
      { airline: "EK", commodityCode: "6008", product: "GCR" },
      { airline: "EK", commodityCode: "6008", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEM/DYES/FERT/INSECTICIDES/PAINTS/DRUGS/COSMETICS/PLASTICS",
    label: "Chemicals, Dyes, Fertilizers, Insecticides, Paints, Drugs, Cosmetics",
    airline: [
      { airline: "EK", commodityCode: "6002", product: "GCR" },
      { airline: "EK", commodityCode: "6002", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6240", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHEMICALS, PHARMACEUTICALS",
    label: "Chemicals, Pharmaceuticals",
    airline: [
      { airline: "EK", commodityCode: "6000", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "CHEWING-GUM",
    label: "Chewing Gum",
    airline: [
      { airline: "EK", commodityCode: "0070", product: "PXS" },
      { airline: "EK", commodityCode: "0070", product: "PXD" },
    ],
  },
  {
    value: "CHINA PORCELAIN",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5220", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CHMCLS,DRUGS PARMA,MEDICINE EXCL COSMETICS,TOILET PREPS/ARTI",
    label: "Chemicals, Drugs, Pharmaceuticals, Medicine excluding Cosmetics, Toiletries",
    airline: [
      { airline: "EK", commodityCode: "6003", product: "GCR" },
      { airline: "EK", commodityCode: "6003", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CHOCOLATE MANUFACTURES",
    label: "Chocolate Manufactures",
    airline: [
      { airline: "EK", commodityCode: "0056", product: "PXS" },
      { airline: "EK", commodityCode: "0056", product: "PXD" },
    ],
  },
  {
    value: "CHOCOLATES MANUFACTURES,CANDIES,WAFERS,BISCUITS",
    label: "Chocolates Manufactures, Candies, Wafers, Biscuits",
    airline: [
      { airline: "EK", commodityCode: "0059", product: "PXS" },
      { airline: "EK", commodityCode: "0059", product: "PXD" },
    ],
  },
  {
    value: "CHRISTMAS TREE ORNAMENTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9532", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CIGARETTE PAPERS, FILTERS, TIPS, PACKAGING MATERIAL",
    label: "Cigarette Papers, Filters, Tips, Packaging Material",
    airline: [
      { airline: "EK", commodityCode: "7025", product: "GCR" },
      { airline: "EK", commodityCode: "7025", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7025", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CLAMS,OYSTERS,SCALLOPS",
    label: "Clams, Oysters, Scallops",
    airline: [
      { airline: "EK", commodityCode: "0310", product: "PXS" },
      { airline: "EK", commodityCode: "0310", product: "PXD" },
    ],
  },
  {
    value: "CLAY PRODUCTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CLEANSING, POLISHING PRODUCTS",
    label: "Cleansing, Polishing Products",
    airline: [
      { airline: "EK", commodityCode: "6902", product: "GCR" },
      { airline: "EK", commodityCode: "6902", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6902", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CLOCKS",
    label: "Watches, Clocks",
    airline: [
      { airline: "QR", commodityCode: "8920", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8911", product: "GCR" },
      { airline: "EK", commodityCode: "8911", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CLOTH EXCLSVLY IN BALESBOLTS OR PIECES NOT FRTH PRCSSD",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2103", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CLOTH NOT FURTHER PROCESSSED OR MANUFACTURED/EXCLUS. BALES/B",
    label: "Cloth not further processed or manufactured, exclusively Bales",
    airline: [
      { airline: "EK", commodityCode: "2102", product: "GCR" },
      { airline: "EK", commodityCode: "2102", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2102", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CLOTH,LADIES CUT DRESSES,SEMI-FINISHED CLOTHIN INCL DRESSMAK",
    label: "Cloth, Ladies Cut Dresses, Semi-Finished Clothing Including Dressmaking",
    airline: [
      { airline: "EK", commodityCode: "2215", product: "GCR" },
      { airline: "EK", commodityCode: "2215", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2215", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CLOTHING AND WEARING APPAREL",
    label: "Garments, Wearing Apparel",
    airline: [
      { airline: "QR", commodityCode: "2201", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "COBALT",
    label: "Cobalt",
    airline: [
      { airline: "EK", commodityCode: "3890", product: "GCR" },
      { airline: "EK", commodityCode: "3890", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3890", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COFFEE",
    label: "Coffee",
    airline: [
      { airline: "EK", commodityCode: "0180", product: "PXS" },
      { airline: "EK", commodityCode: "0180", product: "GCR" },
      { airline: "EK", commodityCode: "0180", product: "PXD" },
    ],
  },
  {
    value: "COFFEE ROASTED,GROUND",
    label: "Coffee Roasted, Ground",
    airline: [
      { airline: "EK", commodityCode: "0183", product: "PXS" },
      { airline: "EK", commodityCode: "0183", product: "PXD" },
    ],
  },
  {
    value: "COMMODESSINKSTILES MADE OF POTTERY PORCELAIN",
    label: "Sanitary Articles Made of Pottery, Porcelain",
    airline: [
      { airline: "QR", commodityCode: "5251", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5235", product: "GCR" },
      { airline: "EK", commodityCode: "5235", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "COMMUNICATION DEVICES, SIGNAL DEVICES",
    label: "Communication Devices, Signal Devices",
    airline: [
      { airline: "EK", commodityCode: "4410", product: "GCR" },
      { airline: "EK", commodityCode: "4410", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4410", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COMPUTER PUNCH CARDS, COMPUTER DATA SHEETS",
    label: "Computer Punch Cards, Computer Data Sheets",
    airline: [
      { airline: "EK", commodityCode: "4313", product: "GCR" },
      { airline: "EK", commodityCode: "4313", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4313", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CONDENSERS",
    label: "Condensers",
    airline: [
      { airline: "EK", commodityCode: "4423", product: "GCR" },
      { airline: "EK", commodityCode: "4423", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4423", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CONFECTIONARY,DESSERTS",
    label: "Advertising Articles, Display Equipment - Not for Sale",
    airline: [
      { airline: "EK", commodityCode: "0060", product: "PXS" },
      { airline: "EK", commodityCode: "0060", product: "PXD" },
    ],
  },
  {
    value: "CONSTRUCTION EQPT, BUILDING MATERIAL",
    label: "Construction Equipment, Building Material",
    airline: [
      { airline: "EK", commodityCode: "9743", product: "GCR" },
      { airline: "EK", commodityCode: "9743", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9743", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CONSTRUCTION PARTS FOR CABLE CARS PYLONS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4215", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "CONTACT LENSES",
    label: "Contact Lenses",
    airline: [
      { airline: "EK", commodityCode: "8303", product: "GCR" },
      { airline: "EK", commodityCode: "8303", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COOKING FAT",
    label: "Cooking Fat",
    airline: [
      { airline: "EK", commodityCode: "0901", product: "PXS" },
      { airline: "EK", commodityCode: "0901", product: "PXD" },
    ],
  },
  {
    value: "COOLING UNITS REFRIGERATION UNITS INDUSTRIAL",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4473", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "COPPER IN SLABS, SEMI-FINISHD PRODS,PLATES,SHEETS,WIRE,ROD,",
    label: "Copper in Slabs, Semi-Finished Products, Plates, Sheets, Wire",
    airline: [
      { airline: "EK", commodityCode: "3032", product: "GCR" },
      { airline: "EK", commodityCode: "3032", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3032", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COPPER MANUFACTURS",
    label: "Copper Manufactures",
    airline: [
      { airline: "EK", commodityCode: "3030", product: "GCR" },
      { airline: "EK", commodityCode: "3030", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3030", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COPPER ORE",
    label: "Copper Ore",
    airline: [
      { airline: "EK", commodityCode: "3034", product: "GCR" },
      { airline: "EK", commodityCode: "3034", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3034", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COPPER WIRE RELAYS CIRCUIT BOARDS COILS",
    label: "Relays",
    airline: [
      { airline: "QR", commodityCode: "4521", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4428", product: "GCR" },
      { airline: "EK", commodityCode: "4428", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "COPPER WIRE, COPPER CABLE",
    label: "Copper Wire, Copper Cable",
    airline: [
      { airline: "EK", commodityCode: "3038", product: "GCR" },
      { airline: "EK", commodityCode: "3038", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3038", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CORSETS, GIRDLES, BRASSIERES",
    label: "Corsets, Girdles, Brassieres",
    airline: [
      { airline: "EK", commodityCode: "2306", product: "GCR" },
      { airline: "EK", commodityCode: "2306", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2306", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COSMETICS,SOAPS,TOILET PREPARATIONS",
    label: "Cosmetics, Soaps, Toilet Preparations",
    airline: [
      { airline: "EK", commodityCode: "6600", product: "GCR" },
      { airline: "EK", commodityCode: "6600", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COSMETICS,TOILET PREPARATIONS/ARTICLES, PERFUMES",
    label: "Cosmetics, Toilet Preparations/Articles, Perfumes",
    airline: [
      { airline: "EK", commodityCode: "6601", product: "GCR" },
      { airline: "EK", commodityCode: "6601", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "COTTON, YARN, THREAD",
    label: "Cotton, Yarn, Thread",
    airline: [
      { airline: "EK", commodityCode: "2020", product: "GCR" },
      { airline: "EK", commodityCode: "2020", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2020", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CRABS",
    label: "Crabs",
    airline: [
      { airline: "EK", commodityCode: "0316", product: "PXS" },
      { airline: "EK", commodityCode: "0316", product: "PXD" },
    ],
  },
  {
    value: "CREMATED HUMAN REMAINS, ASHES",
    label: "Cremated Human Remains, Ashes",
    airline: [
      { airline: "EK", commodityCode: "9095", product: "GCR" },
    ],
  },
  {
    value: "CROCODILE SKINS  WET/SALTED",
    label: "Crocodile Skins, Wet/Salted",
    airline: [
      { airline: "EK", commodityCode: "1194", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1194", product: "GCR" },
      { airline: "QR", commodityCode: "1194", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CURIOS CARVED/WOODEN ,BONE ARTICLES,HORN ARTICLES",
    label: "Curios Carved from Wooden, Bone Articles, or Horn Articles",
    airline: [
      { airline: "EK", commodityCode: "9506", product: "GCR" },
      { airline: "EK", commodityCode: "9506", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9506", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CURIOS CARVED/WOODEN ,BONE/HORN ARTCLS EXCL IVORY ARTCLS",
    label: "Curios, carved or wooden, bone or horn articles, excluding ivory articles.",
    airline: [
      { airline: "EK", commodityCode: "9511", product: "GCR" },
      { airline: "EK", commodityCode: "9511", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9511", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CUT FLOWERS, FOLIAGE, CUTTINGS",
    label: "Cut Flowers, Foliage, Cuttings",
    airline: [
      { airline: "EK", commodityCode: "1403", product: "PXS" },
      { airline: "EK", commodityCode: "1403", product: "PXD" },
    ],
  },
  {
    value: "CUTLER, FORKS, SPOONS EXCLDG SILVERWARE",
    label: "Cutlery, Forks, Spoons Excluding Silver",
    airline: [
      { airline: "EK", commodityCode: "3101", product: "GCR" },
      { airline: "EK", commodityCode: "3101", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3101", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CUTLERY",
    label: "Cutlery",
    airline: [
      { airline: "EK", commodityCode: "3100", product: "GCR" },
      { airline: "EK", commodityCode: "3100", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3100", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "CUTTING TOOLS DRILLS",
    label: "Tools",
    airline: [
      { airline: "QR", commodityCode: "4818", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DAIRY MACHINERY",
    label: "Machinery and Tools",
    airline: [
      { airline: "QR", commodityCode: "4707", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4703", product: "GCR" },
      { airline: "EK", commodityCode: "4703", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DAIRY PRODUCTS EXCL EGGS",
    label: "Dairy Products Excluding Eggs",
    airline: [
      { airline: "EK", commodityCode: "0201", product: "PXS" },
      { airline: "EK", commodityCode: "0201", product: "PXD" },
    ],
  },
  {
    value: "DAIRY PRODUCTS,EGGS",
    label: "Dairy Products, Eggs",
    airline: [
      { airline: "EK", commodityCode: "0200", product: "PXS" },
      { airline: "EK", commodityCode: "0200", product: "PXD" },
    ],
  },
  {
    value: "DAMASCENED ARTICLES REPRODUCTIONS OF OLD STEEL SWORDS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9514", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DANGEROUS GOODS",
    label: "Dangerous Goods",
    airline: [
      { airline: "EK", commodityCode: "E0063", product: "GCR" },
      { airline: "EK", commodityCode: "E0063", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9992", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DATA PROCESSG EQPT,OFC MACHNRY INCL ACCESSORIES,SUPPLIES",
    label: "Data Processing Equipment, Office Machinery, including Accessories, Supplies",
    airline: [
      { airline: "EK", commodityCode: "9705", product: "GCR" },
      { airline: "EK", commodityCode: "9705", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DATA PROCESSG EQPT,OFC MACHNRY-INCL ACCESSORIES,SUPPLIES-ELE",
    label: "Data Processing Equipment, Office Machinery - Including Accessories and Supplies",
    airline: [
      { airline: "EK", commodityCode: "9726", product: "GCR" },
      { airline: "EK", commodityCode: "9726", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9726", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DATA PROCSSG EQPT,OFC MACHNRY,INCL ACCESSORIES,SUPPLIES",
    label: "Data Processing Equipment, Office Machinery, Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "4302", product: "GCR" },
      { airline: "EK", commodityCode: "4302", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DATES",
    label: "Dates",
    airline: [
      { airline: "EK", commodityCode: "0461", product: "PXS" },
      { airline: "EK", commodityCode: "0461", product: "PXD" },
    ],
  },
  {
    value: "DATURA EXTRACT",
    label: "Datura Extract",
    airline: [
      { airline: "EK", commodityCode: "6211", product: "GCR" },
      { airline: "EK", commodityCode: "6211", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DEER",
    label: "Deer",
    airline: [
      { airline: "EK", commodityCode: "1022", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DENTAL/SURGCL/MEDICL INSTRMTS INCL APPARATUS,SUPPLIES",
    label: "Dental/Surgical/Medical Instruments, Including Apparatus",
    airline: [
      { airline: "EK", commodityCode: "8105", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DENTAL/SURGICAL/MEDICAL EQPT",
    label: "Dental/Surgical/Medical Equipment",
    airline: [
      { airline: "EK", commodityCode: "8100", product: "GCR" },
      { airline: "EK", commodityCode: "8100", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DETERGENTS,SOAPS,SOAP FLAKES/POWDER OTHER CLEANING MTRLS",
    label: "Detergents, soaps, soap flakes or powder, and other cleaning supplies",
    airline: [
      { airline: "EK", commodityCode: "6900", product: "GCR" },
      { airline: "EK", commodityCode: "6900", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6900", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DEVELOPED FILMS PAPER PRINTS",
    label: "Films",
    airline: [
      { airline: "QR", commodityCode: "8438", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8420", product: "GCR" },
      { airline: "EK", commodityCode: "8420", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DGR CARGO",
    label: "Dangerous Goods",
    airline: [
      { airline: "QR", commodityCode: "9992", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0063", product: "GCR" },
      { airline: "EK", commodityCode: "E0063", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DIESEL ENGINES, PUMPSETS",
    label: "Diesel Engines, Pumpsets",
    airline: [
      { airline: "EK", commodityCode: "4616", product: "GCR" },
      { airline: "EK", commodityCode: "4616", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4732", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DIGTL/ANALOG COMPUTRS INCL PUNCH CARDS,DISC PACKS,TAPES-ELEC",
    label: "Digital/Analog Computers Including Punch Cards, Disc Packs, Tapes, Electronic",
    airline: [
      { airline: "EK", commodityCode: "4326", product: "GCR" },
      { airline: "EK", commodityCode: "4326", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4317", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DIPLOMATIC CARGO, DIPLOMATIC MAIL",
    label: "Diplomatic Cargo, Diplomatic Mail",
    airline: [
      { airline: "EK", commodityCode: "9945", product: "GCR" },
      { airline: "EK", commodityCode: "9945", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9945", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
    ],
  },
  {
    value: "DISPLAY MATERIAL",
    label: "PENS PENCILS INCL DISPLAY MATERIAL",
    airline: [
      { airline: "QR", commodityCode: "9472", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9473", product: "GCR" },
      { airline: "EK", commodityCode: "9473", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DOOR LOCKS, HANDLES",
    label: "Door Locks, Handles",
    airline: [
      { airline: "EK", commodityCode: "3501", product: "GCR" },
      { airline: "EK", commodityCode: "3501", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3501", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRAIN TUBES, PLASTIC ARTICLES, RUBBER ARTICLES - FOR HOSPITAL USE -",
    label: "Drain Tubes, Plastic Articles, Rubber Articles - For Hospital Use",
    airline: [
      { airline: "EK", commodityCode: "8167", product: "GCR" },
      { airline: "EK", commodityCode: "8167", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRAWINGDRAFTING INSTRUMENTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8820", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DRAWNWORK, NEEDLEWORK, EMBROIDERIES, LACE",
    label: "Drawnwork, Needlework, Embroideries",
    airline: [
      { airline: "EK", commodityCode: "2500", product: "GCR" },
      { airline: "EK", commodityCode: "2500", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRESSES  LADIES, FINISHED",
    label: "Ladies' Finished Dresses",
    airline: [
      { airline: "EK", commodityCode: "2218", product: "GCR" },
      { airline: "EK", commodityCode: "2218", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2218", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRESSES SKIRTS BLOUSES",
    label: "Blouses, Jackets, Jeans, Skirts, Trousers, Waistcoats",
    airline: [
      { airline: "QR", commodityCode: "2310", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2292", product: "GCR" },
      { airline: "EK", commodityCode: "2292", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DRESSMAKES SUPPLIES EXCL TEXTILESCLOTHINGS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3973", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DRILL BITS",
    label: "Drill Bits",
    airline: [
      { airline: "EK", commodityCode: "3236", product: "GCR" },
      { airline: "EK", commodityCode: "3236", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3236", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRILLING MACHINES ELECTRIC",
    label: "WIRESCABLES ELECTRIC",
    airline: [
      { airline: "QR", commodityCode: "4502", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4477", product: "GCR" },
      { airline: "EK", commodityCode: "4477", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DRUGGISTS SUNDRIES OF RUBBER",
    label: "Rubber Goods",
    airline: [
      { airline: "QR", commodityCode: "7430", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DRUGS,MEDICINE,PHARMA.,INSECTICIDE,AIR FRESHNER AEROSOL CAN",
    label: "Drugs, Medicine, Pharmaceuticals, Insecticide, Air Freshener Aerosol",
    airline: [
      { airline: "EK", commodityCode: "6495", product: "GCR" },
      { airline: "EK", commodityCode: "6495", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRY COCHINEALS",
    label: "Dry Cochineals",
    airline: [
      { airline: "EK", commodityCode: "6212", product: "GCR" },
      { airline: "EK", commodityCode: "6212", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DRY ICE",
    label: "Dry Ice",
    airline: [
      { airline: "EK", commodityCode: "6223", product: "GCR" },
      { airline: "EK", commodityCode: "6223", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DUPLICATING MACHINES",
    label: "Adding, Computing, Typewriting Machines, Document, Letter Duplicating Machines",
    airline: [
      { airline: "QR", commodityCode: "4307", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4311", product: "GCR" },
      { airline: "EK", commodityCode: "4311", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "DYES/CHEM/FERT/INSECTICIDES/PAINTS/OILS/PLASTICS",
    label: "Dyes, Chemicals, Fertilizers, Insecticides, Paints, Oils",
    airline: [
      { airline: "EK", commodityCode: "6005", product: "GCR" },
      { airline: "EK", commodityCode: "6005", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DYES/FERT/INSECTICIDES/PAINTS/PIGMTS/COSMETICS/PLASTICS/OILS",
    label: "Dyes, Fertilizers, Insecticides, Paints, Pigments, Cosmetics",
    airline: [
      { airline: "EK", commodityCode: "6004", product: "GCR" },
      { airline: "EK", commodityCode: "6004", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6240", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "DYESTUFFS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "6206", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "EARTH DRILLING EQUIPMENT",
    label: "Drilling Equipment",
    airline: [
      { airline: "QR", commodityCode: "4749", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4748", product: "GCR" },
      { airline: "EK", commodityCode: "4748", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "EEL",
    label: "Eel",
    airline: [
      { airline: "EK", commodityCode: "0320", product: "PXS" },
      { airline: "EK", commodityCode: "0320", product: "PXD" },
    ],
  },
  {
    value: "EGGS",
    label: "Eggs",
    airline: [
      { airline: "EK", commodityCode: "0230", product: "PXS" },
      { airline: "EK", commodityCode: "0230", product: "PXD" },
    ],
  },
  {
    value: "ELASTIC CORD WITH METAL ENDS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9964", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELASTIC MANUFACTURES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2244", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELCTRNC CMPONNTS FABRICATD FR ELEC COMPTRS,AUXILIARY MACHNS",
    label: "Electronic Components Fabricated From Electronic Computers, Auxiliary",
    airline: [
      { airline: "EK", commodityCode: "4314", product: "GCR" },
      { airline: "EK", commodityCode: "4314", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELE APPL./MACHINERY,MACHNRY TOOLS EXCL STEAM/MOTOR SHIP MACH",
    label: "Electrical Appliances/Machinery, Machinery Tools excluding Steam/Motor Ship Machinery",
    airline: [
      { airline: "EK", commodityCode: "4499", product: "GCR" },
      { airline: "EK", commodityCode: "4499", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4499", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC CONTROL PANELS FOR RADAR STATION,POWERPLANT,HEATG/COOLG",
    label: "Electrical Control Panels for Radar Station, Power Plant, Heating",
    airline: [
      { airline: "EK", commodityCode: "4403", product: "GCR" },
      { airline: "EK", commodityCode: "4403", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4498", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC DATA PROCSSG MACHNS,DIGTL/ANALOGUE COMPTRS-INDIVIDL UNI",
    label: "Electrical Data Processing Machines, Digital/Analogue Computers",
    airline: [
      { airline: "EK", commodityCode: "4319", product: "GCR" },
      { airline: "EK", commodityCode: "4319", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC EQPT FR TELETYP,TELEGRAPH,TEL,RADIO-TEL,TV/RADIO BROADC",
    label: "Electrical Equipment for Teletype, Telegraph, Telephone, Radio-Telephone, Television",
    airline: [
      { airline: "EK", commodityCode: "4492", product: "GCR" },
      { airline: "EK", commodityCode: "4492", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4492", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC EQPT, ELEC APPLIANCES EXCL COMPUTERS,OFFICE MACHINERY",
    label: "Electrical Equipment, Electrical Appliances, Excluding Computers, Office",
    airline: [
      { airline: "EK", commodityCode: "4412", product: "GCR" },
      { airline: "EK", commodityCode: "4412", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC EQPT/APPL.,TAPES,CASSETTES,PHONOGRAPH RECORDS,WIRE",
    label: "Electrical Equipment/Appliances, Tapes, Cassettes, Phonograph Records, Wire",
    airline: [
      { airline: "EK", commodityCode: "9706", product: "GCR" },
      { airline: "EK", commodityCode: "9706", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9706", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC TUBES,TRANSISTORS,SOLID STATE SEMI-CONDUCTOR DEVICES",
    label: "Electronic Tubes, Transistors, Solid State Semiconductor",
    airline: [
      { airline: "EK", commodityCode: "4435", product: "GCR" },
      { airline: "EK", commodityCode: "4435", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4435", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELEC TUBES,TRANSISTORS,SOLID STATE SEMI-CONDUCTOR DEVICES,RA",
    label: "Electrical Tubes, Transistors, Solid State Semiconductor Devices",
    airline: [
      { airline: "EK", commodityCode: "4427", product: "GCR" },
      { airline: "EK", commodityCode: "4427", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4427", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC APPLIANCES, GAS APPLIANCES",
    label: "Electric Appliances, Gas Appliances",
    airline: [
      { airline: "EK", commodityCode: "4397", product: "GCR" },
      { airline: "EK", commodityCode: "4397", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4397", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC CONDENSERS,RESISTORS,RHEOSTATS",
    label: "Electric Condensers, Resistors, Rheostats",
    airline: [
      { airline: "EK", commodityCode: "4430", product: "GCR" },
      { airline: "EK", commodityCode: "4430", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4430", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC DOOR CONTROL DEVICES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4581", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC EQPT./APPL. EXCL. BUSINESS/OFFICE MACHINERY",
    label: "Electric Equipment and Appliances excluding Business and Office Machinery",
    airline: [
      { airline: "EK", commodityCode: "4402", product: "GCR" },
      { airline: "EK", commodityCode: "4402", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC EQUIPMENT  EXCLUDING MACHINERY",
    label: "Electric Equipment Excluding Machinery",
    airline: [
      { airline: "EK", commodityCode: "4400", product: "GCR" },
      { airline: "EK", commodityCode: "4400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC HAND TOOLS",
    label: "Tools",
    airline: [
      { airline: "QR", commodityCode: "4826", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC HEATING ELEMENTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4453", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC INSULATORS ELECTRIC FITTINGS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4437", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC LAMPS, LAMP SHADES, CHNDELIERS",
    label: "Electric Lamps, Lamp Shades, Chandeliers",
    airline: [
      { airline: "EK", commodityCode: "4476", product: "GCR" },
      { airline: "EK", commodityCode: "4476", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4476", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC LIGHT BULBS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4512", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC MACHINERY",
    label: "Electric Equipment Excluding Machinery",
    airline: [
      { airline: "QR", commodityCode: "4500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4400", product: "GCR" },
      { airline: "EK", commodityCode: "4400", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC MEDICAL EQUIPMENT",
    label: "Electric Medical Equipment",
    airline: [
      { airline: "EK", commodityCode: "8603", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRIC PUMPS FOR WASHING MACHINES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4454", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ELECTRIC RAZORS, MECHANICAL RAZORS",
    label: "Electric Razors, Mechanical Razors",
    airline: [
      { airline: "EK", commodityCode: "4461", product: "GCR" },
      { airline: "EK", commodityCode: "4461", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4461", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRICAL APPLIANCES",
    label: "Electrical Appliances",
    airline: [
      { airline: "EK", commodityCode: "4404", product: "GCR" },
      { airline: "EK", commodityCode: "4404", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4397", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRNC DATA STORAGE PROCSG MACHINES,DIGITAL COMPUTRS,ANALO",
    label: "Electronic Data Storage Processing Machines, Digital Computers, Analog",
    airline: [
      { airline: "EK", commodityCode: "4303", product: "GCR" },
      { airline: "EK", commodityCode: "4303", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRO EROSION MACHINERY",
    label: "Electro Erosion Machinery",
    airline: [
      { airline: "EK", commodityCode: "4452", product: "GCR" },
      { airline: "EK", commodityCode: "4452", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4452", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRO MEDICAL APPARATUS/OPER.TABLES/DIATHERMIC MACHNS/DENT",
    label: "Electro-Medical Apparatus, Operating Tables, Diathermic Machines",
    airline: [
      { airline: "EK", commodityCode: "8553", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRODES",
    label: "Electrodes",
    airline: [
      { airline: "EK", commodityCode: "4409", product: "GCR" },
      { airline: "EK", commodityCode: "4409", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4409", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRON GUN WHICH IS COMPONENT OF TV RCVG TUBE MOUNT",
    label: "Electron Gun Which is Component of TV Receiving Tube Mount",
    airline: [
      { airline: "EK", commodityCode: "4447", product: "GCR" },
      { airline: "EK", commodityCode: "4447", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4447", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRONIC PARTS",
    label: "Electronic Parts",
    airline: [
      { airline: "EK", commodityCode: "4459", product: "GCR" },
      { airline: "EK", commodityCode: "4459", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4459", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRONIC PRODUCTS",
    label: "Electronic Products",
    airline: [
      { airline: "EK", commodityCode: "4329", product: "GCR" },
      { airline: "EK", commodityCode: "4329", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4459", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTRONIC PRODUCTS  INCL COMPONENTS",
    label: "Electronic Products Including Components",
    airline: [
      { airline: "EK", commodityCode: "4323", product: "GCR" },
      { airline: "EK", commodityCode: "4323", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4459", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ELECTROPLATED NICKEL SILVERWARE,TABLEWARE,TROPHIES,CUPS,MEDA",
    label: "Electroplated Nickel Silverware, Tableware, Trophies, Cups",
    airline: [
      { airline: "EK", commodityCode: "3153", product: "GCR" },
      { airline: "EK", commodityCode: "3153", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3153", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY AMMONIA CYLINDERS",
    label: "Empty Ammonia Cylinders",
    airline: [
      { airline: "EK", commodityCode: "9052", product: "GCR" },
      { airline: "EK", commodityCode: "9052", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9052", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY BEER KEGS",
    label: "Empty Beer Kegs",
    airline: [
      { airline: "EK", commodityCode: "9051", product: "GCR" },
      { airline: "EK", commodityCode: "9051", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9051", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY BOXES OF CARDBOARD,NON-PRECIOUS METAL/FOR JEWELRY,WATC",
    label: "Empty Boxes of Cardboard, Non-Precious Metal/for Jewelry",
    airline: [
      { airline: "EK", commodityCode: "9072", product: "GCR" },
      { airline: "EK", commodityCode: "9072", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9072", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY CASES FR CLOCKSSCIPRECISION INSTRMTSMADE OF LEATHER",
    label: "Leather, leather products",
    airline: [
      { airline: "QR", commodityCode: "9064", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1201", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1201", product: "GCR" },
    ],
  },
  {
    value: "EMPTY CONTAINERS",
    label: "Empty Containers",
    airline: [
      { airline: "EK", commodityCode: "9050", product: "GCR" },
      { airline: "EK", commodityCode: "9050", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9050", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY GELATINE CAPSULES FOR MEDICINES",
    label: "Empty Gelatine Capsules for Medicines",
    airline: [
      { airline: "EK", commodityCode: "6505", product: "GCR" },
      { airline: "EK", commodityCode: "6505", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY METAL CANS",
    label: "Empty Metal Cans",
    airline: [
      { airline: "EK", commodityCode: "9078", product: "GCR" },
      { airline: "EK", commodityCode: "9078", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9078", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EMPTY WATCH CASES METAL",
    label: "Empty Metal Cans",
    airline: [
      { airline: "QR", commodityCode: "9085", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9078", product: "GCR" },
      { airline: "EK", commodityCode: "9078", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ENDIVES, CELERY",
    label: "Endives, Celery",
    airline: [
      { airline: "EK", commodityCode: "0838", product: "PXS" },
      { airline: "EK", commodityCode: "0838", product: "PXD" },
    ],
  },
  {
    value: "ENGINES,TURBINES",
    label: "Engines, Turbines",
    airline: [
      { airline: "EK", commodityCode: "4600", product: "GCR" },
      { airline: "EK", commodityCode: "4600", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ENTERTAINMENT PARTS",
    label: "Entertainment Parts",
    airline: [
      { airline: "EK", commodityCode: "8424", product: "GCR" },
      { airline: "EK", commodityCode: "8424", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8424", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "Equine Equipment",
    label: "Equine Equipment",
    airline: [
      { airline: "EK", commodityCode: "1051", product: "GCR" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ESSENTAIL OILS,PERFUMES,TOILET PREPARATION,SOAP,TOILET WATER",
    label: "Essential Oils, Perfumes, Toilet Preparations, Soap, Toiletries",
    airline: [
      { airline: "EK", commodityCode: "6050", product: "GCR" },
      { airline: "EK", commodityCode: "6050", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ESSENTIAL OILS",
    label: "Essential Oils",
    airline: [
      { airline: "EK", commodityCode: "1716", product: "GCR" },
      { airline: "EK", commodityCode: "1716", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5620", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ETHABUTOL POWDER",
    label: "Ethambutol Powder",
    airline: [
      { airline: "EK", commodityCode: "6234", product: "GCR" },
      { airline: "EK", commodityCode: "6234", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EXPEDITION MATERIAL",
    label: "Expedition Material",
    airline: [
      { airline: "EK", commodityCode: "9974", product: "GCR" },
      { airline: "EK", commodityCode: "9974", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9974", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EXTRACTS, FLAVOURING COMPOUND",
    label: "Extracts, flavoring compound",
    airline: [
      { airline: "EK", commodityCode: "0194", product: "PXS" },
      { airline: "EK", commodityCode: "0194", product: "PXD" },
      { airline: "QR", commodityCode: "194", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EXTRUSION DIES FOR WORKING ALUMINIUM",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4735", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "EXTRUSIONS,HONEYCOMB SHEETS,SHEETS,FOIL,PLATES,TUBES,RODS,",
    label: "Extrusions, Honeycomb Sheets, Sheets, Foil, Plates, etc.",
    airline: [
      { airline: "EK", commodityCode: "3075", product: "GCR" },
      { airline: "EK", commodityCode: "3075", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3075", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "EYELETS,PRESS FASTENERS,RIVETS, ELECTRIC ATTACHING MACHINE",
    label: "Eyelets, press fasteners, rivets, electric attaching machine",
    airline: [
      { airline: "EK", commodityCode: "2205", product: "GCR" },
      { airline: "EK", commodityCode: "2205", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2205", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FANBELTS",
    label: "Fan Belts",
    airline: [
      { airline: "EK", commodityCode: "4248", product: "GCR" },
      { airline: "EK", commodityCode: "4248", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4248", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FANS, HEATERS - ELECTRIC",
    label: "Fans, Heaters - Electric",
    airline: [
      { airline: "EK", commodityCode: "4474", product: "GCR" },
      { airline: "EK", commodityCode: "4474", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4474", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FASTENERS,ZIPPERS,BUCKLES,HANDLES,HANDBAG FRAMES",
    label: "Fasteners, Zippers, Buckles, Handles, Handbags",
    airline: [
      { airline: "EK", commodityCode: "9529", product: "GCR" },
      { airline: "EK", commodityCode: "9529", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9529", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FEATHERS  OSTRICH",
    label: "Feathers, Ostrich",
    airline: [
      { airline: "EK", commodityCode: "1951", product: "GCR" },
      { airline: "EK", commodityCode: "1951", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1951", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FEATHERS, FEATHER TRIMMINGS",
    label: "Feathers, Feather Trimmings",
    airline: [
      { airline: "EK", commodityCode: "1950", product: "GCR" },
      { airline: "EK", commodityCode: "1950", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1950", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FEEDERS,WATERERS,EGG TRAYS,EGG GRADERS,CHICKEN CRATES,PARTS",
    label: "Feeders, Waterers, Egg Trays, Egg Graders, Chicken Crates, Parts",
    airline: [
      { airline: "EK", commodityCode: "9660", product: "GCR" },
      { airline: "EK", commodityCode: "9660", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9660", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FELT BASE FLOOR COVERING",
    label: "Carpets, Rugs",
    airline: [
      { airline: "QR", commodityCode: "2870", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2865", product: "GCR" },
      { airline: "EK", commodityCode: "2865", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FELT CLOTH",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2186", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FELT PAPER MAKERS",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "2185", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FERN",
    label: "Fern",
    airline: [
      { airline: "EK", commodityCode: "1471", product: "PXD" },
      { airline: "EK", commodityCode: "1471", product: "PXS" },
    ],
  },
  {
    value: "FIBREGLASS, FIBREGLASS REINFORCING MATERIAL",
    label: "Fiberglass, Fiberglass Reinforcing Material",
    airline: [
      { airline: "EK", commodityCode: "6801", product: "GCR" },
      { airline: "EK", commodityCode: "6801", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6801", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FILMS",
    label: "Films",
    airline: [
      { airline: "EK", commodityCode: "8420", product: "GCR" },
      { airline: "EK", commodityCode: "8420", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8420", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FILMS  UNEXPOSED , SENSITIVE PAPER",
    label: "Films, Unexposed, Sensitive Paper",
    airline: [
      { airline: "EK", commodityCode: "8423", product: "GCR" },
      { airline: "EK", commodityCode: "8423", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8423", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FILTERS FOR AGRICULTURAL MACHINES",
    label: "Filters for Agricultural Machines",
    airline: [
      { airline: "EK", commodityCode: "4291", product: "GCR" },
      { airline: "EK", commodityCode: "4291", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4291", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FIRE EXTINGUISHERS EMPTY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9592", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FIREPLACES  MARBLE",
    label: "Fireplaces, Marble",
    airline: [
      { airline: "EK", commodityCode: "5406", product: "GCR" },
      { airline: "EK", commodityCode: "5406", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5406", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FISH  EDIBLE ,SEAFOOD  EXCL CAVIAR",
    label: "Fish, Edible, Seafood, excluding...",
    airline: [
      { airline: "EK", commodityCode: "0301", product: "PXS" },
      { airline: "EK", commodityCode: "0301", product: "PXD" },
    ],
  },
  {
    value: "FISH (EDIBLE), SEAFOOD",
    label: "Fish (Edible), Seafood",
    airline: [
      { airline: "EK", commodityCode: "0300", product: "PXS" },
      { airline: "EK", commodityCode: "0300", product: "PXD" },
    ],
  },
  {
    value: "FISH EDIBLE",
    label: "Fish Edible",
    airline: [
      { airline: "EK", commodityCode: "0326", product: "PXS" },
      { airline: "EK", commodityCode: "0326", product: "PXD" },
    ],
  },
  {
    value: "FISH EDIBLE/EXCL.LOBSTERS,SCALLOPS",
    label: "Fish, edible, excluding lobsters",
    airline: [
      { airline: "EK", commodityCode: "0324", product: "PXS" },
      { airline: "EK", commodityCode: "0324", product: "PXD" },
    ],
  },
  {
    value: "FISH GUT  DRIED",
    label: "Fish Gut Dried",
    airline: [
      { airline: "EK", commodityCode: "0334", product: "PXS" },
      { airline: "EK", commodityCode: "0334", product: "PXD" },
    ],
  },
  {
    value: "FISH PROCESSED",
    label: "Fish Processed",
    airline: [
      { airline: "EK", commodityCode: "0307", product: "PXS" },
      { airline: "EK", commodityCode: "0307", product: "PXD" },
    ],
  },
  {
    value: "FISH ROE",
    label: "Fish Roe",
    airline: [
      { airline: "EK", commodityCode: "0330", product: "PXS" },
      { airline: "EK", commodityCode: "0330", product: "PXD" },
    ],
  },
  {
    value: "FISH SMOKED",
    label: "Fish Spices",
    airline: [
      { airline: "EK", commodityCode: "0308", product: "PXS" },
      { airline: "EK", commodityCode: "0308", product: "GCR" },
      { airline: "EK", commodityCode: "0308", product: "PXD" },
    ],
  },
  {
    value: "FISH,CRABS,SHRIMPS-EDIBLE",
    label: "Fish, Crabs, Shrimps - Edible",
    airline: [
      { airline: "EK", commodityCode: "0356", product: "PXS" },
      { airline: "EK", commodityCode: "0356", product: "PXD" },
    ],
  },
  {
    value: "FISHING EQPT NAMELY:LINESHOOKSLURESREELS AND RODS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9244", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FISHING EQUIPMENT  INCLUDING ACCESSORIES",
    label: "Fishing Equipment, including Accessories",
    airline: [
      { airline: "EK", commodityCode: "9241", product: "GCR" },
      { airline: "EK", commodityCode: "9241", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9241", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FLORAL,NURSERY STOCK,BULBS,SEEDS,PLANTS,FLOWERS",
    label: "Floral, Nursery Stock, Bulbs, Seeds, Plants",
    airline: [
      { airline: "EK", commodityCode: "9702", product: "PXD" },
      { airline: "EK", commodityCode: "9702", product: "PXS" },
    ],
  },
  {
    value: "FLORAL/NURSERY STOCK EXCL CUT FLOWERS ,BULBS,SEEDS,TUBERS",
    label: "Floral/Nursery Stock Excluding Cut Flowers, Bulbs, Seeds",
    airline: [
      { airline: "EK", commodityCode: "1402", product: "PXS" },
      { airline: "EK", commodityCode: "1402", product: "PXD" },
    ],
  },
  {
    value: "FLORAL/NURSERY STOCK,BULBS,FLOWERS,SEEDS,TUBERS",
    label: "Floral/Nursery Stock, Bulbs, Flowers, Seeds",
    airline: [
      { airline: "EK", commodityCode: "1400", product: "PXS" },
      { airline: "EK", commodityCode: "1400", product: "PXD" },
    ],
  },
  {
    value: "FLORAL/NURSERY STOCK,BULBS,SEEDS,PLANTS,FLOWERS",
    label: "Floral Nursery Stock, Bulbs, Seeds",
    airline: [
      { airline: "EK", commodityCode: "1401", product: "PXS" },
      { airline: "EK", commodityCode: "1401", product: "PXD" },
    ],
  },
  {
    value: "FLOUR",
    label: "Flour",
    airline: [
      { airline: "EK", commodityCode: "0509", product: "PXS" },
      { airline: "EK", commodityCode: "0509", product: "PXD" },
    ],
  },
  {
    value: "FLOWERS",
    label: "Flowers",
    airline: [
      { airline: "EK", commodityCode: "1420", product: "PXS" },
      { airline: "EK", commodityCode: "1420", product: "PXD" },
    ],
  },
  {
    value: "FLOWERS, PLANTS",
    label: "Flowers, Plants",
    airline: [
      { airline: "EK", commodityCode: "1499", product: "PXD" },
      { airline: "EK", commodityCode: "1499", product: "PXS" },
    ],
  },
  {
    value: "FOLL.PRODS.INCL.BRAND NMS,PRODS.OF ICI/SUBS/ASSO.CO.:ATROMID",
    label: "Following Products, Including Brand Names, Products of ICI/Subsidiaries and Associate Companies",
    airline: [
      { airline: "EK", commodityCode: "6006", product: "GCR" },
      { airline: "EK", commodityCode: "6006", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6006", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FOOD PROCESSING MACHINERY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4705", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FOODSTUFF EXCL CAVAIR,HATCHING EGGS ,SPICES AND BEVERAGES.",
    label: "Foodstuff, excluding caviar, hatching eggs, spices, and beverages.",
    airline: [
      { airline: "EK", commodityCode: "0003", product: "PXS" },
      { airline: "EK", commodityCode: "0003", product: "PXD" },
    ],
  },
  {
    value: "FOODSTUFF EXCL MEAT,FISH,SEAFOOD SPICES,BEVERAGES",
    label: "Foodstuff excluding meat, fish, seafood, spices, and beverages.",
    airline: [
      { airline: "EK", commodityCode: "0012", product: "PXS" },
      { airline: "EK", commodityCode: "0012", product: "PXD" },
    ],
  },
  {
    value: "FOODSTUFF,BEVERAGES-DESTINED TO EMBASSY/COUNSULATE/LEGATION",
    label: "Foodstuffs, Beverages - Destined to Embassy/Consulate/Legation",
    airline: [
      { airline: "EK", commodityCode: "0011", product: "PXS" },
      { airline: "EK", commodityCode: "0011", product: "PXD" },
    ],
  },
  {
    value: "FOODSTUFFS EXCL STRAWBERRIES ,SPICES,BEVERAGES",
    label: "Foodstuffs excluding strawberries, spices, and beverages.",
    airline: [
      { airline: "EK", commodityCode: "0009", product: "PXS" },
      { airline: "EK", commodityCode: "0009", product: "PXD" },
    ],
  },
  {
    value: "FOODSTUFFS, SPICES, BEVERAGES",
    label: "Foodstuffs, Spices, Beverages",
    airline: [
      { airline: "EK", commodityCode: "0006", product: "PXS" },
      { airline: "EK", commodityCode: "0006", product: "GCR" },
      { airline: "EK", commodityCode: "0006", product: "PXD" },
    ],
  },
  {
    value: "FOODSTUFFS,BEVERAGES FR CONSUM/HOUSEHOLD USE-NOT FOR RESALE",
    label: "Foodstuffs, Beverages for Consumer or Household Use - Not for Resale",
    airline: [
      { airline: "EK", commodityCode: "9106", product: "GCR" },
      { airline: "EK", commodityCode: "9106", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FOODSTUFFS,CHEMICALS,ELEC EQPT,TOILET ARTICLES,PLASTIC,PAPER",
    label: "Foodstuffs, Chemicals, Electrical Equipment, Toilet Articles, Plastic, Paper",
    airline: [
      { airline: "EK", commodityCode: "9732", product: "GCR" },
      { airline: "EK", commodityCode: "9732", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FOOTBALL POOL COUPONS",
    label: "Football Pool Coupons",
    airline: [
      { airline: "EK", commodityCode: "7111", product: "GCR" },
      { airline: "EK", commodityCode: "7111", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FOOTBALLS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9211", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FRIDGE,FREEZERS,CLOTHES DRIERS,WASHING MACHINES,STOVES",
    label: "Refrigerators, Freezers, Clothes Dryers, Washing Machines",
    airline: [
      { airline: "EK", commodityCode: "4465", product: "GCR" },
      { airline: "EK", commodityCode: "4465", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4465", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FROGS",
    label: "Frogs",
    airline: [
      { airline: "EK", commodityCode: "0335", product: "PXS" },
      { airline: "EK", commodityCode: "0335", product: "PXD" },
    ],
  },
  {
    value: "FRUIT  DRY,FRESH",
    label: "Fruit, Dry, Fresh",
    airline: [
      { airline: "EK", commodityCode: "0002", product: "PXS" },
      { airline: "EK", commodityCode: "0002", product: "PXD" },
    ],
  },
  {
    value: "FRUIT  EXCLUDING MELONS",
    label: "Fruit Excluding Melons",
    airline: [
      { airline: "EK", commodityCode: "0410", product: "PXS" },
      { airline: "EK", commodityCode: "0410", product: "PXD" },
    ],
  },
  {
    value: "FRUIT  FRESH",
    label: "Fruit, Fresh",
    airline: [
      { airline: "EK", commodityCode: "0413", product: "PXS" },
      { airline: "EK", commodityCode: "0413", product: "PXD" },
    ],
  },
  {
    value: "FRUIT CAKES",
    label: "Fruit Cakes",
    airline: [
      { airline: "EK", commodityCode: "0521", product: "PXS" },
      { airline: "EK", commodityCode: "0521", product: "PXD" },
    ],
  },
  {
    value: "FRUIT JUICES",
    label: "Fruit Juices",
    airline: [
      { airline: "EK", commodityCode: "0192", product: "PXS" },
      { airline: "EK", commodityCode: "0192", product: "PXD" },
    ],
  },
  {
    value: "FRUITS EXCL STRAWBERRIES VEGETABLES",
    label: "Fruits excluding Strawberries and Vegetables",
    airline: [
      { airline: "EK", commodityCode: "0016", product: "PXS" },
      { airline: "EK", commodityCode: "0016", product: "PXD" },
    ],
  },
  {
    value: "FRUITS, VEGETABLES",
    label: "Tobacco, Cigars, Cigarettes",
    airline: [
      { airline: "EK", commodityCode: "0007", product: "PXS" },
      { airline: "EK", commodityCode: "0007", product: "PXD" },
    ],
  },
  {
    value: "FUR PLATES  MADE FROM SEWN SCRAPS",
    label: "Fur Plates Made from Sewn Scraps",
    airline: [
      { airline: "EK", commodityCode: "1102", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1102", product: "GCR" },
      { airline: "QR", commodityCode: "1102", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FUR SCRAPS",
    label: "Fur Scraps",
    airline: [
      { airline: "EK", commodityCode: "1150", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1150", product: "GCR" },
      { airline: "QR", commodityCode: "1150", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURNITURE",
    label: "Furniture",
    airline: [
      { airline: "EK", commodityCode: "9910", product: "GCR" },
      { airline: "EK", commodityCode: "9910", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9910", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURNITURE  EXCL OBJECTS OF ART",
    label: "Furniture excluding objects of art",
    airline: [
      { airline: "EK", commodityCode: "7628", product: "GCR" },
      { airline: "EK", commodityCode: "7628", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7628", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURNITURE  EXCL PAINTINGS/ENGRAVINGS/OBJECTS OF ART",
    label: "Furniture, excluding paintings, engravings, or objects of art.",
    airline: [
      { airline: "EK", commodityCode: "9911", product: "GCR" },
      { airline: "EK", commodityCode: "9911", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9911", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURNITURE SAFES EXCL PAINTINGSENGRAVINGSANTIQUITIESOBJEC",
    label: "Furniture",
    airline: [
      { airline: "QR", commodityCode: "9913", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9910", product: "GCR" },
      { airline: "EK", commodityCode: "9910", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "FURNITURE,FURNITURE COMPONENTS,ARTIFACTS,CURIOS-MADE OF WOOD",
    label: "Furniture, Furniture Components, Artifacts, Curios - Made of Wood",
    airline: [
      { airline: "EK", commodityCode: "7625", product: "GCR" },
      { airline: "EK", commodityCode: "7625", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7625", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURS, FUR WEARING APPAREL, SKINS",
    label: "Tobacco, Cigars, Cigarettes",
    airline: [
      { airline: "EK", commodityCode: "1103", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1103", product: "GCR" },
      { airline: "QR", commodityCode: "1103", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURS, HIDES, SKINS EXCLUDING MINK, WEARING APPAREL",
    label: "Furs, Hides, Skins Excluding Mink, Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "1195", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1195", product: "GCR" },
      { airline: "QR", commodityCode: "1195", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURS, HIDES, SKINS EXCLUDING WEARING APPAREL",
    label: "Shipments of ICI, its subsidiaries, and associate companies.",
    airline: [
      { airline: "EK", commodityCode: "1100", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1100", product: "GCR" },
      { airline: "QR", commodityCode: "1100", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "FURS,HIDES,SKINS-UNDRESED/INCL SEMI-FINISHED MFRS",
    label: "Furs, hides, skins - undressed, including semi-finished",
    airline: [
      { airline: "EK", commodityCode: "1213", product: "GCR" },
      { airline: "EK", commodityCode: "1213", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1213", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS",
    label: "Garments, Wearing Apparel",
    airline: [
      { airline: "QR", commodityCode: "9988", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GARMENTS, CHILDRENS WEARING APPAREL",
    label: "Garments, Children's Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "2309", product: "GCR" },
      { airline: "EK", commodityCode: "2309", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2309", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, CLOTHING AND WEARING APPAREL EXCLUDING LEATHER MANUFACTURES",
    label: "Garments, Clothing, and Wearing Apparel, excluding Leather Manufactures",
    airline: [
      { airline: "EK", commodityCode: "2204", product: "GCR" },
      { airline: "EK", commodityCode: "2204", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2204", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL",
    label: "Garments, Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "2200", product: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL (EXCLUDING UMBRELLAS, BILLFOLDS, PURSES, CARRYING CASES, HANDBAGS, COSTUME",
    label: "Garments, wearing apparel (excluding umbrellas, billfolds, purses, carrying cases, etc.)",
    airline: [
      { airline: "EK", commodityCode: "2203", product: "GCR" },
      { airline: "EK", commodityCode: "2203", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2203", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL (FUR/LEATHER)",
    label: "Garments, Wearing Apparel (Fur)",
    airline: [
      { airline: "EK", commodityCode: "2234", product: "GCR" },
      { airline: "EK", commodityCode: "2234", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2234", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL (KNITTED)",
    label: "Garments, Wearing Apparel (Knitted)",
    airline: [
      { airline: "EK", commodityCode: "2455", product: "GCR" },
      { airline: "EK", commodityCode: "2455", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2455", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL, SHOE LACES, HOOKS, SNAPS, BUTTONS, BUCKLES, ZIP-FASTENERS EXCLUDING FURS,",
    label: "Garments, Wearing Apparel, Shoe Laces, Hooks, Snaps, Buttons, Buckles, Zipper Fasteners",
    airline: [
      { airline: "EK", commodityCode: "2206", product: "GCR" },
      { airline: "EK", commodityCode: "2206", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2206", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL, SHOE LACES, HOOKS, SNAPS, BUTTONS,BUCKLES, ZIP-FASTENERS EXCLUDING FOOTWE",
    label: "Garments, wearing apparel, shoelaces, hooks, snaps, buttons, buckles, zip fasteners",
    airline: [
      { airline: "EK", commodityCode: "2207", product: "GCR" },
      { airline: "EK", commodityCode: "2207", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2207", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, WEARING APPAREL, TEXTILE MANUFACTURES - ON HANGERS -",
    label: "Garments, Wearing Apparel, Textile Manufactures - On Hangers",
    airline: [
      { airline: "EK", commodityCode: "2311", product: "GCR" },
      { airline: "EK", commodityCode: "2311", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2311", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, YARN, THREAD, FIBRES - NOT FURTHER PROCESSED OR MANUFACTURED/EXCLUSIVELY IN BALES, BOLTS,",
    label: "Garments, Yarn, Thread, Fibers - Not Further Processed or Manufactured/Exclusively in Bales",
    airline: [
      { airline: "EK", commodityCode: "2211", product: "GCR" },
      { airline: "EK", commodityCode: "2211", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2211", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, YARN, THREAD, FIBRES, TEXTILES, WEARING APPAREL, LEATHER, LEATHER MANUFACTURES",
    label: "Garments, yarn, thread, fibers, textiles, wearing apparel, leather, leather manufactures",
    airline: [
      { airline: "EK", commodityCode: "9703", product: "GCR" },
      { airline: "EK", commodityCode: "9703", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9703", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, YARN, THREAD, FIBRES, TEXTILES, WEARING APPAREL, LEATHER, LEATHER MANUFACTURES EXCLUDING F",
    label: "Garments, yarn, thread, fibers, textiles, wearing apparel, leather, leather manufactures, excluding fur.",
    airline: [
      { airline: "EK", commodityCode: "9734", product: "GCR" },
      { airline: "EK", commodityCode: "9734", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9734", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GARMENTS, YARN, THREAD, TEXTILE MANUFACTURES, WEARING APPAREL EXCLUDING FOOTWEAR, LEATHER MANUFACTUR",
    label: "Garments, Yarn, Thread, Textile Manufactures, Wearing Apparel excluding Footwear, Leather Manufactures",
    airline: [
      { airline: "EK", commodityCode: "2194", product: "GCR" },
      { airline: "EK", commodityCode: "2194", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2194", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GAS MANTLES",
    label: "Gas Mantles",
    airline: [
      { airline: "EK", commodityCode: "2627", product: "GCR" },
      { airline: "EK", commodityCode: "2627", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2627", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GEOLOGICAL SAMPLES  EXCLUDING ORE",
    label: "Geological Samples Excluding Ore",
    airline: [
      { airline: "EK", commodityCode: "5901", product: "GCR" },
      { airline: "EK", commodityCode: "5901", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5902", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GEOPHYSICAL EQUIPMENT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GIFT PARCELS  CONT FOOD,CLOTHG,SHOES,MEDI,COSMETCS,TOILET AR",
    label: "Gift Parcels Containing Food, Clothing, Shoes, Medicines, Cosmetics, Toilet Articles",
    airline: [
      { airline: "EK", commodityCode: "9104", product: "GCR" },
      { airline: "EK", commodityCode: "9104", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GIFT PARCELS  CONTAINING FOOD, CLOTHING",
    label: "Gift Parcels Containing Food, Clothing",
    airline: [
      { airline: "EK", commodityCode: "9102", product: "GCR" },
      { airline: "EK", commodityCode: "9102", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GIFT SHIPMENTS  CONTAINING FOOD,MEDICAL SUPPLIES",
    label: "Gift Shipments Containing Food, Medical Supplies",
    airline: [
      { airline: "EK", commodityCode: "9105", product: "GCR" },
      { airline: "EK", commodityCode: "9105", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GINGER",
    label: "Ginger",
    airline: [
      { airline: "EK", commodityCode: "0751", product: "PXS" },
      { airline: "EK", commodityCode: "0751", product: "PXD" },
    ],
  },
  {
    value: "GINSENG ROOT",
    label: "Ginseng Root",
    airline: [
      { airline: "EK", commodityCode: "6425", product: "GCR" },
      { airline: "EK", commodityCode: "6425", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GLANDS  ANIMAL",
    label: "Animal Glands",
    airline: [
      { airline: "EK", commodityCode: "1931", product: "GCR" },
      { airline: "EK", commodityCode: "1931", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GLASS BOTTLES EXCLUDING CRYSTALWARE",
    label: "Glass, Glass Products",
    airline: [
      { airline: "QR", commodityCode: "5321", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5300", product: "GCR" },
      { airline: "EK", commodityCode: "5300", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GLASS, GLASS PRODUCTS",
    label: "Glass, Glass Products",
    airline: [
      { airline: "EK", commodityCode: "5300", product: "GCR" },
      { airline: "EK", commodityCode: "5300", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GLASSWARE  INCL GLASS LAMPSHADES, ASSOCIATD ELEC FXTRS/FTNGS",
    label: "Glassware, Including Glass Lampshades and Associated Electrical Components",
    airline: [
      { airline: "EK", commodityCode: "5351", product: "GCR" },
      { airline: "EK", commodityCode: "5351", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5351", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GLOVES, MITTENS",
    label: "Gloves, Mittens",
    airline: [
      { airline: "EK", commodityCode: "2332", product: "GCR" },
      { airline: "EK", commodityCode: "2332", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2332", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GOATS",
    label: "Goats",
    airline: [
      { airline: "EK", commodityCode: "1054", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GOLFBAGS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9247", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GOODS CONSIGNED TO AMBASSADORS,LEGATIONS,CONSULS OR OTHER OF",
    label: "Goods Consigned to Ambassadors, Legations, Consuls, or Other Officials",
    airline: [
      { airline: "EK", commodityCode: "9981", product: "GCR" },
      { airline: "EK", commodityCode: "9981", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9945", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
    ],
  },
  {
    value: "GOVERNMENT OWNED STORES  INCLUDING SUPPLIES",
    label: "Government Owned Stores, Including Supplies",
    airline: [
      { airline: "EK", commodityCode: "9942", product: "GCR" },
      { airline: "EK", commodityCode: "9942", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9942", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GRANITE SLABS",
    label: "Granite Slabs",
    airline: [
      { airline: "EK", commodityCode: "5900", product: "GCR" },
      { airline: "EK", commodityCode: "5900", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5900", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "GRAPHITE",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5160", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GUM ARABIC",
    label: "Gum Arabic",
    airline: [
      { airline: "EK", commodityCode: "1352", product: "PXS" },
      { airline: "EK", commodityCode: "1352", product: "PXD" },
    ],
  },
  {
    value: "GUNS",
    label: "Guns, Firearms, Ammunition",
    airline: [
      { airline: "QR", commodityCode: "9315", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9300", product: "GCR" },
      { airline: "EK", commodityCode: "9300", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "GUNS, FIREARMS, AMMUNITION",
    label: "Guns, Firearms, Ammunition",
    airline: [
      { airline: "EK", commodityCode: "9300", product: "GCR" },
      { airline: "EK", commodityCode: "9300", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HABERDASHERY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9961", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HAIR, HAIR MANUFACTURES",
    label: "Hair, Hair Manufactures",
    airline: [
      { airline: "EK", commodityCode: "2700", product: "GCR" },
      { airline: "EK", commodityCode: "2700", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2700", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HAIR,WIGS,RADIOS,TVS  MISCELLANEOUS ITEMS.....",
    label: "Hair, Wigs, Radios, Televisions, Miscellaneous Items.",
    airline: [
      { airline: "EK", commodityCode: "9751", product: "GCR" },
      { airline: "EK", commodityCode: "9751", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9751", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGS",
    label: "Handbags",
    airline: [
      { airline: "EK", commodityCode: "9552", product: "GCR" },
      { airline: "EK", commodityCode: "9552", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9552", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGS GLOVES",
    label: "HANDBAGS",
    airline: [
      { airline: "QR", commodityCode: "2503", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9552", product: "GCR" },
      { airline: "EK", commodityCode: "9552", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HANDBAGS SHOES INCLUDING DISPLAY MATERIAL",
    label: "Handbags",
    airline: [
      { airline: "QR", commodityCode: "9559", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9552", product: "GCR" },
      { airline: "EK", commodityCode: "9552", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9569", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGS, BELTS - MADE OF LEATHER",
    label: "Handbags, Belts - Made of Leather",
    airline: [
      { airline: "EK", commodityCode: "1234", product: "GCR" },
      { airline: "EK", commodityCode: "1234", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1234", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGS, POCKETBOOKS, WALLETS, PURSES",
    label: "Handbags, Pocketbooks, Wallets",
    airline: [
      { airline: "EK", commodityCode: "1231", product: "GCR" },
      { airline: "EK", commodityCode: "1231", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1231", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGS,PURSES,WALLETS INCL ACCESSORIES OTHER THAN LEATHER",
    label: "Handbags, Purses, Wallets including Accessories Other Than Leather",
    airline: [
      { airline: "EK", commodityCode: "9557", product: "GCR" },
      { airline: "EK", commodityCode: "9557", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9557", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDBAGSPURSESWALLETS OTHER THAN LEATHER",
    label: "HANDBAGSPURSESWALLETS INCL ACCESSORIES OTHER THAN LEATHER",
    airline: [
      { airline: "QR", commodityCode: "9554", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9557", product: "GCR" },
      { airline: "EK", commodityCode: "9557", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HANDICRAFT ARTICLES MADE OF WOODMETALCORKSTRAWBAMBOO",
    label: "HANDICRAFT PRODUCTS MADE OF TEXTILESMETALWOODSTRAWLEATHE",
    airline: [
      { airline: "QR", commodityCode: "9518", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9516", product: "GCR" },
      { airline: "EK", commodityCode: "9516", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HANDICRAFT ENTIRELY OF ONYX",
    label: "Handicraft Entirely of Onyx",
    airline: [
      { airline: "EK", commodityCode: "5821", product: "GCR" },
      { airline: "EK", commodityCode: "5821", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9517", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PDCTS TXTLS,METAL,WOOD,CORK,STRAW,WICKER,LEATHER,",
    label: "Handicraft products made of textiles, metal, wood, cork, straw, wicker",
    airline: [
      { airline: "EK", commodityCode: "9513", product: "GCR" },
      { airline: "EK", commodityCode: "9513", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9513", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PRODS MADE OF METAL,WOOD,STRAW,LEATHER,EARTH,ONYX",
    label: "Handicraft Products Made of Metal, Wood, Straw, Leather, Earth, Onyx",
    airline: [
      { airline: "EK", commodityCode: "9517", product: "GCR" },
      { airline: "EK", commodityCode: "9517", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9517", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PRODS MADE OF TEXTILES,METAL,LEATHER EXCL DIAMOND",
    label: "Handicraft products made of textiles, metal, leather, excluding diamonds",
    airline: [
      { airline: "EK", commodityCode: "9718", product: "GCR" },
      { airline: "EK", commodityCode: "9718", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9718", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PRODS MADE OF TEXTLS,METAL,WOOD,CORK,STRAW,WICKER",
    label: "Handicraft Products Made of Textiles, Metal, Wood, Cork, Straw, Wicker",
    airline: [
      { airline: "EK", commodityCode: "9503", product: "GCR" },
      { airline: "EK", commodityCode: "9503", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9503", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PRODS TXTLS,METAL,WOOD,CLAY EXCL WEARG AAPAREL",
    label: "Handicraft Products Textiles, Metal, Wood, Clay excluding Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "9522", product: "GCR" },
      { airline: "EK", commodityCode: "9522", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9522", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFT PRODUCTS MADE OF TEXTILES,METAL,WOOD,STRAW,LEATHE",
    label: "Handicraft products made of textiles, metal, wood, straw, leather",
    airline: [
      { airline: "EK", commodityCode: "9516", product: "GCR" },
      { airline: "EK", commodityCode: "9516", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9516", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS",
    label: "Handicrafts",
    airline: [
      { airline: "EK", commodityCode: "9527", product: "GCR" },
      { airline: "EK", commodityCode: "9527", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9527", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS MADE OF BRASS,COPPER,IRON,WOOD,BAMBOO,WICKER,PAP",
    label: "Handicrafts made of brass, copper, iron, wood, bamboo, wicker, paper",
    airline: [
      { airline: "EK", commodityCode: "9515", product: "GCR" },
      { airline: "EK", commodityCode: "9515", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9515", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS MADE OF BRASS,COPPER,IRON,WOOD,CLAY,HANDLOOM TXT",
    label: "Handicrafts made of brass, copper, iron, wood, clay, handloom textiles.",
    airline: [
      { airline: "EK", commodityCode: "9509", product: "GCR" },
      { airline: "EK", commodityCode: "9509", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9509", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS MADE OF BRASS,COPPER,IRON,WOOD,STONE,BAMBOO,WICK",
    label: "Handicrafts Made of Brass, Copper, Iron, Wood, Stone, Bamboo, Wicker",
    airline: [
      { airline: "EK", commodityCode: "9512", product: "GCR" },
      { airline: "EK", commodityCode: "9512", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9512", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS MADE OF SISAL,FIBRE,BANANA FIBRE,BAMBOO,LEATHER,",
    label: "Handicrafts Made of Sisal, Fiber, Banana Fiber, Bamboo, Leather",
    airline: [
      { airline: "EK", commodityCode: "9520", product: "GCR" },
      { airline: "EK", commodityCode: "9520", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9520", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS METAL,WOOD,CORK,STRAW EXCL TXTL,LEATHER,DIAMONDS",
    label: "Handicrafts made of metal, wood, cork, straw, excluding textiles and leather.",
    airline: [
      { airline: "EK", commodityCode: "9524", product: "GCR" },
      { airline: "EK", commodityCode: "9524", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9524", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTS(MADE OF METAL,WOOD,CORK,STRAW,BAMBOO,WICKER,CLAY",
    label: "Handicrafts made of metal, wood, cork, straw, bamboo, wicker",
    airline: [
      { airline: "EK", commodityCode: "9525", product: "GCR" },
      { airline: "EK", commodityCode: "9525", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9525", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HANDICRAFTSHANDLOOM TEXTILESSILVERBRASSCOPPERIRONWOOD",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9519", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HANDLES MADE OF WOOD",
    label: "WOOD PRODUCTS",
    airline: [
      { airline: "QR", commodityCode: "7603", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7600", product: "GCR" },
      { airline: "EK", commodityCode: "7600", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HARDWARE",
    label: "Hardware",
    airline: [
      { airline: "EK", commodityCode: "3300", product: "GCR" },
      { airline: "EK", commodityCode: "3300", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HARDWARE FOR FURNITURE",
    label: "Hardware for Furniture",
    airline: [
      { airline: "EK", commodityCode: "3504", product: "GCR" },
      { airline: "EK", commodityCode: "3504", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3504", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HARES",
    label: "Hares",
    airline: [
      { airline: "EK", commodityCode: "1040", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HATCHING EGGS",
    label: "Hatching Eggs",
    airline: [
      { airline: "EK", commodityCode: "1082", product: "PXS" },
      { airline: "EK", commodityCode: "1082", product: "PXD" },
    ],
  },
  {
    value: "HATS",
    label: "Hats",
    airline: [
      { airline: "EK", commodityCode: "2350", product: "GCR" },
      { airline: "EK", commodityCode: "2350", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2350", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HELICOPTER SPARES",
    label: "Helicopter Spares",
    airline: [
      { airline: "EK", commodityCode: "4107", product: "GCR" },
      { airline: "EK", commodityCode: "4107", product: "AOG", productSHC: "AOG" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HENNA  DRIED",
    label: "Henna, Dried",
    airline: [
      { airline: "EK", commodityCode: "1503", product: "PXD" },
      { airline: "EK", commodityCode: "1503", product: "PXS" },
    ],
  },
  {
    value: "HERBS, LEAVES - INCLUDING PRODUCTS THEREOF -",
    label: "Herbs, Leaves - Including Products Thereof",
    airline: [
      { airline: "EK", commodityCode: "1500", product: "PXD" },
      { airline: "EK", commodityCode: "1500", product: "PXS" },
    ],
  },
  {
    value: "HIDES,SKINS - INCLUDING PRODUCTS THEREOF",
    label: "Hides, Skins - Including Products Thereof",
    airline: [
      { airline: "EK", commodityCode: "1215", product: "GCR" },
      { airline: "EK", commodityCode: "1215", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1215", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HIDES,SKINS- UNDRESSED- FURS EXCL MFRS NUTRIA/REPTILE SKINS",
    label: "Hides, skins - undressed - furs excluding manufactures of nutria/reptile skins.",
    airline: [
      { airline: "EK", commodityCode: "1101", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1101", product: "GCR" },
      { airline: "QR", commodityCode: "1101", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HONEY",
    label: "Honey",
    airline: [
      { airline: "EK", commodityCode: "0075", product: "PXS" },
      { airline: "EK", commodityCode: "0075", product: "GCR" },
      { airline: "EK", commodityCode: "0075", product: "PXD" },
    ],
  },
  {
    value: "HORSE MEAT",
    label: "Horse Meat",
    airline: [
      { airline: "EK", commodityCode: "0670", product: "PXS" },
      { airline: "EK", commodityCode: "0670", product: "PXD" },
    ],
  },
  {
    value: "HOSE, PANTYHOSE",
    label: "Hose, Pantyhose",
    airline: [
      { airline: "EK", commodityCode: "2367", product: "GCR" },
      { airline: "EK", commodityCode: "2367", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2367", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOSP SUPPLIES CLOTHG,DRESSG,MEDICINE,LAB TOOLS,PHARMA,MEDICA",
    label: "Hospital Supplies, Clothing, Dressings, Medicines, Lab Tools, Pharmaceuticals",
    airline: [
      { airline: "EK", commodityCode: "9971", product: "GCR" },
      { airline: "EK", commodityCode: "9971", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4703", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOT PEPPERS,EGGPLANTS",
    label: "Hot Peppers, Eggplants",
    airline: [
      { airline: "EK", commodityCode: "0023", product: "PXS" },
      { airline: "EK", commodityCode: "0023", product: "PXD" },
    ],
  },
  {
    value: "HOTEL SUPPLIES BED SHEETSSOAPTOYSGOLF CLUBSBRONZEWAR",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8000", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HOUSEHOLD APPLIANCES/UTENSILS - ELECTRIC -",
    label: "Household Appliances/Utensils - Electric",
    airline: [
      { airline: "EK", commodityCode: "4450", product: "GCR" },
      { airline: "EK", commodityCode: "4450", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4450", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOUSEHOLD ELECTRONIC IGNITERS",
    label: "Electronic Products",
    airline: [
      { airline: "QR", commodityCode: "9900", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4329", product: "GCR" },
      { airline: "EK", commodityCode: "4329", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HOUSEHOLD FURN,KITCHEN EQPT USED  EXCL PER.EFFECTS",
    label: "Household Furniture, Kitchen Equipment Used, Excluding Personal Effects",
    airline: [
      { airline: "EK", commodityCode: "9984", product: "GCR" },
      { airline: "EK", commodityCode: "9984", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9984", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOUSEHOLD FURNITUREKITCHEN EQPTCUTLER EXCL PAINTINGSOBJEC",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9917", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HOUSEHOLD GOODS USED ,WEARING APPAREL/COSMETICS  USED",
    label: "Household Goods Used, Wearing Apparel/Cosmetics Used",
    airline: [
      { airline: "EK", commodityCode: "9994", product: "GCR" },
      { airline: "EK", commodityCode: "9994", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOUSEHOLD WOODENWARE",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "7685", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HOUSEHOLD/TABLE/KITCHEN /HOSPITAL UTENSILS",
    label: "Household/Table/Kitchen/Hospital Utensils",
    airline: [
      { airline: "EK", commodityCode: "3400", product: "GCR" },
      { airline: "EK", commodityCode: "3400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3400", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HOUSEHOLD/WEARING GD,COSMETICS,TOILETRIES(USED,NO RESALE)",
    label: "Household/Wearing Goods, Cosmetics, Toiletries (Used, etc.)",
    airline: [
      { airline: "EK", commodityCode: "9993", product: "GCR" },
      { airline: "EK", commodityCode: "9993", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HUMAN BLOOD",
    label: "Human Blood",
    airline: [
      { airline: "EK", commodityCode: "6109", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "HUMAN EYES,TISSUES,DEHYDRATED CORNEAS",
    label: "Human Eyes, Tissues, Dehydrated",
    airline: [
      { airline: "EK", commodityCode: "9092", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HUMAN HAIR",
    label: "Human Hair",
    airline: [
      { airline: "EK", commodityCode: "9090", product: "GCR" },
      { airline: "EK", commodityCode: "9090", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9090", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "HUMAN REMAINS, UNCREMATED",
    label: "Human Remains, Uncremated",
    airline: [
      { airline: "EK", commodityCode: "9091", product: "GCR" },
      { airline: "EK", commodityCode: "9091", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "HYPODERMIC (SURGICAL) NEEDLES",
    label: "Hypodermic (Surgical)",
    airline: [
      { airline: "EK", commodityCode: "8114", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ICE CREAM,FROZEN CONFECTION",
    label: "Ice Cream, Frozen Confectionery",
    airline: [
      { airline: "EK", commodityCode: "0246", product: "PXS" },
      { airline: "EK", commodityCode: "0246", product: "PXD" },
    ],
  },
  {
    value: "IMITATION JEWELRY,FANCY NOVELTIES EXCL CLOTH,WATCHES WHICH C",
    label: "Imitation Jewelry, Fancy Novelties, Excluding Clothing and Watches Which Contain",
    airline: [
      { airline: "EK", commodityCode: "9742", product: "GCR" },
      { airline: "EK", commodityCode: "9742", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9742", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "IMITATION JEWELRY,NOVELTIES,ORNAMTS EXCL WATCHES,CLOCKS",
    label: "Imitation Jewelry, Novelties, Ornaments excluding Watches.",
    airline: [
      { airline: "EK", commodityCode: "9006", product: "GCR" },
      { airline: "EK", commodityCode: "9006", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9006", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "IMITATION JEWELRY,PERSONAL ORNAMENTS,ARTIFICIAL/GLASS STONES",
    label: "Imitation Jewelry, Personal Ornaments, Artificial/Glass Stones",
    airline: [
      { airline: "EK", commodityCode: "9001", product: "GCR" },
      { airline: "EK", commodityCode: "9001", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "IMITATION JEWELRYFANCY NOVELTIESPERSONAL ORNAMENTS EX",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9009", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "IMPLMENTS FR MEASURING,CHKG,ANALYSG,AUTO CONTRLLG,CONDENSORS",
    label: "Implements for Measuring, Checking, Analyzing, Auto Controlling",
    airline: [
      { airline: "EK", commodityCode: "4455", product: "GCR" },
      { airline: "EK", commodityCode: "4455", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4455", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INDIAN BEEDIES",
    label: "Indian Beedies",
    airline: [
      { airline: "EK", commodityCode: "9613", product: "GCR" },
      { airline: "EK", commodityCode: "9613", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9795", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INDIAN SWEETMEATS",
    label: "Indian Sweetmeats",
    airline: [
      { airline: "EK", commodityCode: "0497", product: "PXS" },
      { airline: "EK", commodityCode: "0497", product: "PXD" },
    ],
  },
  {
    value: "INDL CHEMICALS, TESTING EQPT  MADE OF GLASS",
    label: "Industrial Chemicals, Testing Equipment Made of Glass",
    airline: [
      { airline: "EK", commodityCode: "6224", product: "GCR" },
      { airline: "EK", commodityCode: "6224", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6224", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INDL PRODS:TEXTILESFIBRESANDMFRSMETALSDRUGS FRM ARE3 TRANS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9922", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "INFANT FOOD",
    label: "Infant Food",
    airline: [
      { airline: "EK", commodityCode: "0010", product: "PXS" },
      { airline: "EK", commodityCode: "0010", product: "PXD" },
    ],
  },
  {
    value: "INJECTION INSTRUMENTS, INFUSION SETS",
    label: "Injection Instruments, Infusion Sets",
    airline: [
      { airline: "EK", commodityCode: "8112", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSECTICIDE",
    label: "Insecticide",
    airline: [
      { airline: "EK", commodityCode: "6240", product: "GCR" },
      { airline: "EK", commodityCode: "6240", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6240", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSTRUMENTS FOR DENTISTRY, SURGERY, MEASURING, CALIBRATING, X-RAY EQUIPMENT, ANALYSING SCALES, MICRO",
    label: "Instruments for dentistry, surgery, measuring, calibrating, X-ray equipment, analyzing scales",
    airline: [
      { airline: "EK", commodityCode: "8003", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSTRUMENTS FOR REGULATING, MEASURING, TESTING",
    label: "Instruments for Regulating, Measuring, Testing",
    airline: [
      { airline: "EK", commodityCode: "8909", product: "GCR" },
      { airline: "EK", commodityCode: "8909", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSTRUMTS,EQPT-DESIGNED FOR SCI SURGCL LAB,INDL RADIO OR TV",
    label: "Instruments, Equipment - Designed for Scientific, Surgical, Laboratory",
    airline: [
      { airline: "EK", commodityCode: "9719", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSULATING TUBINGS",
    label: "Insulating Tubings",
    airline: [
      { airline: "EK", commodityCode: "6812", product: "GCR" },
      { airline: "EK", commodityCode: "6812", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6812", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INSULATION MACINERY INCLUDING SUPPLIES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4727", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "INSULIN, CHEMICALS, DRUGS, PHARMACEUTICALS, MEDICINES",
    label: "Insulin, Chemicals, Drugs, Pharmaceuticals, Medicines",
    airline: [
      { airline: "EK", commodityCode: "6001", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "INTEGRATD CIRCUITS,CONDENSORS,RELAYS,RESISTORS,TRANSISTORS",
    label: "Integrated Circuits, Capacitors, Relays, Resistors",
    airline: [
      { airline: "EK", commodityCode: "4446", product: "GCR" },
      { airline: "EK", commodityCode: "4446", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4446", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INTEGRATED CIRCUITS,RELAYS,CONDENSOR,CAPACITORS,TRANSISTORS,",
    label: "Integrated Circuits, Relays, Condensers, Capacitors",
    airline: [
      { airline: "EK", commodityCode: "4350", product: "GCR" },
      { airline: "EK", commodityCode: "4350", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4350", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INTERNAL COMBUSTION ENGINES,TURBINES",
    label: "Internal Combustion Engines, Turbines",
    airline: [
      { airline: "EK", commodityCode: "4609", product: "GCR" },
      { airline: "EK", commodityCode: "4609", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "INVENTORY MATERIALS FOR SHIPS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4234", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "IVORY GOODS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "1990", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "JACKETS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2349", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "KITCHEN/TABLE UTENSLS,VASES EXCL ELECTRIC EQUIPMENT",
    label: "Kitchen and Table Utensils, Vases, Excluding Electric Equipment",
    airline: [
      { airline: "EK", commodityCode: "3409", product: "GCR" },
      { airline: "EK", commodityCode: "3409", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3409", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "KIWIFRUIT",
    label: "Kiwifruit",
    airline: [
      { airline: "EK", commodityCode: "0456", product: "PXS" },
      { airline: "EK", commodityCode: "0456", product: "PXD" },
    ],
  },
  {
    value: "KNITTING MACHINES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4787", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "KOLA NUTS",
    label: "Kola Nuts",
    airline: [
      { airline: "EK", commodityCode: "0037", product: "PXS" },
      { airline: "EK", commodityCode: "0037", product: "PXD" },
    ],
  },
  {
    value: "LABELS ,CARBOARD CARTONS UNASSEMBLED ,OFC STATIONERY,PROMOTIO",
    label: "Labels, Cardboard Cartons Unassembled, Office Stationery",
    airline: [
      { airline: "EK", commodityCode: "7178", product: "GCR" },
      { airline: "EK", commodityCode: "7178", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7181", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LABELS,ADHESIVE TAPE,DISPENSER,CARDBOARD CARTON UNASSEMBLED",
    label: "Labels, Adhesive Tape, Dispenser, Cardboard Carton",
    airline: [
      { airline: "EK", commodityCode: "7181", product: "GCR" },
      { airline: "EK", commodityCode: "7181", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7181", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LAMB, MUTTON",
    label: "Lamb, Mutton, and Sheep",
    airline: [
      { airline: "EK", commodityCode: "0630", product: "PXS" },
      { airline: "EK", commodityCode: "0630", product: "PXD" },
    ],
  },
  {
    value: "LAMB/KID/SHEEP/GOAT SKINS EXCL WEARING APPAREL",
    label: "Lamb, Kid, Sheep, and Goat Skins, Excluding Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "1125", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1125", product: "GCR" },
      { airline: "QR", commodityCode: "1125", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LAMPS,BULBS,TUBES-INCANDESCENT,FLUORESCENT",
    label: "Lamps, Bulbs, Tubes - Incandescent",
    airline: [
      { airline: "EK", commodityCode: "4470", product: "GCR" },
      { airline: "EK", commodityCode: "4470", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4470", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LAWN SPRINKLERS,PISTOL NOZZLE/CONNECTORS,BASES USD FOR SPRIN",
    label: "Lawn Sprinklers, Pistol Nozzle and Connectors, Bases Used",
    airline: [
      { airline: "EK", commodityCode: "3206", product: "GCR" },
      { airline: "EK", commodityCode: "3206", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3206", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER  EXCL NUTRIA/REPTILE SKIN MANUACTURES",
    label: "Leather Excluding Nutria/Reptile Skin Manufactures",
    airline: [
      { airline: "EK", commodityCode: "1237", product: "GCR" },
      { airline: "EK", commodityCode: "1237", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1237", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER  UNMANUFACTURED",
    label: "Leather, Unmanufactured",
    airline: [
      { airline: "EK", commodityCode: "1205", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1205", product: "GCR" },
      { airline: "QR", commodityCode: "1205", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER GOODS",
    label: "LEATHER PRODUCTS",
    airline: [
      { airline: "QR", commodityCode: "1202", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1201", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1201", product: "GCR" },
    ],
  },
  {
    value: "LEATHER TANNED,DYED,FINISHED,SEMI-FINISHED,CUT TO SHAPE",
    label: "Shipments of Imperial Chemical Industries, its Subsidiaries and Associate Companies",
    airline: [
      { airline: "EK", commodityCode: "1204", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1204", product: "GCR" },
      { airline: "QR", commodityCode: "1204", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER-BAG,BALL,BELT,BILLFOLD,SUITCASE,HARNESS,SADDLERY,POC",
    label: "Leather bags, balls, belts, billfolds, suitcases, and harnesses.",
    airline: [
      { airline: "EK", commodityCode: "1238", product: "GCR" },
      { airline: "EK", commodityCode: "1238", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1238", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER, LEATHER GARMENTS",
    label: "Leather, Leather Garments",
    airline: [
      { airline: "EK", commodityCode: "1200", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1200", product: "GCR" },
      { airline: "QR", commodityCode: "1200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER, LEATHER PRODUCTS",
    label: "Leather, leather products",
    airline: [
      { airline: "EK", commodityCode: "1201", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1201", product: "GCR" },
      { airline: "QR", commodityCode: "1201", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER,HIDES AND SKINS - EXCL. FURS AND PELTS",
    label: "Leather, Hides and Skins - Excluding Furs and Pelts",
    airline: [
      { airline: "EK", commodityCode: "1198", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1198", product: "GCR" },
      { airline: "QR", commodityCode: "1198", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER,HIDES,SKINS - TANNED, PROCESSED",
    label: "Leather, Hides, Skins - Tanned, Prepared",
    airline: [
      { airline: "EK", commodityCode: "1211", product: "GCR" },
      { airline: "EK", commodityCode: "1211", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1211", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER,HIDES,SKINS -EXCL.WEARING APPAREL,FURS",
    label: "Leather, Hides, and Skins, excluding Wearing Apparel and Furs",
    airline: [
      { airline: "EK", commodityCode: "1207", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1207", product: "GCR" },
      { airline: "QR", commodityCode: "1207", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHER,LEATHER PRODUCTS EXCL. SPORTING GOODS",
    label: "Leather, Leather Products Excluding Sporting Goods",
    airline: [
      { airline: "EK", commodityCode: "1210", product: "GCR" },
      { airline: "EK", commodityCode: "1210", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1210", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LEATHERHIDESANDSKINS EXCL FURSPELTSREPTILENUTRIAL SK",
    label: "Leather, leather products",
    airline: [
      { airline: "QR", commodityCode: "1212", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1201", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1201", product: "GCR" },
    ],
  },
  {
    value: "LEATHERLEATHER GOODS ARTIFICIAL EXCL WEARING APPAREL",
    label: "WEARING APPAREL",
    airline: [
      { airline: "QR", commodityCode: "1272", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "LENSES",
    label: "Lenses",
    airline: [
      { airline: "EK", commodityCode: "8440", product: "GCR" },
      { airline: "EK", commodityCode: "8440", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LENSES FRAMES, SUNGLASSES",
    label: "Lenses, Frames, Sunglasses",
    airline: [
      { airline: "EK", commodityCode: "8370", product: "GCR" },
      { airline: "EK", commodityCode: "8370", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LENSES, PRISMS",
    label: "Lenses, Prisms",
    airline: [
      { airline: "EK", commodityCode: "8340", product: "GCR" },
      { airline: "EK", commodityCode: "8340", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LETTUCE",
    label: "Lettuce",
    airline: [
      { airline: "EK", commodityCode: "0803", product: "PXS" },
      { airline: "EK", commodityCode: "0803", product: "PXD" },
    ],
  },
  {
    value: "LIGHTERS",
    label: "Lighters",
    airline: [
      { airline: "EK", commodityCode: "9625", product: "GCR" },
      { airline: "EK", commodityCode: "9625", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9625", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LIGHTING FIXTURES, LIGHTING FITTING",
    label: "Lighting Fixtures, Lighting Fitting",
    airline: [
      { airline: "EK", commodityCode: "4475", product: "GCR" },
      { airline: "EK", commodityCode: "4475", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4475", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LIMES, LEMONS",
    label: "Limes, Lemons",
    airline: [
      { airline: "EK", commodityCode: "0422", product: "PXS" },
      { airline: "EK", commodityCode: "0422", product: "PXD" },
    ],
  },
  {
    value: "LIVE AQUATIC PLANTS, CORAL",
    label: "Live Aquatic Plants, Coral",
    airline: [
      { airline: "EK", commodityCode: "1983", product: "GCR" },
      { airline: "EK", commodityCode: "1983", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "LIVE AQUATIC PLANTS, FISH (INEDIBLE), CORAL, WEED, FISH FOOD",
    label: "Live Aquatic Plants, Inedible Fish, Coral, Weed, Fish Food",
    airline: [
      { airline: "EK", commodityCode: "9720", product: "GCR" },
      { airline: "EK", commodityCode: "9720", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "LIVE AQUATIC PLANTS, FISH (LIVE, INEDIBLE), CORAL, WEED, FISH FOOD",
    label: "Live Aquatic Plants, Live Inedible Fish, Coral, Weed, Fish Food",
    airline: [
      { airline: "EK", commodityCode: "1024", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "LIVER  RAW",
    label: "Raw Liver",
    airline: [
      { airline: "EK", commodityCode: "0645", product: "PXS" },
      { airline: "EK", commodityCode: "0645", product: "PXD" },
    ],
  },
  {
    value: "LIVESTOCK",
    label: "Livestock",
    airline: [
      { airline: "EK", commodityCode: "1000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "LOBSTERS",
    label: "Lobsters",
    airline: [
      { airline: "EK", commodityCode: "0386", product: "PXS" },
      { airline: "EK", commodityCode: "0386", product: "PXD" },
    ],
  },
  {
    value: "LOCKS",
    label: "Locks",
    airline: [
      { airline: "EK", commodityCode: "3969", product: "GCR" },
      { airline: "EK", commodityCode: "3969", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3969", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LOUD SPKRS,TAPE RECORDRS,RCRD PLAYERS,RADIOS,AMPLIFIERS",
    label: "Loudspeakers, Tape Recorders, Record Players, Radios",
    airline: [
      { airline: "EK", commodityCode: "4414", product: "GCR" },
      { airline: "EK", commodityCode: "4414", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LOUDSPEAKERS",
    label: "Loudspeakers",
    airline: [
      { airline: "EK", commodityCode: "4425", product: "GCR" },
      { airline: "EK", commodityCode: "4425", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4425", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "LWANMOWERS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4716", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MACHINE PARTSAUTOMOBILE WEATHER SHIELDS MADE OF PLASTIC",
    label: "Plastic Articles",
    airline: [
      { airline: "QR", commodityCode: "6858", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MACHINERY  FOR CONSTRUCTING, EXCAVATING, CONVEYING",
    label: "Machinery for constructing, excavating, conveying",
    airline: [
      { airline: "EK", commodityCode: "4720", product: "GCR" },
      { airline: "EK", commodityCode: "4720", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4720", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY AND TOOLS .......",
    label: "Machinery and Tools",
    airline: [
      { airline: "EK", commodityCode: "4703", product: "GCR" },
      { airline: "EK", commodityCode: "4703", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4703", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY EXCLUDING TOOLS COMPUTERS",
    label: "Tools",
    airline: [
      { airline: "QR", commodityCode: "4728", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MACHINERY FOR OIL DRILLING,OIL FIELD SERVICING,DREDGING",
    label: "Machinery for Oil Drilling, Oil Field Servicing, Dredging",
    airline: [
      { airline: "EK", commodityCode: "4742", product: "GCR" },
      { airline: "EK", commodityCode: "4742", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4742", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY FOR PAINT MIXING",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4784", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MACHINERY FOR SUGAR REFINING",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4769", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MACHINERY FR CONSTRUCTG,EARTH MOVG,CONVEYG,EXCAVATG,MINING",
    label: "Machinery for Constructing, Earth Moving, Conveying, Excavating",
    airline: [
      { airline: "EK", commodityCode: "4747", product: "GCR" },
      { airline: "EK", commodityCode: "4747", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4747", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY TOOLS EXCL.STEAMSHIP/MOTORSHIP SPARE PARTS",
    label: "Machinery Tools, Excluding Steamship or Motorshiop Spare Parts",
    airline: [
      { airline: "EK", commodityCode: "4700", product: "GCR" },
      { airline: "EK", commodityCode: "4700", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4700", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY, ELECTRIC APPARATUS, TOOLS",
    label: "Machinery, Electric Apparatus, Tools",
    airline: [
      { airline: "EK", commodityCode: "4701", product: "GCR" },
      { airline: "EK", commodityCode: "4701", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4701", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINERY,TOOLS EXCL MACHNS FOR A/CRAFT ARRESTING,CATAPULTIN",
    label: "Machinery and Tools excluding Machines for Aircraft Arresting and Catapulting",
    airline: [
      { airline: "EK", commodityCode: "4702", product: "GCR" },
      { airline: "EK", commodityCode: "4702", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4703", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINES  FOR MFG BOTTLES, WASHING BOTTLES",
    label: "Machines for manufacturing bottles, washing bottles",
    airline: [
      { airline: "EK", commodityCode: "4708", product: "GCR" },
      { airline: "EK", commodityCode: "4708", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4708", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MACHINES FR CUPPOUCH FILLINGINJECTION MOULDINGPRINTING",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4759", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MAGAZINES, PERIODICALS, NEWSPAPERS - PUBLISHED ONCE WEEKLY OR AT LONGER INTERVALS",
    label: "Magazines, Periodicals, Newspapers - Published Once Weekly or at Longer Intervals",
    airline: [
      { airline: "EK", commodityCode: "7113", product: "GCR" },
      { airline: "EK", commodityCode: "7113", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MAGAZINES,PERIODCALS PUBLISHED ONCE WEEKLY OR LONGER INTERVALS - BOOKS EXCLUDING PHOTOS",
    label: "Magazines, Periodicals Published Once Weekly or Longer Intervals - Books Excluding Photos",
    airline: [
      { airline: "EK", commodityCode: "7106", product: "GCR" },
      { airline: "EK", commodityCode: "7106", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MAGNETIC TAPES FOR DATA STORAGE",
    label: "Magnetic Tapes for Data Storage",
    airline: [
      { airline: "EK", commodityCode: "4315", product: "GCR" },
      { airline: "EK", commodityCode: "4315", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4315", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MAGS, PERIODICALS EXCLUDING NEWSPAPERS",
    label: "Magazines, Periodicals Excluding Newspapers",
    airline: [
      { airline: "EK", commodityCode: "7117", product: "GCR" },
      { airline: "EK", commodityCode: "7117", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MAHI MAHI",
    label: "MAHI-MAHI",
    airline: [
      { airline: "EK", commodityCode: "0319", product: "PXS" },
      { airline: "EK", commodityCode: "0319", product: "PXD" },
    ],
  },
  {
    value: "MANGOES",
    label: "Mangoes",
    airline: [
      { airline: "EK", commodityCode: "0460", product: "PXS" },
      { airline: "EK", commodityCode: "0460", product: "PXD" },
    ],
  },
  {
    value: "MANGOES, MELONS, PINEAPPLES",
    label: "Mangoes, Melons, Pineapples",
    airline: [
      { airline: "EK", commodityCode: "0027", product: "PXS" },
      { airline: "EK", commodityCode: "0027", product: "PXD" },
    ],
  },
  {
    value: "MANICURE CASES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "1296", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MANUFACTURING MATERIALS FOR PLUSH TOYS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9209", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MARBLE",
    label: "Marble",
    airline: [
      { airline: "EK", commodityCode: "5400", product: "GCR" },
      { airline: "EK", commodityCode: "5400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5400", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MEAT  EXCL SLAUGHTERED POULTRY, GAME",
    label: "Meat Excluding Slaughtered Poultry",
    airline: [
      { airline: "EK", commodityCode: "0605", product: "PXS" },
      { airline: "EK", commodityCode: "0605", product: "PXD" },
    ],
  },
  {
    value: "MEAT INCLUDING SLAUGHTERED POULTRY",
    label: "Meat including slaughtered poultry",
    airline: [
      { airline: "EK", commodityCode: "0600", product: "PXS" },
      { airline: "EK", commodityCode: "0600", product: "PXD" },
    ],
  },
  {
    value: "MEAT, SAUSAGES, BOLOGNA, FRANKFURTERS",
    label: "Meat, Sausages, Bologna, Frankfurters",
    airline: [
      { airline: "EK", commodityCode: "0602", product: "PXS" },
      { airline: "EK", commodityCode: "0602", product: "PXD" },
    ],
  },
  {
    value: "MEAT, SEAFOOD",
    label: "Meat, Seafood",
    airline: [
      { airline: "EK", commodityCode: "0603", product: "PXS" },
      { airline: "EK", commodityCode: "0603", product: "PXD" },
    ],
  },
  {
    value: "MEDICAL EQUIPMENT  INCLUDING SUPPLIES",
    label: "Medical Equipment, Including Supplies",
    airline: [
      { airline: "EK", commodityCode: "8575", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MELONS,PERSIMMONS,CITRUS FRUITS",
    label: "Tobacco, Cigars, Cigarettes",
    airline: [
      { airline: "EK", commodityCode: "0029", product: "PXS" },
      { airline: "EK", commodityCode: "0029", product: "PXD" },
    ],
  },
  {
    value: "MERINO LAMB SKINS",
    label: "Lamb, Kid, Sheep, and Goat Skins, Excluding Wearing Apparel",
    airline: [
      { airline: "QR", commodityCode: "1216", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1125", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1125", product: "GCR" },
    ],
  },
  {
    value: "MERINO LAMB SKINS TANNEDDYED",
    label: "Lamb, Kid, Sheep, and Goat Skins, Excluding Wearing Apparel",
    airline: [
      { airline: "QR", commodityCode: "1155", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1125", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1125", product: "GCR" },
    ],
  },
  {
    value: "METAL DIE CAST ALLOYS EXCL GOLD PLATINUM ALLOYS",
    label: "METAL WARES EXCL GOLD PLATINUM MTRLS",
    airline: [
      { airline: "QR", commodityCode: "3013", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3025", product: "GCR" },
      { airline: "EK", commodityCode: "3025", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "METAL FURNITURE METAL FIXTURES",
    label: "FURNITURE",
    airline: [
      { airline: "QR", commodityCode: "3500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9910", product: "GCR" },
      { airline: "EK", commodityCode: "9910", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "METAL INGOTS/GRAIN  SEMI-FINISHED  SHEET, FOIL, POWDER, SPO",
    label: "Metal Ingots/Grain Semi-Finished Sheet, Foil, Plates",
    airline: [
      { airline: "EK", commodityCode: "3002", product: "GCR" },
      { airline: "EK", commodityCode: "3002", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3002", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "METAL KITCHENWARE",
    label: "Metal Kitchenware",
    airline: [
      { airline: "EK", commodityCode: "3411", product: "GCR" },
      { airline: "EK", commodityCode: "3411", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3411", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "METAL SAFES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9915", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "METAL WARES  EXCL GOLD, PLATINUM, PLATINUM MTRLS",
    label: "Metal Wares Excluding Gold, Platinum, Platinum Material.",
    airline: [
      { airline: "EK", commodityCode: "3025", product: "GCR" },
      { airline: "EK", commodityCode: "3025", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3025", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "METAL WARES EXCL SILVER GOLD PLATINUM MTRLS",
    label: "Metal Wares Excluding Gold, Platinum, Platinum Material.",
    airline: [
      { airline: "QR", commodityCode: "3027", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3025", product: "GCR" },
      { airline: "EK", commodityCode: "3025", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "METALLIZED PLASTICPAPER FOILS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "METALS,MINERALS-EXCL GOLD,SILVER,PLATINUM,ALLOYS",
    label: "Metals, Minerals - Excluding Gold, Silver, Platinum, Alloys",
    airline: [
      { airline: "EK", commodityCode: "9722", product: "GCR" },
      { airline: "EK", commodityCode: "9722", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9722", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MICA CAPACITORSCONDENSER FILMSBLOCKS MUSCTOVITEANDFABRICATED",
    label: "Mica, Mica Products",
    airline: [
      { airline: "QR", commodityCode: "5501", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5500", product: "GCR" },
      { airline: "EK", commodityCode: "5500", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MICA, MICA PRODUCTS",
    label: "Mica, Mica Products",
    airline: [
      { airline: "EK", commodityCode: "5500", product: "GCR" },
      { airline: "EK", commodityCode: "5500", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "Military AirMail",
    label: "Military AirMail",
    airline: [
      { airline: "EK", commodityCode: "E0106", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9948", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "Military SAL Mail",
    label: "Military SAL Mail",
    airline: [
      { airline: "EK", commodityCode: "E0105", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9948", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MILITARY STORESIMPEDIMENTA",
    label: "Diplomatic Cargo, Diplomatic Mail",
    airline: [
      { airline: "QR", commodityCode: "9948", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9945", product: "GCR" },
      { airline: "EK", commodityCode: "9945", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MILK FRESH",
    label: "Milk Fresh",
    airline: [
      { airline: "EK", commodityCode: "0203", product: "PXS" },
      { airline: "EK", commodityCode: "0203", product: "PXD" },
    ],
  },
  {
    value: "MILKING MACHINES INCLUDING ACCESSORIES",
    label: "Accessories",
    airline: [
      { airline: "QR", commodityCode: "4706", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9623", product: "GCR" },
      { airline: "EK", commodityCode: "9623", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MINERAL SPECIMEN",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5902", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MINERAL WATER",
    label: "Fish, live, inedible",
    airline: [
      { airline: "EK", commodityCode: "0113", product: "PXS" },
      { airline: "EK", commodityCode: "0113", product: "PXD" },
    ],
  },
  {
    value: "MINING MACHINERYWELL MACHINERYPUMPING MACHINERY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4745", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MISCELLANEOUS ITEMS",
    label: "Miscellaneous Items",
    isGeneric: true,
    airline: [
      { airline: "EK", commodityCode: "9735", product: "GCR" },
      { airline: "EK", commodityCode: "9735", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9735", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9750", product: "GCR" },
      { airline: "EK", commodityCode: "9750", product: "AOG", productSHC: "AOG" },
      { airline: "EK", commodityCode: "9750", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9750", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9799", product: "GCR" },
      { airline: "EK", commodityCode: "9799", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9799", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MISCELLANEOUS ITEMS .......",
    label: "Miscellaneous Items",
    isGeneric: true,
    airline: [
      { airline: "EK", commodityCode: "9797", product: "GCR" },
      { airline: "EK", commodityCode: "9797", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9797", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9798", product: "GCR" },
      { airline: "EK", commodityCode: "9798", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9798", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MISCELLANEOUS ITEMS........",
    label: "Handicrafts made of metal, wood, cork, straw, excluding textiles, leather, and diamonds.",
    airline: [
      { airline: "EK", commodityCode: "9996", product: "GCR" },
      { airline: "EK", commodityCode: "9996", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9996", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9999", product: "GCR" },
      { airline: "EK", commodityCode: "9999", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOBILE PHONE ACCESSORIES, PARTS/COMPONENTS FOR THE MANUFACTURE OF TELECOMMUNICATION EQUIPMENT",
    label: "Mobile Phone Accessories, Parts and Components for the Manufacture of Telecommunication Equipment",
    airline: [
      { airline: "EK", commodityCode: "4422", product: "GCR" },
      { airline: "EK", commodityCode: "4422", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4422", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOBILE PHONES, MOBILE PHONES,AUTOMOBILE RADIOS, DICTATION MACHINES, HEARING AIDS, RECORDS, RECORDING",
    label: "Mobile Phones, Automobile Radios, Dictation Machines, Hearing Aids, Records, Recording",
    airline: [
      { airline: "EK", commodityCode: "4416", product: "GCR" },
      { airline: "EK", commodityCode: "4416", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4492", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOBILE PHONES, TELEPHONE EQUIPMENT, RADIO-TELEPHONE EQUIPMENT - INCLUDING TESTING EQUIPMENT -",
    label: "Mobile Phones, Telephone Equipment, Radio-Telephone Equipment - Including Testing Equipment",
    airline: [
      { airline: "EK", commodityCode: "4419", product: "GCR" },
      { airline: "EK", commodityCode: "4419", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4492", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MODEL ELECTRIC RAILWAYS ELECTRIC TOYS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9214", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOSQUITO COILS",
    label: "Mosquito Coils",
    airline: [
      { airline: "EK", commodityCode: "6202", product: "GCR" },
      { airline: "EK", commodityCode: "6202", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6202", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOTION PICTURE FILMS",
    label: "Motion Picture Films",
    airline: [
      { airline: "EK", commodityCode: "8425", product: "GCR" },
      { airline: "EK", commodityCode: "8425", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8425", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOTION PICTURE FILMS (INCL ADVTG MTRLS)",
    label: "Motion Picture Films (Including Advertising Materials)",
    airline: [
      { airline: "EK", commodityCode: "8426", product: "GCR" },
      { airline: "EK", commodityCode: "8426", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8426", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOTION PICTURE FILMS EXCL NEWSFEEL FILMS",
    label: "Motion Picture Films",
    airline: [
      { airline: "QR", commodityCode: "8431", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8425", product: "GCR" },
      { airline: "EK", commodityCode: "8425", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOTOR ASSISTED BITRIMOTORCYCLESMOTORSCOOTERS",
    label: "Motor Scooters, Motorcycles, Cycles, Parts of Surface Vehicles, including",
    airline: [
      { airline: "QR", commodityCode: "4220", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4235", product: "GCR" },
      { airline: "EK", commodityCode: "4235", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOTORCAR CUSHIONS BACKRESTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4221", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOTORCYCLESMOTORSCOOTERSBICYCLES BOXED",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4228", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOTORS, GENERATORS, TRANSFORMERS - ELECTRIC",
    label: "Motors, Generators, Transformers - Electric",
    airline: [
      { airline: "EK", commodityCode: "4560", product: "GCR" },
      { airline: "EK", commodityCode: "4560", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4560", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOTORSCOOTERS,MOTORCYCLES,CYCLES,PART OF SURFACE VEHICLES,IN",
    label: "Motor Scooters, Motorcycles, Cycles, Parts of Surface Vehicles, including",
    airline: [
      { airline: "EK", commodityCode: "4235", product: "GCR" },
      { airline: "EK", commodityCode: "4235", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4235", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOULDING DEVICES",
    label: "Molding Devices",
    airline: [
      { airline: "EK", commodityCode: "4718", product: "GCR" },
      { airline: "EK", commodityCode: "4718", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4718", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MOULDING MACHINERY",
    label: "Molding Devices",
    airline: [
      { airline: "QR", commodityCode: "4719", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4718", product: "GCR" },
      { airline: "EK", commodityCode: "4718", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MOULDS, DIES",
    label: "Molds, Dies",
    airline: [
      { airline: "EK", commodityCode: "3963", product: "GCR" },
      { airline: "EK", commodityCode: "3963", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3963", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MUNITIONS OF WAR",
    label: "Guns, Firearms, Ammunition",
    airline: [
      { airline: "QR", commodityCode: "9310", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
      { airline: "EK", commodityCode: "9300", product: "GCR" },
      { airline: "EK", commodityCode: "9300", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MUSHROOMS, MUSHROOM SPAWN",
    label: "Mushrooms, Mushroom Products",
    airline: [
      { airline: "EK", commodityCode: "0850", product: "PXS" },
      { airline: "EK", commodityCode: "0850", product: "PXD" },
    ],
  },
  {
    value: "MUSIC BOXES RECORDING TAPEPHONOGRAPH RECORDS INCL ACCESSOR",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8201", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "MUSICAL INST,PHONOGRAPHS,PHONOGRAPH RECORDS,CASSETTE TAPES",
    label: "Musical Instruments, Phonographs, Phonograph Records, Cassette Tapes",
    airline: [
      { airline: "EK", commodityCode: "8200", product: "GCR" },
      { airline: "EK", commodityCode: "8200", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MUSICAL INSTRUMENTS",
    label: "Musical Instruments",
    airline: [
      { airline: "EK", commodityCode: "9713", product: "GCR" },
      { airline: "EK", commodityCode: "9713", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9713", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MUSICL INSTRMTS,MUSIC BOX,PHONOGRAPHS EXCL COMB WITH CLOCKS",
    label: "Musical Instruments, Music Box, Phonographs, excluding combined with clocks.",
    airline: [
      { airline: "EK", commodityCode: "8206", product: "GCR" },
      { airline: "EK", commodityCode: "8206", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "MUSICL INSTRMTS,PHONOGRAPH RCRDS,TAPE RECORDGS,SHEET MUSIC",
    label: "Musical Instruments, Phonograph Records, Tape Recordings, Sheet Music",
    airline: [
      { airline: "EK", commodityCode: "8211", product: "GCR" },
      { airline: "EK", commodityCode: "8211", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NATURAL RESINS",
    label: "Natural Resins",
    airline: [
      { airline: "EK", commodityCode: "6806", product: "GCR" },
      { airline: "EK", commodityCode: "6806", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6806", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWP/MAG/PERS/BOOKS",
    label: "Newspapers, Magazines, Periodicals",
    airline: [
      { airline: "EK", commodityCode: "7118", product: "GCR" },
      { airline: "EK", commodityCode: "7118", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPER,MAGS,PERIODICALS,BOOKS PRNTD MATTER,PHOTOGRAPHS",
    label: "Newspaper, Magazines, Periodicals, Books, Printed Matter, etc.",
    airline: [
      { airline: "EK", commodityCode: "7129", product: "GCR" },
      { airline: "EK", commodityCode: "7129", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPERS",
    label: "Newspapers",
    airline: [
      { airline: "EK", commodityCode: "7109", product: "GCR" },
      { airline: "EK", commodityCode: "7109", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPERS  DAILY",
    label: "Newspapers, Daily",
    airline: [
      { airline: "EK", commodityCode: "7107", product: "GCR" },
      { airline: "EK", commodityCode: "7107", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPERS AND MAGAZINES",
    label: "Newspapers and Magazines",
    airline: [
      { airline: "EK", commodityCode: "7120", product: "GCR" },
      { airline: "EK", commodityCode: "7120", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPERS, MAGAZINES",
    label: "Newspapers, Magazines",
    airline: [
      { airline: "EK", commodityCode: "7104", product: "GCR" },
      { airline: "EK", commodityCode: "7104", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPAPERS,MAGAZINES,PERIODICALS",
    label: "Newspapers, Magazines, Periodicals",
    airline: [
      { airline: "EK", commodityCode: "7110", product: "GCR" },
      { airline: "EK", commodityCode: "7110", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPEPRS,MAGAZINES,PERIODICALS,BOOKS",
    label: "Newspapers, Magazines, Periodicals",
    airline: [
      { airline: "EK", commodityCode: "7112", product: "GCR" },
      { airline: "EK", commodityCode: "7112", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NEWSPPR/MAGAZINES/PERIODCLS EXCL STAMPS,SHARECPNS,PRESS PHOT",
    label: "Newspapers, Magazines, Periodicals excluding Stamps, Share Coupons",
    airline: [
      { airline: "EK", commodityCode: "7102", product: "GCR" },
      { airline: "EK", commodityCode: "7102", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NUCLEAR REACTOR FUEL CONTAINERS,FUEL RAW MTRL CNTRS EMPTY",
    label: "Nuclear Reactor Fuel Containers, Fuel Raw Material Containers Empty",
    airline: [
      { airline: "EK", commodityCode: "9935", product: "GCR" },
      { airline: "EK", commodityCode: "9935", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9935", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NUCLEAR REACTOR PARTS INCL HEAT EXCHANGRS,CONTROL RODS,VALVE",
    label: "Nuclear Reactor Parts, including Heat Exchangers, Control Rods, and Valves",
    airline: [
      { airline: "EK", commodityCode: "9930", product: "GCR" },
      { airline: "EK", commodityCode: "9930", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9930", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NUTRIA SKINS",
    label: "Nutria Skins",
    airline: [
      { airline: "EK", commodityCode: "1196", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1196", product: "GCR" },
      { airline: "QR", commodityCode: "1196", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "NUTS",
    label: "Nuts",
    airline: [
      { airline: "EK", commodityCode: "0020", product: "PXS" },
      { airline: "EK", commodityCode: "0020", product: "GCR" },
      { airline: "EK", commodityCode: "0020", product: "PXD" },
    ],
  },
  {
    value: "NWP.,MAGS,PERIODICALS,BOOKS,PRINTED MATTER EXCL.POSTAGE STAM",
    label: "Newspapers, Magazines, Periodicals, Books, Printed Matter Excluding...",
    airline: [
      { airline: "EK", commodityCode: "7101", product: "GCR" },
      { airline: "EK", commodityCode: "7101", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OFFICE MACHINERY",
    label: "Office Machinery",
    airline: [
      { airline: "EK", commodityCode: "4300", product: "GCR" },
      { airline: "EK", commodityCode: "4300", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OFFICE MACHINES INCLUDING SUPPLIES",
    label: "Office Machines, Including Supplies",
    airline: [
      { airline: "EK", commodityCode: "4327", product: "GCR" },
      { airline: "EK", commodityCode: "4327", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OFFICE SUPPLIES  EXCLUDING MACHINERY",
    label: "Office Supplies, excluding Machinery",
    airline: [
      { airline: "EK", commodityCode: "9400", product: "GCR" },
      { airline: "EK", commodityCode: "9400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9400", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OIL COMPOUNDS  FOR PAINT",
    label: "Oil Compounds for Paint",
    airline: [
      { airline: "EK", commodityCode: "1728", product: "GCR" },
      { airline: "EK", commodityCode: "1728", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1728", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OILS  ANIMAL, VEGETABLE",
    label: "Oils, Animal, Vegetable",
    airline: [
      { airline: "EK", commodityCode: "1700", product: "GCR" },
      { airline: "EK", commodityCode: "1700", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5620", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OILS  REFINED",
    label: "Refined Oils",
    airline: [
      { airline: "EK", commodityCode: "5620", product: "GCR" },
      { airline: "EK", commodityCode: "5620", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5620", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OLIVE OIL",
    label: "Olive Oil",
    airline: [
      { airline: "EK", commodityCode: "1701", product: "GCR" },
      { airline: "EK", commodityCode: "1701", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5620", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OLIVES",
    label: "Olives",
    airline: [
      { airline: "EK", commodityCode: "0462", product: "PXS" },
      { airline: "EK", commodityCode: "0462", product: "PXD" },
    ],
  },
  {
    value: "OPIUM",
    label: "Opium",
    airline: [
      { airline: "EK", commodityCode: "6435", product: "GCR" },
      { airline: "EK", commodityCode: "6435", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "OPTICAL GOODSPHOTO AND PROJ EQPT",
    label: "OPTICAL GOODSPHOTOPROJ EQPT INCL SUPP DISPLAY ADVTG FOR MO",
    airline: [
      { airline: "QR", commodityCode: "8397", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8398", product: "GCR" },
      { airline: "EK", commodityCode: "8398", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "OPTICAL INSTRUMTSAPPARATUSGOODS AND SUPPLIES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8301", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "OPTICL INSTRUMTSAPPARATUSANDSUPPLIES CONSGND TO CERRO TO",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8302", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ORCHIDS",
    label: "Orchids",
    airline: [
      { airline: "EK", commodityCode: "1429", product: "PXS" },
      { airline: "EK", commodityCode: "1429", product: "PXD" },
    ],
  },
  {
    value: "ORE  EXCLUDING GOLD, SILVER, PLATINUM",
    label: "Ore, Excluding Gold, Silver, Platinum",
    airline: [
      { airline: "EK", commodityCode: "3895", product: "GCR" },
      { airline: "EK", commodityCode: "3895", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3895", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OUTBOARD MOTORS  INCL ACCESSORIES",
    label: "Outboard Motors, Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "4181", product: "GCR" },
      { airline: "EK", commodityCode: "4181", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4181", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OUTBOARD MOTORS FOR BOATS",
    label: "OUTBOARD MOTORS INCL ACCESSORIES",
    airline: [
      { airline: "QR", commodityCode: "4180", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4181", product: "GCR" },
      { airline: "EK", commodityCode: "4181", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "OUTSIZED CARGO",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9794", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "OVERCOATS,JACKETS,SKIRTS,SHIRTS,WAISTCOATS,TROUSERS-LEATHER",
    label: "Overcoats, Jackets, Skirts, Shirts, Waistcoats, and so on.",
    airline: [
      { airline: "EK", commodityCode: "2243", product: "GCR" },
      { airline: "EK", commodityCode: "2243", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2243", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "OVERHEAD TRACK TROLLEY CARRIER ANDOR PARTS FOR MTRL HNDLG",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8427", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PACKING MACHINERY WRAPPING MACHINERY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4758", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PAINT BRUSHES PAINT ROLLERS",
    label: "BRUSHES",
    airline: [
      { airline: "QR", commodityCode: "9541", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9540", product: "GCR" },
      { airline: "EK", commodityCode: "9540", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PAINTINGS, ETCHINGS,ENGRAVINGS",
    label: "Paintings, Etchings, Engravings",
    airline: [
      { airline: "EK", commodityCode: "9500", product: "GCR" },
      { airline: "EK", commodityCode: "9500", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAINTS/PIGMENTS/VARNISHES",
    label: "Paints, Pigments, Varnishes",
    airline: [
      { airline: "EK", commodityCode: "6750", product: "GCR" },
      { airline: "EK", commodityCode: "6750", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6005", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAPAYAS",
    label: "Papayas",
    airline: [
      { airline: "EK", commodityCode: "0486", product: "PXS" },
      { airline: "EK", commodityCode: "0486", product: "PXD" },
    ],
  },
  {
    value: "PAPAYAS, PINEAPPLES",
    label: "Papayas, Pineapples",
    airline: [
      { airline: "EK", commodityCode: "0487", product: "PXS" },
      { airline: "EK", commodityCode: "0487", product: "PXD" },
    ],
  },
  {
    value: "PAPER  SHEETS,ROLLS/EXCL PRNTD MATTER, PHOTOGRAPHIC PAPER",
    label: "Paper Sheets, Rolls (Excluding Printed Matter, Photographic Paper)",
    airline: [
      { airline: "EK", commodityCode: "7001", product: "GCR" },
      { airline: "EK", commodityCode: "7001", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAPER PACKAGING MATERIAL",
    label: "Paper Packaging Material",
    airline: [
      { airline: "EK", commodityCode: "7021", product: "GCR" },
      { airline: "EK", commodityCode: "7021", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7021", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAPER PATERNS",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "7080", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PAPER PRODUCTS",
    label: "PAPER PRODUCTS",
    airline: [
      { airline: "QR", commodityCode: "7000", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PAPER, PAPER PRODUCTS",
    label: "Paper, Paper Products",
    airline: [
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9721", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAPER,CARDBOARD-IN SHEETS,ROLLS/EXCL PRNTD MATTER,PHOTO PAPE",
    label: "Paper, cardboard in sheets, rolls, excluding printed matter",
    airline: [
      { airline: "EK", commodityCode: "7003", product: "GCR" },
      { airline: "EK", commodityCode: "7003", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7003", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PAPERPLASTIC IMPREGNATD WITH DYEG PIGMTS FOR IND TXTL PRNTG",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "7053", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PAPERRUBBER MFRS EXCL NEWSPAPERMAGSBOOKBRAILLE TYPE EQPT",
    label: "Paper, Paper Products",
    airline: [
      { airline: "QR", commodityCode: "7900", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PARI MUTUAL TOTALIZATORS INCL TICKET ROLLS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4375", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PARTS FOR DYE FILTERS",
    label: "Parts for Dye Filters",
    airline: [
      { airline: "EK", commodityCode: "4755", product: "GCR" },
      { airline: "EK", commodityCode: "4755", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4755", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS FOR ELECTRIC REFRIGERATORS",
    label: "Parts for Refrigerators and Cookers",
    airline: [
      { airline: "QR", commodityCode: "4466", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3574", product: "GCR" },
      { airline: "EK", commodityCode: "3574", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PARTS FOR RADIOS,RECORD PLAYERS,TELEVISIONS",
    label: "Parts for Radios, Record Players, Televisions",
    airline: [
      { airline: "EK", commodityCode: "4458", product: "GCR" },
      { airline: "EK", commodityCode: "4458", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4458", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS FOR REFRIGERATORS/COOKERS",
    label: "Parts for Refrigerators and Cookers",
    airline: [
      { airline: "EK", commodityCode: "3574", product: "GCR" },
      { airline: "EK", commodityCode: "3574", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3574", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS FOR SPORTING BOATS  INCL ACCESSORIES",
    label: "Parts for Sporting Boats, Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "4266", product: "GCR" },
      { airline: "EK", commodityCode: "4266", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4266", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS FR ROAD CONSTRUCTION MACHINERY,PARTS FOR GENERATORS",
    label: "Parts from Road Construction Machinery, Parts for Generators",
    airline: [
      { airline: "EK", commodityCode: "4741", product: "GCR" },
      { airline: "EK", commodityCode: "4741", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4741", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PARTS OF AUTOMOBILESMOTORSCOOTERSCYCLES ANDAGRI MACHINES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4204", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PARTS OF SURFACE VEHICLESAGRI MACHNRY EXCL STEAMMOTORSHIP",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9739", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PASTRY DOUGH",
    label: "Pastry Dough",
    airline: [
      { airline: "EK", commodityCode: "0514", product: "PXS" },
      { airline: "EK", commodityCode: "0514", product: "PXD" },
    ],
  },
  {
    value: "PATE DE FOIE GRAS",
    label: "Pâté de Foie Gras",
    airline: [
      { airline: "EK", commodityCode: "0606", product: "PXS" },
      { airline: "EK", commodityCode: "0606", product: "PXD" },
    ],
  },
  {
    value: "PENS, PENCILS  INCL DISPLAY MATERIAL",
    label: "Pens, Pencils, Including Display Material",
    airline: [
      { airline: "EK", commodityCode: "9473", product: "GCR" },
      { airline: "EK", commodityCode: "9473", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9473", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PENS, PENCILS  INCL STANDS, HOLDERS, CASES",
    label: "Pens, pencils, including stands, holders, and cases.",
    airline: [
      { airline: "EK", commodityCode: "9471", product: "GCR" },
      { airline: "EK", commodityCode: "9471", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9471", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PENS,PENCILS",
    label: "Pens, Pencils",
    airline: [
      { airline: "EK", commodityCode: "9470", product: "GCR" },
      { airline: "EK", commodityCode: "9470", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9470", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PERFUME, TOILET WATER",
    label: "Perfume, Toilet Water",
    airline: [
      { airline: "EK", commodityCode: "6631", product: "GCR" },
      { airline: "EK", commodityCode: "6631", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PERFUMES",
    label: "Perfumes",
    airline: [
      { airline: "EK", commodityCode: "6630", product: "GCR" },
      { airline: "EK", commodityCode: "6630", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PERSONAL EFF./HOUSEHOLD GDS. -NOT FOR RESALE",
    label: "Personal Effects / Household Goods - Not for Resale",
    airline: [
      { airline: "EK", commodityCode: "9716", product: "GCR" },
      { airline: "EK", commodityCode: "9716", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9716", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PERSONAL EFFECTSHOUSEHOLD EFFECTS OF GOVT OFFICERS TRAVELLI",
    label: "Household Goods, Personal Effects",
    airline: [
      { airline: "QR", commodityCode: "9980", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9998", product: "GCR" },
      { airline: "EK", commodityCode: "9998", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PEWTER PRODUCTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3161", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PHONOGRAPH PICK UPS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4407", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PHONOGRAPH RECORDS",
    label: "Phonograph Records",
    airline: [
      { airline: "EK", commodityCode: "8282", product: "GCR" },
      { airline: "EK", commodityCode: "8282", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8282", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHONOGRAPH RECORDS",
    label: "PHONOGRAPH RECORDS",
    airline: [
      { airline: "QR", commodityCode: "8275", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8282", product: "GCR" },
      { airline: "EK", commodityCode: "8282", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PHONOGRAPH RECORDS,RECORDING TAPE",
    label: "Phonograph Records, Recording Tape",
    airline: [
      { airline: "EK", commodityCode: "8280", product: "GCR" },
      { airline: "EK", commodityCode: "8280", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8280", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHOTO FILMS/PAPER-SENSITIZED,UNEXPSD/INCL PHOTO CHMCS,UNSENS",
    label: "Photo Films/Paper-Sensitized, Unexposed, Including Photo",
    airline: [
      { airline: "EK", commodityCode: "8430", product: "GCR" },
      { airline: "EK", commodityCode: "8430", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8430", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHOTO-TYPESETTING MACHINES",
    label: "Photo-Typesetting Machines",
    airline: [
      { airline: "EK", commodityCode: "4304", product: "GCR" },
      { airline: "EK", commodityCode: "4304", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4304", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHOTOCOPYING MACHINS  INCL ACCESSORIES, SUPPLIES",
    label: "Photocopying Machines, Including Accessories and Supplies",
    airline: [
      { airline: "EK", commodityCode: "4322", product: "GCR" },
      { airline: "EK", commodityCode: "4322", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4307", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PHOTOGRAPHIC SENSITIZED PAPER",
    label: "Photographic Sensitized Paper",
    airline: [
      { airline: "EK", commodityCode: "7046", product: "GCR" },
      { airline: "EK", commodityCode: "7046", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7046", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PIECE GOODS  MADE OF NYLON",
    label: "Piece Goods Made of Nylon",
    airline: [
      { airline: "EK", commodityCode: "2162", product: "GCR" },
      { airline: "EK", commodityCode: "2162", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2162", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PIGS",
    label: "Pigs",
    airline: [
      { airline: "EK", commodityCode: "1074", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "9741", product: "GCR" },
      { airline: "EK", commodityCode: "9741", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PINEAPPLES",
    label: "Pineapples",
    airline: [
      { airline: "EK", commodityCode: "0485", product: "PXS" },
      { airline: "EK", commodityCode: "0485", product: "PXD" },
    ],
  },
  {
    value: "PIPES  SMOKING",
    label: "Pipes, Smoking",
    airline: [
      { airline: "EK", commodityCode: "9615", product: "GCR" },
      { airline: "EK", commodityCode: "9615", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9615", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PIPES AND SMOKERS ARTICLES",
    label: "PIPES SMOKING",
    airline: [
      { airline: "QR", commodityCode: "9600", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9615", product: "GCR" },
      { airline: "EK", commodityCode: "9615", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PIPES PIPE FITTINGS PIPE FLANGES HOSES",
    label: "Pipes, Pipe Fittings",
    airline: [
      { airline: "QR", commodityCode: "4901", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4902", product: "GCR" },
      { airline: "EK", commodityCode: "4902", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PIPES, PIPE FITTINGS",
    label: "Pipes, Pipe Fittings",
    airline: [
      { airline: "EK", commodityCode: "4902", product: "GCR" },
      { airline: "EK", commodityCode: "4902", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4902", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PIPES,PIPE FITTINGS,SPRINKLER SYSTEMS",
    label: "Pipes, Pipe Fittings, Sprinkler",
    airline: [
      { airline: "EK", commodityCode: "4753", product: "GCR" },
      { airline: "EK", commodityCode: "4753", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4753", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PISTONS, PISTON RINGS",
    label: "Pistons, Piston Assemblies",
    airline: [
      { airline: "EK", commodityCode: "4969", product: "GCR" },
      { airline: "EK", commodityCode: "4969", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4969", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLANT HANGERS KNITTED",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9966", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PLANTS  EXCL. ORCHIDS",
    label: "Plants excluding Orchids",
    airline: [
      { airline: "EK", commodityCode: "1476", product: "PXD" },
      { airline: "EK", commodityCode: "1476", product: "PXS" },
    ],
  },
  {
    value: "PLANTS-FLWS,BLBS,SDS,FLORAL/NURSERY STKS,DPLY MATS EXPO USE",
    label: "Plants, flowers, bulbs, seeds, floral and nursery stocks, display materials for exposition use.",
    airline: [
      { airline: "EK", commodityCode: "9989", product: "GCR" },
      { airline: "EK", commodityCode: "9989", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9991", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC ARTICLES  USED IN ANIMAL HUSBANDRY",
    label: "Plastic Articles Used in Animal Husbandry",
    airline: [
      { airline: "EK", commodityCode: "6857", product: "GCR" },
      { airline: "EK", commodityCode: "6857", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6857", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC ARTICLES (FOR HOUSEHOLD USE)",
    label: "Plastic Articles for Household Use",
    airline: [
      { airline: "EK", commodityCode: "6827", product: "GCR" },
      { airline: "EK", commodityCode: "6827", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6827", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC ARTICLES,WOOD,WOOD PRODUCTS",
    label: "Plastic Articles, Wood, Wood Products",
    airline: [
      { airline: "EK", commodityCode: "9723", product: "GCR" },
      { airline: "EK", commodityCode: "9723", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9723", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC BLOOD BAGS, CELLOPHANE, POLYETHYLENE BAGS, ROLLS (FOR WRAPPING)",
    label: "Plastic Blood Bags, Cellophane, Polyethylene Bags, Rolls (For Wrapping)",
    airline: [
      { airline: "EK", commodityCode: "6847", product: "GCR" },
      { airline: "EK", commodityCode: "6847", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6847", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC COATED FABRICS NOT FRTHR PRCSSD/MFD/EXCLSVLY IN BALE",
    label: "Plastic Coated Fabrics, Not Further Processed or Manufactured",
    airline: [
      { airline: "EK", commodityCode: "2144", product: "GCR" },
      { airline: "EK", commodityCode: "2144", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2144", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC CONTAINERS",
    label: "Plastic Containers",
    airline: [
      { airline: "EK", commodityCode: "6855", product: "GCR" },
      { airline: "EK", commodityCode: "6855", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6855", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC DOILIES",
    label: "Plastic Doilies",
    airline: [
      { airline: "EK", commodityCode: "6817", product: "GCR" },
      { airline: "EK", commodityCode: "6817", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6817", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC FOILS PLASTIC SHEETS",
    label: "Plastic Articles",
    airline: [
      { airline: "QR", commodityCode: "6807", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PLASTIC INJECTION MOULDING MACHINERY",
    label: "Plastic Injection Moulding Machinery",
    airline: [
      { airline: "EK", commodityCode: "4757", product: "GCR" },
      { airline: "EK", commodityCode: "4757", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4757", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC KITCHEN/TABLE/DECORATIVE WARE, TOYS",
    label: "Plastic Kitchen/Table/Decorative Ware, Toys",
    airline: [
      { airline: "EK", commodityCode: "6824", product: "GCR" },
      { airline: "EK", commodityCode: "6824", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6824", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC PACKAGING MATERIAL",
    label: "Plastic Articles",
    airline: [
      { airline: "QR", commodityCode: "6831", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PLASTIC SURGICAL EQUIPMENT, HUMAN PLASMA",
    label: "Plastic Surgical Equipment, Human Plasma",
    airline: [
      { airline: "EK", commodityCode: "6110", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLASTIC TUBING PLASTIC GRANULES ELECTRIC WRING",
    label: "Plastic Articles",
    airline: [
      { airline: "QR", commodityCode: "4478", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "GCR" },
      { airline: "EK", commodityCode: "6810", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PLATINOID MINERAL CONCENTRADES, MATTE",
    label: "Platinoid Mineral Concentrates, Matte",
    airline: [
      { airline: "EK", commodityCode: "3011", product: "GCR" },
      { airline: "EK", commodityCode: "3011", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3011", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PLYWOOD, VENEERWOOD",
    label: "Plywood, Veneers, Etc.",
    airline: [
      { airline: "EK", commodityCode: "7601", product: "GCR" },
      { airline: "EK", commodityCode: "7601", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7601", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PNEUMATIC EQUIPMENT, HYDRAULIC EQUIPMENT, TOOLS",
    label: "Pneumatic Equipment, Hydraulic Equipment, Tools",
    airline: [
      { airline: "EK", commodityCode: "4954", product: "GCR" },
      { airline: "EK", commodityCode: "4954", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4954", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "POLISHES,PASTE,POWDERS,PREPARATIONS-ISED FOR POLISHING,PRESE",
    label: "Polishes, Pastes, Powders, and Preparations Used for Polishing",
    airline: [
      { airline: "EK", commodityCode: "6901", product: "GCR" },
      { airline: "EK", commodityCode: "6901", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6901", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "POLYPROPYLENE FILM METALISED /GRANULES",
    label: "Polypropylene Film Metallized / Granules",
    airline: [
      { airline: "EK", commodityCode: "6030", product: "GCR" },
      { airline: "EK", commodityCode: "6030", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6030", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PORK, CHICKEN - CHILLED OR FROZEN",
    label: "Pork, Chicken - Chilled or Frozen",
    airline: [
      { airline: "EK", commodityCode: "0651", product: "PXS" },
      { airline: "EK", commodityCode: "0651", product: "PXD" },
    ],
  },
  {
    value: "PORTABLE ELECTRONIC CALCULATORS",
    label: "Electronic Products",
    airline: [
      { airline: "QR", commodityCode: "4305", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4329", product: "GCR" },
      { airline: "EK", commodityCode: "4329", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "POTTERY",
    label: "Sanitary Articles Made of Pottery, Porcelain",
    airline: [
      { airline: "QR", commodityCode: "5210", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5235", product: "GCR" },
      { airline: "EK", commodityCode: "5235", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "POTTERY, CERAMICS",
    label: "Pottery, Ceramics",
    airline: [
      { airline: "EK", commodityCode: "5295", product: "GCR" },
      { airline: "EK", commodityCode: "5295", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5295", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "POTTERY,CHINA/EARTHEN/CRYSTALWARE,PORCELAIN WHOLLY IRISH MFR",
    label: "Pottery, China, Earthenware, Crystalware, Porcelain Wholly",
    airline: [
      { airline: "EK", commodityCode: "5297", product: "GCR" },
      { airline: "EK", commodityCode: "5297", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5297", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "POTTERY,CHINA/EARTHEN/STONE/CRYSTAL/GLASSWARE EXCL ARTIFCL S",
    label: "Pottery, China, Earthenware, Stoneware, Crystal, Glassware, Excluding...",
    airline: [
      { airline: "EK", commodityCode: "5299", product: "GCR" },
      { airline: "EK", commodityCode: "5299", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5299", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "POULTRY, GAME",
    label: "Poultry, Game",
    airline: [
      { airline: "EK", commodityCode: "0640", product: "PXS" },
      { airline: "EK", commodityCode: "0640", product: "PXD" },
    ],
  },
  {
    value: "POWER AMPLIFIERS MOTORS ELECTRIC",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4561", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PREFABRICATED HOUSES RELATED OUTFIT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9955", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PRINTED CIRCUITS",
    label: "Printed Circuits",
    airline: [
      { airline: "EK", commodityCode: "4505", product: "GCR" },
      { airline: "EK", commodityCode: "4505", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4521", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER",
    label: "Printed Matter",
    airline: [
      { airline: "EK", commodityCode: "9737", product: "GCR" },
      { airline: "EK", commodityCode: "9737", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER  EXCL NEWSPAPERS",
    label: "Printed Matter, Excluding Newspapers",
    airline: [
      { airline: "EK", commodityCode: "7122", product: "GCR" },
      { airline: "EK", commodityCode: "7122", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER  EXCLUDING NEWSPAPERS",
    label: "Printed matter, excluding newspapers",
    airline: [
      { airline: "EK", commodityCode: "9738", product: "GCR" },
      { airline: "EK", commodityCode: "9738", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER, PAPER-INCL PHOTOGRAPHIC,SENSITIZED PAPER-EXC",
    label: "Printed Matter, Paper - Including Photographic and Sensitized Paper - Excluding",
    airline: [
      { airline: "EK", commodityCode: "7011", product: "GCR" },
      { airline: "EK", commodityCode: "7011", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7011", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER,PAPER-INCL PHOTO SENSITIZED PAPER EXCL NEWSPAPER",
    label: "Printed Matter, Paper, Including Photo-Sensitized Paper, Excluding Newspapers",
    airline: [
      { airline: "EK", commodityCode: "9728", product: "GCR" },
      { airline: "EK", commodityCode: "9728", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9728", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER,PAPER-INCLUDING PHOTOGRAPHIC/SENSITIZED PAPER",
    label: "Printed Matter, Paper, Including Photographic or Sensitized Paper",
    airline: [
      { airline: "EK", commodityCode: "9710", product: "GCR" },
      { airline: "EK", commodityCode: "9710", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTED MATTER........",
    label: "Printed Matter",
    airline: [
      { airline: "EK", commodityCode: "7126", product: "GCR" },
      { airline: "EK", commodityCode: "7126", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7127", product: "GCR" },
      { airline: "EK", commodityCode: "7127", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "7128", product: "GCR" },
      { airline: "EK", commodityCode: "7128", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PRINTER FOR PERSONAL COMPUTER",
    label: "Printer for Personal Computer",
    airline: [
      { airline: "EK", commodityCode: "4324", product: "GCR" },
      { airline: "EK", commodityCode: "4324", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4300", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTER MATTER",
    label: "Printed Matter",
    airline: [
      { airline: "EK", commodityCode: "7100", product: "GCR" },
      { airline: "EK", commodityCode: "7100", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9710", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PRINTING INK/LACQUERS, RUBBER STAMPS, INK PAD",
    label: "Printing Ink/Lacquers, Rubber Stamps, Ink",
    airline: [
      { airline: "EK", commodityCode: "6751", product: "GCR" },
      { airline: "EK", commodityCode: "6751", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6751", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PROCESS CONTROL EQUIPMENT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8557", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PROJECTORS ASSEMBLED",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8452", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PROJN EQPT INCL SUPP/ACCS EXCL NEWSREEL,35MM FILM EXPOSED",
    label: "Projection Equipment, Including Supplies and Accessories, Excluding Newsreel",
    airline: [
      { airline: "EK", commodityCode: "8395", product: "GCR" },
      { airline: "EK", commodityCode: "8395", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8395", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PROSTHESES",
    label: "Leather, Leather Products Excluding Sporting Goods",
    airline: [
      { airline: "EK", commodityCode: "8183", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PULLOVERS, CARDIGANS",
    label: "Pullovers, Cardigans",
    airline: [
      { airline: "EK", commodityCode: "2452", product: "GCR" },
      { airline: "EK", commodityCode: "2452", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2452", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PUMPING FIXTURES, PIPE FIXTURES",
    label: "Pumping Fixtures, Pipe Fixtures",
    airline: [
      { airline: "EK", commodityCode: "3503", product: "GCR" },
      { airline: "EK", commodityCode: "3503", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3503", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PUMPS",
    label: "FILTERS PUMPS",
    airline: [
      { airline: "QR", commodityCode: "4732", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4754", product: "GCR" },
      { airline: "EK", commodityCode: "4754", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "PUNCH CARS,TAPE,DATA SHEETS/DISCS FR ELCTRNC DATA STORAGE-PR",
    label: "Punch Cards, Tape, Data Sheets/Discs from Electronic Data Processing Machines",
    airline: [
      { airline: "EK", commodityCode: "4317", product: "GCR" },
      { airline: "EK", commodityCode: "4317", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4317", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PURSES,HANDBAGS,WALLETS,BRIEFCASES,SCHOOL BAGS-OF LEATHER",
    label: "Purses, Handbags, Wallets, Briefcases, School Bags",
    airline: [
      { airline: "EK", commodityCode: "9553", product: "GCR" },
      { airline: "EK", commodityCode: "9553", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9553", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "PYRETHRUM EXTRACT",
    label: "Pyrethrum Extract",
    airline: [
      { airline: "EK", commodityCode: "6227", product: "GCR" },
      { airline: "EK", commodityCode: "6227", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6227", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "QUARTZ",
    label: "Quartz",
    airline: [
      { airline: "EK", commodityCode: "5700", product: "GCR" },
      { airline: "EK", commodityCode: "5700", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5700", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "QUARTZ MANUFACTURES",
    label: "Quartz Manufactures",
    airline: [
      { airline: "EK", commodityCode: "5750", product: "GCR" },
      { airline: "EK", commodityCode: "5750", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5750", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "QUARTZ SILICA PRODUCTS",
    label: "Quartz Manufactures",
    airline: [
      { airline: "QR", commodityCode: "5708", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5750", product: "GCR" },
      { airline: "EK", commodityCode: "5750", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "QUININE  ALKALOID",
    label: "Quinine Alkaloid",
    airline: [
      { airline: "EK", commodityCode: "6271", product: "GCR" },
      { airline: "EK", commodityCode: "6271", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RABBIT HAIR UNMANUFACTURED",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "1930", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RADAR EQUIPMENT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4498", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RADIOACTIVE MTRLS  FOR MEDICAL/LABORATORY USE",
    label: "Radioactive Materials for Medical or Laboratory Use",
    airline: [
      { airline: "EK", commodityCode: "6012", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RADIOS, TV, RADIO-TV SETS, PHONOGRAPH SETS",
    label: "Radios, Televisions, Radio-Television Sets, Phonographs",
    airline: [
      { airline: "EK", commodityCode: "4420", product: "GCR" },
      { airline: "EK", commodityCode: "4420", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RADIOS,ELECTRONIC TUBES,TRANSISTORS,SOLID-STATE SEMI-CONDUCT",
    label: "Radios, Electronic Tubes, Transistors, Solid-State Semiconductors",
    airline: [
      { airline: "EK", commodityCode: "4440", product: "GCR" },
      { airline: "EK", commodityCode: "4440", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RADIOS,TELEVISIONS,RECORD PLAYERS,TAPE RECORDERS",
    label: "Radios, Televisions, Record Players, Tape Recorders",
    airline: [
      { airline: "EK", commodityCode: "4411", product: "GCR" },
      { airline: "EK", commodityCode: "4411", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RADIOS,TV,RADIO-TV SETS,RADIO-PHONOGRAPH SETS,ELEC HSHLD APP",
    label: "Radios, Televisions, Radio-Television Sets, Radio-Phonograph Sets, Electrical",
    airline: [
      { airline: "EK", commodityCode: "4417", product: "GCR" },
      { airline: "EK", commodityCode: "4417", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RAIODS, TAPE RECORDS, RECORD PLAYERS, AERIALS",
    label: "Radios, Tape Recorders, Record Players, Aerials",
    airline: [
      { airline: "EK", commodityCode: "4415", product: "GCR" },
      { airline: "EK", commodityCode: "4415", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4415", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RAIODS,TVS,RCRD PLAYRS,TAPE RCRDERS,LOUDSPKRS,AMPLIFIERS",
    label: "Radios, Televisions, Record Players, Tape Recorders, Loudspeakers",
    airline: [
      { airline: "EK", commodityCode: "4413", product: "GCR" },
      { airline: "EK", commodityCode: "4413", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4425", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RASPBERRIES",
    label: "Raspberries",
    airline: [
      { airline: "EK", commodityCode: "0494", product: "PXS" },
      { airline: "EK", commodityCode: "0494", product: "PXD" },
    ],
  },
  {
    value: "RAZOR BLADES",
    label: "RAZORS RAZOR BLADES",
    airline: [
      { airline: "QR", commodityCode: "3126", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "3127", product: "GCR" },
      { airline: "EK", commodityCode: "3127", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RAZORS, RAZOR BLADES",
    label: "Razors, Razor Blades",
    airline: [
      { airline: "EK", commodityCode: "3127", product: "GCR" },
      { airline: "EK", commodityCode: "3127", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3127", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RECORD PLAYERS TAPE RECORDERS",
    label: "Radios, Televisions, Record Players, Tape Recorders",
    airline: [
      { airline: "QR", commodityCode: "4421", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4411", product: "GCR" },
      { airline: "EK", commodityCode: "4411", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RECORDING MACHINES USING TAPE WIRE DISC",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4336", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RECORDING TAPES,CASSETTES,PHONOGRAPH RECORDS,FILMS",
    label: "Recording Tapes, Cassettes, Phonograph Records, Films",
    airline: [
      { airline: "EK", commodityCode: "8281", product: "GCR" },
      { airline: "EK", commodityCode: "8281", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8281", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RECORDS, RECORDING TAPE, RECORDING WIRE",
    label: "Records, Recording Tape, Recording Wire",
    airline: [
      { airline: "EK", commodityCode: "8277", product: "GCR" },
      { airline: "EK", commodityCode: "8277", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8277", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RELAYS",
    label: "Relays",
    airline: [
      { airline: "EK", commodityCode: "4428", product: "GCR" },
      { airline: "EK", commodityCode: "4428", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4428", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RELIGIOUS ARTICLES EXCL.PRINTED MATTER PICTURES,VESTMENTS",
    label: "Religious Articles excluding Printed Matter Pictures, Vestments",
    airline: [
      { airline: "EK", commodityCode: "9560", product: "GCR" },
      { airline: "EK", commodityCode: "9560", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9560", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RELIGIOUS BOOKS",
    label: "Religious Books",
    airline: [
      { airline: "EK", commodityCode: "7123", product: "GCR" },
      { airline: "EK", commodityCode: "7123", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9560", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "REPTILE SKINS",
    label: "Reptile Skins",
    airline: [
      { airline: "EK", commodityCode: "1190", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1190", product: "GCR" },
      { airline: "QR", commodityCode: "1190", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RESISTORS,RHEOSTATS,ELECTRIC SWITCHES",
    label: "Resistors, Rheostats, Electric Switches",
    airline: [
      { airline: "EK", commodityCode: "4431", product: "GCR" },
      { airline: "EK", commodityCode: "4431", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4431", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RESISTORS,TRANSISTORS,CAPACITORS,REGULATORS,TUNERS",
    label: "Resistors, Transistors, Capacitors, Regulators, Tubes",
    airline: [
      { airline: "EK", commodityCode: "4439", product: "GCR" },
      { airline: "EK", commodityCode: "4439", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4439", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RIVETING TOOLS RIVETS",
    label: "Tools",
    airline: [
      { airline: "QR", commodityCode: "3271", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ROLLER SKATE WHEELS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9235", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "ROLLS,SHEETS,SLABS,UNFINISHED FORMS-MADE OF RUBBER",
    label: "Rolls, Sheets, Slabs, Unfinished Forms - Made",
    airline: [
      { airline: "EK", commodityCode: "7415", product: "GCR" },
      { airline: "EK", commodityCode: "7415", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7415", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "ROOTS AND SPICES",
    label: "Roots and Spices",
    airline: [
      { airline: "EK", commodityCode: "0700", product: "PXS" },
      { airline: "EK", commodityCode: "0700", product: "PXD" },
    ],
  },
  {
    value: "ROSE PETALS",
    label: "Rose Petals",
    airline: [
      { airline: "EK", commodityCode: "1411", product: "PXS" },
      { airline: "EK", commodityCode: "1411", product: "PXD" },
    ],
  },
  {
    value: "RUBBER BELTS,RUBBER BELTING",
    label: "Rubber Belts, Rubber Belting",
    airline: [
      { airline: "EK", commodityCode: "7425", product: "GCR" },
      { airline: "EK", commodityCode: "7425", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7425", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RUBBER BOOTS",
    label: "Rubber Boots",
    airline: [
      { airline: "EK", commodityCode: "7437", product: "GCR" },
      { airline: "EK", commodityCode: "7437", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7437", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RUBBER DOUCHE BAG SETS",
    label: "Rubber Goods",
    airline: [
      { airline: "QR", commodityCode: "7431", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RUBBER GLOVES",
    label: "RUBBER GOODS",
    airline: [
      { airline: "QR", commodityCode: "7440", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "GCR" },
      { airline: "EK", commodityCode: "7420", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "RUBBER SEALS",
    label: "Rubber Seals",
    airline: [
      { airline: "EK", commodityCode: "7448", product: "GCR" },
      { airline: "EK", commodityCode: "7448", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7448", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RUBBER TYRES, RUBBER TUBES",
    label: "Rubber Tires, Rubber Tubes",
    airline: [
      { airline: "EK", commodityCode: "7481", product: "GCR" },
      { airline: "EK", commodityCode: "7481", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7481", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "RUBBER, RUBBER PRODUCTS",
    label: "Rubber, Rubber Products",
    airline: [
      { airline: "EK", commodityCode: "7400", product: "GCR" },
      { airline: "EK", commodityCode: "7400", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7400", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SADDLES, RIDING EQPT",
    label: "Saddles, Riding Equipment",
    airline: [
      { airline: "EK", commodityCode: "9208", product: "GCR" },
      { airline: "EK", commodityCode: "9208", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9208", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SAFETY EQPT AND APPARATUS,GENERIC ITEM OF DENTAL/MEDI/OPTICAL",
    label: "Safety Equipment and Apparatus, Generic Item of Dental, Medical, Optical",
    airline: [
      { airline: "EK", commodityCode: "8550", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SAFETY EQPT SAFETY APPARATUS",
    label: "Safety Equipment and Apparatus, Generic Item of Dental, Medical, Optical",
    airline: [
      { airline: "QR", commodityCode: "8500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "8550", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SALMON",
    label: "Salmon",
    airline: [
      { airline: "EK", commodityCode: "0340", product: "PXS" },
      { airline: "EK", commodityCode: "0340", product: "PXD" },
    ],
  },
  {
    value: "SANDALWOOD",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "7606", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SANITARY ARTICLES  MADE OF POTTERY,PORCELAIN",
    label: "Sanitary Articles Made of Pottery, Porcelain",
    airline: [
      { airline: "EK", commodityCode: "5235", product: "GCR" },
      { airline: "EK", commodityCode: "5235", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "5235", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCAFFOLDING",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3323", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SCALE MODELS  SHIPS",
    label: "Scale Models of Ships",
    airline: [
      { airline: "EK", commodityCode: "9215", product: "GCR" },
      { airline: "EK", commodityCode: "9215", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9215", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCI/PRECISION INSTRMTS,LAB EQPT(INCL SUPPL), WATCHES, CLOCKS",
    label: "Scientific and Precision Instruments, Laboratory Equipment (Including Supplies), Watches",
    airline: [
      { airline: "EK", commodityCode: "9711", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCIENTIFIC/LAB INSTRMTS INCL APPARATUS",
    label: "Scientific/Laboratory Instruments Including Apparatus",
    airline: [
      { airline: "EK", commodityCode: "8601", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCIENTIFIC/LAB INSTRMTS INCL APPARATUS, SUPPLIES",
    label: "Scientific/Lab Instruments including Apparatus, Supplies",
    airline: [
      { airline: "EK", commodityCode: "8600", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCIENTIFIC/PRECISION INSTRUMENTS EXCL WATCHES/CLOCKS",
    label: "Scientific/Precision Instruments excluding Watches/Clocks",
    airline: [
      { airline: "EK", commodityCode: "8001", product: "GCR" },
      { airline: "EK", commodityCode: "8001", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SCIENTIFIC/PRECISION/DENTAL/SURGICAL INST.,WATCHES,CLOCKS",
    label: "Scientific, Precision, Dental, Surgical Instruments, Watches, Clocks",
    airline: [
      { airline: "EK", commodityCode: "8002", product: "GCR" },
      { airline: "EK", commodityCode: "8002", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEA SHELLS",
    label: "Sea Flora, Sea Sponges",
    airline: [
      { airline: "QR", commodityCode: "1971", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "1970", product: "GCR" },
      { airline: "EK", commodityCode: "1970", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SEA URCHIN/PROCESSED",
    label: "Sea Urchin Processed",
    airline: [
      { airline: "EK", commodityCode: "0304", product: "PXS" },
      { airline: "EK", commodityCode: "0304", product: "PXD" },
    ],
  },
  {
    value: "SEA-FLORA, SHELLS",
    label: "Sea Flora, Sea Sponges",
    airline: [
      { airline: "EK", commodityCode: "1970", product: "GCR" },
      { airline: "EK", commodityCode: "1970", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1970", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEA-URCHIN",
    label: "Sea Urchin",
    airline: [
      { airline: "EK", commodityCode: "0305", product: "PXS" },
      { airline: "EK", commodityCode: "0305", product: "PXD" },
    ],
  },
  {
    value: "SEALING RINGS  MADE OF ARTIFICIAL RUBBER",
    label: "Sealing Rings Made of Artificial Rubber",
    airline: [
      { airline: "EK", commodityCode: "7483", product: "GCR" },
      { airline: "EK", commodityCode: "7483", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7483", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SECURITY PAPER",
    label: "Security Paper",
    airline: [
      { airline: "EK", commodityCode: "7026", product: "GCR" },
      { airline: "EK", commodityCode: "7026", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7000", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEEDS",
    label: "Seeds",
    airline: [
      { airline: "EK", commodityCode: "1485", product: "GCR" },
      { airline: "EK", commodityCode: "1485", product: "PXD" },
      { airline: "EK", commodityCode: "1485", product: "PXS" },
    ],
  },
  {
    value: "SEEDS, PLANTS",
    label: "Seeds, Plants",
    airline: [
      { airline: "EK", commodityCode: "1479", product: "PXD" },
      { airline: "EK", commodityCode: "1479", product: "PXS" },
    ],
  },
  {
    value: "SELF-ADHESIVE LABELS",
    label: "Self-Adhesive Labels",
    airline: [
      { airline: "EK", commodityCode: "7179", product: "GCR" },
      { airline: "EK", commodityCode: "7179", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7179", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEMI CONDUCTOR DEVICES",
    label: "ELEC TUBESTRANSISTORSSOLID STATE SEMI CONDUCTOR DEVICES",
    airline: [
      { airline: "QR", commodityCode: "4438", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4435", product: "GCR" },
      { airline: "EK", commodityCode: "4435", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SEMI FINISHED CLOTHING",
    label: "Cloth, Ladies Cut Dresses, Semi-Finished Clothing Including Dressmaking",
    airline: [
      { airline: "QR", commodityCode: "2259", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2215", product: "GCR" },
      { airline: "EK", commodityCode: "2215", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SEMI-CONDUCTORS",
    label: "Semiconductors",
    airline: [
      { airline: "EK", commodityCode: "4504", product: "GCR" },
      { airline: "EK", commodityCode: "4504", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4438", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEMI-PRECIOUS STONES",
    label: "Semi-Precious Stones",
    airline: [
      { airline: "EK", commodityCode: "5851", product: "GCR" },
      { airline: "QR", commodityCode: "5858", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SEWING MACHINES  INCL ACCESSORIES, SUPPLIES",
    label: "Sewing Machines, including Accessories and Supplies",
    airline: [
      { airline: "EK", commodityCode: "4789", product: "GCR" },
      { airline: "EK", commodityCode: "4789", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4789", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHARK FINS",
    label: "SHARK FINS",
    airline: [
      { airline: "EK", commodityCode: "0370", product: "PXS" },
      { airline: "EK", commodityCode: "0370", product: "PXD" },
    ],
  },
  {
    value: "SHEEP",
    label: "Sheep",
    airline: [
      { airline: "EK", commodityCode: "1052", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SHEEP SKIN COATS,OVERCOATS,HATS,SLIPPERS-HANDMADE",
    label: "Sheepskin Coats, Overcoats, Hats, Slippers",
    airline: [
      { airline: "EK", commodityCode: "2189", product: "GCR" },
      { airline: "EK", commodityCode: "2189", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2189", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHEETSTUBINGWIRE MADE OF TUNGSTENTANTALUMOLYBDENUM",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3096", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SHELLFISH",
    label: "Shellfish",
    airline: [
      { airline: "EK", commodityCode: "0309", product: "PXS" },
      { airline: "EK", commodityCode: "0309", product: "PXD" },
    ],
  },
  {
    value: "SHIRTS, BLOUSES, UNDERWEAR",
    label: "Shirts, blouses, underwear",
    airline: [
      { airline: "EK", commodityCode: "2408", product: "GCR" },
      { airline: "EK", commodityCode: "2408", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2408", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHOE LEATHER ALONE OR TOGETHER WITH OTHER SHOE MFG MTRLS",
    label: "Shoe Leather Alone or Together with Other Shoe Manufacturing Materials",
    airline: [
      { airline: "EK", commodityCode: "1206", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "1206", product: "GCR" },
      { airline: "QR", commodityCode: "1206", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHOE UPPERS",
    label: "Shoes",
    airline: [
      { airline: "QR", commodityCode: "2417", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2415", product: "GCR" },
      { airline: "EK", commodityCode: "2415", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SHOES",
    label: "Shoes",
    airline: [
      { airline: "EK", commodityCode: "2415", product: "GCR" },
      { airline: "EK", commodityCode: "2415", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2415", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHOES AND SLIPPERS",
    label: "Shoes, Slippers",
    airline: [
      { airline: "QR", commodityCode: "2422", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2420", product: "GCR" },
      { airline: "EK", commodityCode: "2420", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SHOES ANDSLIPPERS FINISHEDSOLESHEELS ANDUPPERS EXCL ANY OTHER",
    label: "Shoes",
    airline: [
      { airline: "QR", commodityCode: "2418", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2415", product: "GCR" },
      { airline: "EK", commodityCode: "2415", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SHOES, SLIPPERS",
    label: "Shoes, Slippers",
    airline: [
      { airline: "EK", commodityCode: "2420", product: "GCR" },
      { airline: "EK", commodityCode: "2420", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2420", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHPMTS OF ICI, ITS SUBSIDIARIES & ASSOCIATE COS.",
    label: "Shipments of ICI, its subsidiaries & associate companies.",
    airline: [
      { airline: "EK", commodityCode: "9960", product: "GCR" },
      { airline: "EK", commodityCode: "9960", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9960", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SHRIMPS, PRAWNS",
    label: "Shrimps, etc.",
    airline: [
      { airline: "EK", commodityCode: "0380", product: "PXS" },
      { airline: "EK", commodityCode: "0380", product: "PXD" },
    ],
  },
  {
    value: "SHRIMPS, PRAWNS, LOBSTERS",
    label: "Shrimps, Prawns",
    airline: [
      { airline: "EK", commodityCode: "0384", product: "PXS" },
      { airline: "EK", commodityCode: "0384", product: "PXD" },
    ],
  },
  {
    value: "SILK ARTSILK MANUFACTURES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2175", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SILK YARN",
    label: "Wool, Yarn, Thread",
    airline: [
      { airline: "QR", commodityCode: "2075", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2090", product: "GCR" },
      { airline: "EK", commodityCode: "2090", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SILVER ORE",
    label: "Silver Ore",
    airline: [
      { airline: "EK", commodityCode: "3896", product: "GCR" },
      { airline: "EK", commodityCode: "3896", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SILVER-BULLION,INGOTS,SPECIE,GRAIN,FOIL.",
    label: "Silver Bullion, Ingots, Specie, Grain",
    airline: [
      { airline: "EK", commodityCode: "3015", product: "GCR" },
      { airline: "EK", commodityCode: "3015", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SILVER/SILVER PRODUCTS/SILVER JEWELLERY",
    label: "Silver, Silver Products, Silver Jewelry",
    airline: [
      { airline: "EK", commodityCode: "E0077", product: "GCR" },
      { airline: "EK", commodityCode: "E0077", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SKATEBOARD  INCL HELMETS, PROTECTIVE PADS",
    label: "Skateboard Including Helmets, Protective Pads",
    airline: [
      { airline: "EK", commodityCode: "9229", product: "GCR" },
      { airline: "EK", commodityCode: "9229", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9229", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SKIS,SKIPOLES,SKI BINDINGS",
    label: "Skis, Ski Poles, Ski Bindings",
    airline: [
      { airline: "EK", commodityCode: "9274", product: "GCR" },
      { airline: "EK", commodityCode: "9274", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9274", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SMOKE DETECTORS",
    label: "Government Owned Stores, Including Supplies",
    airline: [
      { airline: "EK", commodityCode: "4449", product: "GCR" },
      { airline: "EK", commodityCode: "4449", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4449", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SNAILS",
    label: "Snails",
    airline: [
      { airline: "EK", commodityCode: "1091", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SNAPPER",
    label: "Snapper",
    airline: [
      { airline: "EK", commodityCode: "0355", product: "PXS" },
      { airline: "EK", commodityCode: "0355", product: "PXD" },
    ],
  },
  {
    value: "SOLES  FOR SHOES, SLIPPERS",
    label: "Soles for Shoes, Slippers",
    airline: [
      { airline: "EK", commodityCode: "2426", product: "GCR" },
      { airline: "EK", commodityCode: "2426", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2426", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SOUPS",
    label: "Soups",
    airline: [
      { airline: "EK", commodityCode: "0885", product: "PXS" },
      { airline: "EK", commodityCode: "0885", product: "PXD" },
    ],
  },
  {
    value: "SOUVENIRS INCL LEATHER GOODS,SILVERWARE,WOOD/COPPER MFRS,BON",
    label: "Souvenirs including leather goods, silverware, wood/copper manufactures, and bone",
    airline: [
      { airline: "EK", commodityCode: "9505", product: "GCR" },
      { airline: "EK", commodityCode: "9505", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9505", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SOUVENIRS LEATHER/WOOD/COPPER/IVORY/BONE/HORN GDS.",
    label: "Souvenirs Leather, Wood, Copper, Ivory, Bone, Horn Goods.",
    airline: [
      { airline: "EK", commodityCode: "9508", product: "GCR" },
      { airline: "EK", commodityCode: "9508", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9508", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPECTACLE FRAMES",
    label: "Spectacle Frames",
    airline: [
      { airline: "EK", commodityCode: "8371", product: "GCR" },
      { airline: "EK", commodityCode: "8371", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8371", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPECTACLES,SUNGLASSES - INCL ACCESSORIES",
    label: "Spectacles, Sunglasses - Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "8372", product: "GCR" },
      { airline: "EK", commodityCode: "8372", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8372", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPICES, SPICE EXTRACTS EXCLUDING SAFFRON",
    label: "Spices, Spice Extracts Excluding Saffron",
    airline: [
      { airline: "EK", commodityCode: "0702", product: "PXS" },
      { airline: "EK", commodityCode: "0702", product: "PXD" },
    ],
  },
  {
    value: "SPIRITS,LIQUORS,WINES,BEERS",
    label: "Spirits, Liquors, Wines",
    airline: [
      { airline: "EK", commodityCode: "0129", product: "GCR" },
      { airline: "EK", commodityCode: "0129", product: "PXD" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPONGES  ARTIFICIAL",
    label: "Sponges, Artificial",
    airline: [
      { airline: "EK", commodityCode: "1981", product: "GCR" },
      { airline: "EK", commodityCode: "1981", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1981", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPONGES  NATURAL",
    label: "Sponges, Natural",
    airline: [
      { airline: "EK", commodityCode: "1980", product: "GCR" },
      { airline: "EK", commodityCode: "1980", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "1981", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SPORTING GUNS HUNTING GUNS",
    label: "Guns, Firearms, Ammunition",
    airline: [
      { airline: "QR", commodityCode: "9309", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
      { airline: "EK", commodityCode: "9300", product: "GCR" },
      { airline: "EK", commodityCode: "9300", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "STARTER SWITCHES FOR FLOURESCENT LAMPS",
    label: "Switches",
    airline: [
      { airline: "QR", commodityCode: "4570", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4434", product: "GCR" },
      { airline: "EK", commodityCode: "4434", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "STATIONERY",
    label: "Stationery",
    airline: [
      { airline: "EK", commodityCode: "7090", product: "GCR" },
      { airline: "EK", commodityCode: "7090", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7090", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "STATIONERY/OFFICE SUPPLIES",
    label: "Buttons, Buckles",
    airline: [
      { airline: "EK", commodityCode: "9744", product: "GCR" },
      { airline: "EK", commodityCode: "9744", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9744", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "STEEL CIRCLIPS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4734", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "STEEL STAPLES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3976", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "STOCKINGS, ANKLETS, PEDS, SOCKS",
    label: "Stockings, Anklets, Peds, Socks",
    airline: [
      { airline: "EK", commodityCode: "2360", product: "GCR" },
      { airline: "EK", commodityCode: "2360", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2360", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "STOMACH  DRIED",
    label: "Stomach, Dried",
    airline: [
      { airline: "EK", commodityCode: "1923", product: "GCR" },
      { airline: "EK", commodityCode: "1923", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "STONES FOR BUILDING CONSTRUCTION",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "5819", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "STRAW PRODUCTS, GRASS PRODUCTS",
    label: "Straw Products, Grass Products",
    airline: [
      { airline: "EK", commodityCode: "7500", product: "GCR" },
      { airline: "EK", commodityCode: "7500", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7500", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "STRAWBERRIES",
    label: "Strawberries",
    airline: [
      { airline: "EK", commodityCode: "0495", product: "PXS" },
      { airline: "EK", commodityCode: "0495", product: "PXD" },
    ],
  },
  {
    value: "STUDIO LIGHTING EQUIPMENT",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4472", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SUFACE COATED PAPER  IN ROLLS, SHEETS",
    label: "Surface Coated Paper in Rolls, Sheets",
    airline: [
      { airline: "EK", commodityCode: "7031", product: "GCR" },
      { airline: "EK", commodityCode: "7031", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7031", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SUITCASES,OVERNIGHT BAGS,BRIEFCASES,ATTACHE CASES,HANDBAGS,W",
    label: "Suitcases, Overnight Bags, Briefcases, Attache Cases, Handbags",
    airline: [
      { airline: "EK", commodityCode: "9558", product: "GCR" },
      { airline: "EK", commodityCode: "9558", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9558", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SUNGLASSES,GOGGLES",
    label: "Sunglasses, Goggles",
    airline: [
      { airline: "EK", commodityCode: "8380", product: "GCR" },
      { airline: "EK", commodityCode: "8380", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8380", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SUNGLASSES,GOGGLES-INCL SPECTACLE CASES WHEN SHPD WITH MAIN",
    label: "Sunglasses, Goggles - Including Spectacle Cases When Shipped With",
    airline: [
      { airline: "EK", commodityCode: "8382", product: "GCR" },
      { airline: "EK", commodityCode: "8382", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8382", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFAC VEHICLS EXCL STEAMSHIP/MOTORSHIP PARTS",
    label: "Surface Vehicles Excluding Steamship or Motorsip",
    airline: [
      { airline: "EK", commodityCode: "4201", product: "GCR" },
      { airline: "EK", commodityCode: "4201", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9739", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFAC VEHICLS,SELF-PROPELLED AGRI MACH-INCL ACCESRS-EXCL ST",
    label: "Surface Vehicles, Self-Propelled Agricultural Machinery - Including Accessories",
    airline: [
      { airline: "EK", commodityCode: "4206", product: "GCR" },
      { airline: "EK", commodityCode: "4206", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9739", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFACE VEHICLES INCL ACCESSORIES ,MACHINERY,TOOLS,CUTLERY",
    label: "Surface vehicles, including accessories, machinery, tools, and cutlery.",
    airline: [
      { airline: "EK", commodityCode: "9715", product: "GCR" },
      { airline: "EK", commodityCode: "9715", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4703", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFACE VEHICLES,PARTS,ACCESSORIES",
    label: "Surface Vehicles, Parts, Accessories",
    airline: [
      { airline: "EK", commodityCode: "4200", product: "GCR" },
      { airline: "EK", commodityCode: "4200", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFACE VEHICLES(INCL ACCESSORIES) EXCH STEAM/MOTORSHP PARTS",
    label: "Surface Vehicles (including Accessories) Excluding Steam or Motor Ship Parts",
    airline: [
      { airline: "EK", commodityCode: "9725", product: "GCR" },
      { airline: "EK", commodityCode: "9725", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9727", product: "GCR" },
      { airline: "EK", commodityCode: "9727", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SURFACE VEHICLS INCL ACCES MACHNS EXCL STEAM/MOTORSHP MACHN",
    label: "Surface Vehicles, Including Accessories and Machines, Excluding Steam or Motor Ship Machines",
    airline: [
      { airline: "EK", commodityCode: "9704", product: "GCR" },
      { airline: "EK", commodityCode: "9704", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURFACE VHCLS,SELF-PPLD AGRO MACH-INCL ACCSR-EXCL STEAM/MOTO",
    label: "Surface Vehicles, Self-Propelled Agricultural Machines - Including Accessories - Excluding Steam or Motor Ship Machines",
    airline: [
      { airline: "EK", commodityCode: "4209", product: "GCR" },
      { airline: "EK", commodityCode: "4209", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9739", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURGICAL BEDS",
    label: "Surgical Beds",
    airline: [
      { airline: "EK", commodityCode: "8103", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SURGICAL GAUZES/BANDAGES/COTTON WOOL/SANITARY TOWELS",
    label: "Surgical Gauzes, Bandages, Cotton Wool, Sanitary",
    airline: [
      { airline: "EK", commodityCode: "6007", product: "GCR" },
      { airline: "EK", commodityCode: "6007", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7430", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SWITCHES",
    label: "Switches",
    airline: [
      { airline: "EK", commodityCode: "4434", product: "GCR" },
      { airline: "EK", commodityCode: "4434", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4434", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "SWITCHESRELAYSFUSESEXCESS VOLTAGE CONDUCTORSPLUGSSOCKET",
    label: "Relays",
    airline: [
      { airline: "QR", commodityCode: "4493", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4428", product: "GCR" },
      { airline: "EK", commodityCode: "4428", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "SWITCHGEARSMETERSFUSESTRANSFORMERSRELAYS ELECTRIC",
    label: "MOTORS GENERATORS TRANSFORMERS ELECTRIC",
    airline: [
      { airline: "QR", commodityCode: "4583", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4560", product: "GCR" },
      { airline: "EK", commodityCode: "4560", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TABLE FLATWARE, BRONZEWARE",
    label: "Table Flatware, Bronzeware",
    airline: [
      { airline: "EK", commodityCode: "3150", product: "GCR" },
      { airline: "EK", commodityCode: "3150", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3150", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TABLE/KITCHEN UTENSLS OF STNLESS STEEL EXCL MACHI,ELEC EQPT",
    label: "Table and Kitchen Utensils of Stainless Steel Excluding Machinery",
    airline: [
      { airline: "EK", commodityCode: "3404", product: "GCR" },
      { airline: "EK", commodityCode: "3404", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3404", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TACHOGRAPHS FOR SURFACE VEHICLES",
    label: "Surface Vehicles, Parts, Accessories",
    airline: [
      { airline: "QR", commodityCode: "4243", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4200", product: "GCR" },
      { airline: "EK", commodityCode: "4200", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TAPE RECORDERS",
    label: "Radios, Televisions, Record Players, Tape Recorders",
    airline: [
      { airline: "QR", commodityCode: "4418", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4411", product: "GCR" },
      { airline: "EK", commodityCode: "4411", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TAPS AND DIES",
    label: "Taps and Dies",
    airline: [
      { airline: "EK", commodityCode: "4803", product: "GCR" },
      { airline: "EK", commodityCode: "4803", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4803", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TAROS",
    label: "Taro",
    airline: [
      { airline: "EK", commodityCode: "0866", product: "PXS" },
      { airline: "EK", commodityCode: "0866", product: "PXD" },
    ],
  },
  {
    value: "TEA",
    label: "Tea",
    airline: [
      { airline: "EK", commodityCode: "0185", product: "PXS" },
      { airline: "EK", commodityCode: "0185", product: "GCR" },
      { airline: "EK", commodityCode: "0185", product: "PXD" },
    ],
  },
  {
    value: "TEA INSTANT",
    label: "Instant Tea",
    airline: [
      { airline: "EK", commodityCode: "0186", product: "PXS" },
      { airline: "EK", commodityCode: "0186", product: "PXD" },
    ],
  },
  {
    value: "TELEGRAPH/TELEPHONE/TELETYPE APPARATUS",
    label: "Telegraph/Telephone/Teletype Apparatus",
    airline: [
      { airline: "EK", commodityCode: "4445", product: "GCR" },
      { airline: "EK", commodityCode: "4445", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4492", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TELEPHONE MARBLE BASES",
    label: "Marble",
    airline: [
      { airline: "QR", commodityCode: "5293", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "5400", product: "GCR" },
      { airline: "EK", commodityCode: "5400", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TELEVISION TUNERS",
    label: "Television Tuners",
    airline: [
      { airline: "EK", commodityCode: "4506", product: "GCR" },
      { airline: "EK", commodityCode: "4506", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4506", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TELEVISIONS",
    label: "Televisions",
    airline: [
      { airline: "EK", commodityCode: "4442", product: "GCR" },
      { airline: "EK", commodityCode: "4442", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4414", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TERRY CLOTH, TERRY ARTICLES",
    label: "Terry Cloth, Terry Articles",
    airline: [
      { airline: "EK", commodityCode: "2222", product: "GCR" },
      { airline: "EK", commodityCode: "2222", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2222", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TESTING EQPT USD TO CHK FOR POISONOUS FUMES IN MINES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8554", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TEXTBOOKS,INSTRUMTS,VISUAL TEACHG AIDS-FOR USE EDUCATNL INST",
    label: "Textbooks, Instruments, Visual Teaching Aids - For Use Educational Institutions",
    airline: [
      { airline: "EK", commodityCode: "7159", product: "GCR" },
      { airline: "EK", commodityCode: "7159", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7011", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TEXTILE ARTICLES  FNSHD/EXCL WEARING APPAREL",
    label: "Textile Articles, Finished, Excluding Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "2600", product: "GCR" },
      { airline: "EK", commodityCode: "2600", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2600", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TEXTILE FIBRESANDMFRS,METALANDMFRS,NON-METLC  MISC.ITEMS.......",
    label: "Textile Fibers and Manufactures, Metal and Manufactures, Non-Metallic Miscellaneous Items.",
    airline: [
      { airline: "EK", commodityCode: "9752", product: "GCR" },
      { airline: "EK", commodityCode: "9752", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9752", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TEXTILE FURNISHINGS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2800", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TEXTILE/SEWING/SHOE MACHINERY",
    label: "Textile, Sewing, and Shoe Machinery",
    airline: [
      { airline: "EK", commodityCode: "4780", product: "GCR" },
      { airline: "EK", commodityCode: "4780", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4780", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TEXTILES,APPAREL,MACHINERY,CUTLER,ELEC EQPT,SURFACE VEHICLES",
    label: "Textiles, Apparel, Machinery, Cutlery, Electrical Equipment, Surface Vehicles",
    airline: [
      { airline: "EK", commodityCode: "9733", product: "GCR" },
      { airline: "EK", commodityCode: "9733", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9733", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "THERMOSTATS,SELECTOR SWITCHES,SWITCH DOORS",
    label: "Thermostats, Selector Switches, Switch Doors",
    airline: [
      { airline: "EK", commodityCode: "4467", product: "GCR" },
      { airline: "EK", commodityCode: "4467", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4467", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "THREAD CORD MADE OF RUBBER TEXTILE COVERED",
    label: "Rubber, Rubber Products",
    airline: [
      { airline: "QR", commodityCode: "2041", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "7400", product: "GCR" },
      { airline: "EK", commodityCode: "7400", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TILAPIA",
    label: "Tilapia",
    airline: [
      { airline: "EK", commodityCode: "0318", product: "PXS" },
      { airline: "EK", commodityCode: "0318", product: "PXD" },
    ],
  },
  {
    value: "TISSUE PAPER",
    label: "PAPER PRODUCTS",
    airline: [
      { airline: "QR", commodityCode: "7050", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "GCR" },
      { airline: "EK", commodityCode: "9721", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TITANIUM ALLOYS NICKEL ALLOYS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3993", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TOBACCO, CIGARS, CIGARETTES",
    label: "Tobacco, Cigars, Cigarettes",
    airline: [
      { airline: "EK", commodityCode: "9601", product: "GCR" },
      { airline: "EK", commodityCode: "9601", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOBACCO, TOBACCO PRODUCTS",
    label: "Tobacco, Tobacco Products",
    airline: [
      { airline: "EK", commodityCode: "1550", product: "GCR" },
      { airline: "EK", commodityCode: "1550", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOBACCO,CIGARS,CIGARETTES,PIPES,HUMIDORS,CIGAR/CIGARETTE HOL",
    label: "Tobacco, Cigars, Cigarettes, Pipes, Humidors, Cigar/Cigarette Holders",
    airline: [
      { airline: "EK", commodityCode: "9602", product: "GCR" },
      { airline: "EK", commodityCode: "9602", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOILET ARTICLES/TOILET WATER/PERFUMES/COSMETICS-ALONE OR TOG",
    label: "Toilet Articles, Toilet Water, Perfumes, Cosmetics, and Related Products",
    airline: [
      { airline: "EK", commodityCode: "6605", product: "GCR" },
      { airline: "EK", commodityCode: "6605", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOMATOES",
    label: "Tomatoes",
    airline: [
      { airline: "EK", commodityCode: "0880", product: "PXS" },
      { airline: "EK", commodityCode: "0880", product: "PXD" },
    ],
  },
  {
    value: "TOOLS",
    label: "Tools",
    airline: [
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4800", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOOLS INCLUDING RAZOR BLADES , CUTLERY",
    label: "Tools, including razor blades, and cutlery.",
    airline: [
      { airline: "EK", commodityCode: "9707", product: "GCR" },
      { airline: "EK", commodityCode: "9707", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9707", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOOLS INCLUDING RAZOR BLADES CUTLERY",
    label: "TOOLS INCLUDING RAZOR BLADES CUTLERY",
    airline: [
      { airline: "QR", commodityCode: "3200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9707", product: "GCR" },
      { airline: "EK", commodityCode: "9707", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TOUPEES,WIGS,SWITCHES,FALSE EYELASHES",
    label: "Toupees, Wigs, Switches, False Eyelashes",
    airline: [
      { airline: "EK", commodityCode: "2741", product: "GCR" },
      { airline: "EK", commodityCode: "2741", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2741", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOWELS",
    label: "Blankets, Bedsheets/Spreads, Pillow Cases, Mosquito Nets",
    airline: [
      { airline: "QR", commodityCode: "2846", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2811", product: "GCR" },
      { airline: "EK", commodityCode: "2811", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TOYS EXCL TOY TRAINS UMBRELLASATHLETIC EQPT MADE PRIMARILY",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "6859", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TOYS GAMES",
    label: "Toys, games, athletic goods, sporting goods",
    airline: [
      { airline: "QR", commodityCode: "9203", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "9202", product: "GCR" },
      { airline: "EK", commodityCode: "9202", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TOYS GAMES-INCL PACKAGING MTRL WHEN HPD WITH MAIN ARTCL",
    label: "Toys, games, including packaging material when shipped with main article.",
    airline: [
      { airline: "EK", commodityCode: "9207", product: "GCR" },
      { airline: "EK", commodityCode: "9207", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9207", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOYS,GAMES,ATHELTIC GOODS INCL SPORTG/HUNTG GUNS EXCL WATCHE",
    label: "Toys, Games, Athletic Goods, including Sporting or Hunting Guns, excluding Watches",
    airline: [
      { airline: "EK", commodityCode: "9206", product: "GCR" },
      { airline: "EK", commodityCode: "9206", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9206", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOYS,GAMES,ATHLETIC GOODS,SPORTG GOODS EXCL WEARING APPAREL",
    label: "Toys, Games, Athletic Goods, Sporting Goods excluding Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "9205", product: "GCR" },
      { airline: "EK", commodityCode: "9205", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9205", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOYS,GAMES,ATHLETIC GOODS,SPORTING GOODS",
    label: "Toys, games, athletic goods, sporting goods",
    airline: [
      { airline: "EK", commodityCode: "9202", product: "GCR" },
      { airline: "EK", commodityCode: "9202", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9202", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TOYS,GAMES,SPORTING EQUIPMENT",
    label: "Toys, Games, Sporting Equipment",
    airline: [
      { airline: "EK", commodityCode: "9712", product: "GCR" },
      { airline: "EK", commodityCode: "9712", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9712", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TRANSFERS DECALCOMANIA",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "7047", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TRANSISTOR RADIOS",
    label: "Transistor Radios",
    airline: [
      { airline: "EK", commodityCode: "4444", product: "GCR" },
      { airline: "EK", commodityCode: "4444", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4444", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TRANSISTORS, ELECTRIC CONDENSERS",
    label: "Transistors, Electric Condensers",
    airline: [
      { airline: "EK", commodityCode: "4436", product: "GCR" },
      { airline: "EK", commodityCode: "4436", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4436", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TRANSPARENT CELLULOSIC WRAPPING MATERIAL",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9056", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TROPICAL PLANTS  EXCL CUT FLOWERS",
    label: "Tropical Plants, Excluding Cut Flowers",
    airline: [
      { airline: "EK", commodityCode: "1477", product: "PXD" },
      { airline: "EK", commodityCode: "1477", product: "PXS" },
    ],
  },
  {
    value: "TROPICAL PLANTS, SEEDS",
    label: "Tropical Plants, Seeds",
    airline: [
      { airline: "EK", commodityCode: "1480", product: "PXD" },
      { airline: "EK", commodityCode: "1480", product: "PXS" },
    ],
  },
  {
    value: "TROUSERS, SHIRTS",
    label: "Trousers, Shirts",
    airline: [
      { airline: "EK", commodityCode: "2214", product: "GCR" },
      { airline: "EK", commodityCode: "2214", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2214", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TUBE FITTNGS THERMOPLASTIC TUBES TUBING TOOLS TUBE VALVES",
    label: "Tools",
    airline: [
      { airline: "QR", commodityCode: "3052", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "GCR" },
      { airline: "EK", commodityCode: "4800", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TUBERS,EARTH NUTS",
    label: "Tubers, Earth Nuts",
    airline: [
      { airline: "EK", commodityCode: "0017", product: "PXS" },
      { airline: "EK", commodityCode: "0017", product: "PXD" },
    ],
  },
  {
    value: "TUBES, VALVES - FOR RADIOS, TELEVISIONS",
    label: "Tubes, Valves - For Radios, Televisions",
    airline: [
      { airline: "EK", commodityCode: "4433", product: "GCR" },
      { airline: "EK", commodityCode: "4433", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4433", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TUBIFEX WORMS",
    label: "Tubifex worms",
    airline: [
      { airline: "EK", commodityCode: "1059", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TUNA  FRESH",
    label: "Tuna Fish",
    airline: [
      { airline: "EK", commodityCode: "0323", product: "PXS" },
      { airline: "EK", commodityCode: "0323", product: "PXD" },
    ],
  },
  {
    value: "TUNGSTENTUNGSTN CARBIDE POWDERTNGSTN CONCNTRATSTANTALUM",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3094", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TURKEY HATCHING EGGS",
    label: "Turkey Hatching Eggs",
    airline: [
      { airline: "EK", commodityCode: "1084", product: "PXS" },
      { airline: "EK", commodityCode: "1084", product: "PXD" },
    ],
  },
  {
    value: "TURTLES",
    label: "Turtles",
    airline: [
      { airline: "EK", commodityCode: "0385", product: "PXS" },
      { airline: "EK", commodityCode: "0385", product: "PXD" },
      { airline: "EK", commodityCode: "1072", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TV TUNER PARTS NES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "4441", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "TWIST/MASONRY DRILLS,MILLING CUTTERS,REAMERS,TOOL BITS,HACKS",
    label: "Twist or Masonry Drills, Milling Cutters, Reamers, Tools",
    airline: [
      { airline: "EK", commodityCode: "4816", product: "GCR" },
      { airline: "EK", commodityCode: "4816", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4816", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TYPEWRITER RIBBONS",
    label: "Typewriter Ribbons",
    airline: [
      { airline: "EK", commodityCode: "4382", product: "GCR" },
      { airline: "EK", commodityCode: "4382", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4382", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "TYPEWRITERS",
    label: "Typewriters",
    airline: [
      { airline: "EK", commodityCode: "4321", product: "GCR" },
      { airline: "EK", commodityCode: "4321", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4321", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "UNACCOMPANIED BAGGAGE, PERSONAL EFFECTS  NOT FORE RESALE",
    label: "Unaccompanied Baggage, Personal Effects Not For Resale",
    airline: [
      { airline: "EK", commodityCode: "9986", product: "GCR" },
      { airline: "EK", commodityCode: "9986", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9986", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "UNDERWEAR",
    label: "Underwear, Swimwear, Body Supporting Garments",
    airline: [
      { airline: "QR", commodityCode: "2460", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2461", product: "GCR" },
      { airline: "EK", commodityCode: "2461", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "UNDERWEAR, SWIMWEAR, BODY SUPPORTING GARMENTS",
    label: "Underwear, Swimwear, Body Supporting Garments",
    airline: [
      { airline: "EK", commodityCode: "2461", product: "GCR" },
      { airline: "EK", commodityCode: "2461", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2461", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "UNEXPOSED FILMS, UNRECORDED TAPES",
    label: "Unexposed Films, Unrecorded Tapes",
    airline: [
      { airline: "EK", commodityCode: "8434", product: "GCR" },
      { airline: "EK", commodityCode: "8434", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8434", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "UNIVERSAL FILLING GUIDES,GREASE GUNS,WOOD FILES,FIXEDSAWS HA",
    label: "Universal Filling Guides, Grease Guns, Wood Files, Fixtures",
    airline: [
      { airline: "EK", commodityCode: "4819", product: "GCR" },
      { airline: "EK", commodityCode: "4819", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4819", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "UPHOLSTERYCURTAINSDRAPERS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "2830", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "US DIPLOMATIC POUCHES, MOVING ON US GOVT. B/L",
    label: "US Diplomatic Pouches, Moving on US Government Bill of Lading",
    airline: [
      { airline: "EK", commodityCode: "9947", product: "GCR" },
      { airline: "EK", commodityCode: "9947", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9947", product: "GCR", productSHC: "GCR", commoditySHC: "\"GCR" },
    ],
  },
  {
    value: "VACCINES",
    label: "Vaccines",
    airline: [
      { airline: "EK", commodityCode: "6099", product: "AXS", productSHC: "PIL" },
    ],
  },
  {
    value: "VALVES,ELEC/MECH MACHINRY FR NUCLEAR,HYDRO-CARBON POWER PLAN",
    label: "VALVES, electrical or mechanical machinery for nuclear, hydro-carbon power",
    airline: [
      { airline: "EK", commodityCode: "4515", product: "GCR" },
      { airline: "EK", commodityCode: "4515", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4515", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VEHICLES AND ACCESSORIES EXCL STEAM/MOTOR/RAIL/ARGI.MACH.PARTS",
    label: "Vehicles and Accessories Excluding Steam, Motor, Rail, Agricultural Machinery Parts",
    airline: [
      { airline: "EK", commodityCode: "4203", product: "GCR" },
      { airline: "EK", commodityCode: "4203", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9739", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VETERINARY MEDICINAL DIETARY ADDITIVE",
    label: "Veterinary Medicinal Dietary Additive",
    airline: [
      { airline: "EK", commodityCode: "6251", product: "GCR" },
      { airline: "EK", commodityCode: "6251", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6200", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VETERINARY PHARMACEUTICALS",
    label: "Veterinary Pharmaceuticals",
    airline: [
      { airline: "EK", commodityCode: "6502", product: "GCR" },
      { airline: "EK", commodityCode: "6502", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VIDEO CASSETTES",
    label: "Video Cassettes",
    airline: [
      { airline: "EK", commodityCode: "8284", product: "GCR" },
      { airline: "EK", commodityCode: "8284", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8284", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VISCOSE CLOTH NOT FRTHR PRCSSD/MFD/EXCLSVLY IN BALES,BOLTS,P",
    label: "Viscose cloth, not further processed, manufactured, or exclusively in",
    airline: [
      { airline: "EK", commodityCode: "2104", product: "GCR" },
      { airline: "EK", commodityCode: "2104", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2104", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "VITAMINS FOR ANIMAL FOOD",
    label: "Vitamins for Animal Food",
    airline: [
      { airline: "EK", commodityCode: "0986", product: "AXA", productSHC: "AXA" },
      { airline: "EK", commodityCode: "0986", product: "GCR" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WALKIE TALKIES INCLUDING BATTERIES",
    label: "Batteries",
    airline: [
      { airline: "QR", commodityCode: "4448", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "4405", product: "GCR" },
      { airline: "EK", commodityCode: "4405", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WALLPAPER",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "7056", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WATCH BANDS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "9531", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WATCH PARTS",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "8912", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WATCHES",
    label: "Watches",
    airline: [
      { airline: "EK", commodityCode: "8925", product: "GCR" },
      { airline: "EK", commodityCode: "8925", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8912", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WATCHES, CLOCKS",
    label: "Watches, Clocks",
    airline: [
      { airline: "EK", commodityCode: "8911", product: "GCR" },
      { airline: "EK", commodityCode: "8911", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8912", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WEARING APPAREL MADE OF LEATH EXCL FOOTWEAR",
    label: "WEARING APPAREL",
    airline: [
      { airline: "QR", commodityCode: "2245", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "GCR" },
      { airline: "EK", commodityCode: "2200", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WEARING APPAREL,COSEMTICS,TOILET ARTCLS USED NOT FOR RESALE",
    label: "Wearing Apparel, Cosmetics, Toilet Articles Used Not for Resale",
    airline: [
      { airline: "EK", commodityCode: "9995", product: "GCR" },
      { airline: "EK", commodityCode: "9995", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9999", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WELDING SUPPLIES",
    label: "",
    airline: [
      { airline: "QR", commodityCode: "3909", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "GCR" },
      { airline: "EK", commodityCode: "E0000", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WILLOW ARTICLES  WOVEN",
    label: "Willow Articles Woven",
    airline: [
      { airline: "EK", commodityCode: "7381", product: "GCR" },
      { airline: "EK", commodityCode: "7381", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7381", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WINES",
    label: "Wines",
    airline: [
      { airline: "EK", commodityCode: "0130", product: "PXS" },
      { airline: "EK", commodityCode: "0130", product: "GCR" },
      { airline: "EK", commodityCode: "0130", product: "PXD" },
    ],
  },
  {
    value: "WIRE CLOTH",
    label: "Wire Cloth",
    airline: [
      { airline: "EK", commodityCode: "3004", product: "GCR" },
      { airline: "EK", commodityCode: "3004", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "3004", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WIRE PROCESSORS",
    label: "Wire Processors",
    airline: [
      { airline: "EK", commodityCode: "4330", product: "GCR" },
      { airline: "EK", commodityCode: "4330", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4330", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WIRES,CABLES - ELECTRIC -",
    label: "Wires, Cables - Electrical",
    airline: [
      { airline: "EK", commodityCode: "4477", product: "GCR" },
      { airline: "EK", commodityCode: "4477", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "4477", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOOD PARQUET FLOORING",
    label: "Wood Parquet Flooring",
    airline: [
      { airline: "EK", commodityCode: "7608", product: "GCR" },
      { airline: "EK", commodityCode: "7608", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7608", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOOD, WOOD PRODUCTS",
    label: "Wood, Wood Products",
    airline: [
      { airline: "EK", commodityCode: "7600", product: "GCR" },
      { airline: "EK", commodityCode: "7600", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7600", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOODEN CABINETS FOR RADIOS,TVS,PHONOGRAPHS,SEWING MACHINES",
    label: "Wooden Cabinets for Radios, Televisions, Phonographs, Sewing",
    airline: [
      { airline: "EK", commodityCode: "7630", product: "GCR" },
      { airline: "EK", commodityCode: "7630", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7630", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOODEN FURNITURE  EXCL OBJECTS OF ART",
    label: "Wooden Furniture Excluding Objects of Art",
    airline: [
      { airline: "EK", commodityCode: "7627", product: "GCR" },
      { airline: "EK", commodityCode: "7627", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "7627", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOODEN TOYS",
    label: "Wooden Toys",
    airline: [
      { airline: "EK", commodityCode: "9204", product: "GCR" },
      { airline: "EK", commodityCode: "9204", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "9204", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WOOL, YARN, THREAD",
    label: "Wool, Yarn, Thread",
    airline: [
      { airline: "EK", commodityCode: "2090", product: "GCR" },
      { airline: "EK", commodityCode: "2090", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2090", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "WORMS",
    label: "Worms",
    airline: [
      { airline: "EK", commodityCode: "1093", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "WRIST WATCHES  WITH BAND OR BRACELETS",
    label: "Wristwatches with Band or Bracelet",
    airline: [
      { airline: "EK", commodityCode: "8913", product: "GCR" },
      { airline: "EK", commodityCode: "8913", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "8912", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "XANTHOPHYLL CONCENTRATE",
    label: "Xanthophyll Concentrate",
    airline: [
      { airline: "EK", commodityCode: "6208", product: "GCR" },
      { airline: "EK", commodityCode: "6208", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "6208", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YAMS, COCOYAMS, PLAINTAINS",
    label: "Yams, Cocoyams",
    airline: [
      { airline: "EK", commodityCode: "0807", product: "PXS" },
      { airline: "EK", commodityCode: "0807", product: "PXD" },
    ],
  },
  {
    value: "YARN, THREAD, FIBRES",
    label: "Yarn, Thread, Fibres",
    airline: [
      { airline: "EK", commodityCode: "2002", product: "GCR" },
      { airline: "EK", commodityCode: "2002", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2002", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YARN,THREAD,FIBERS IN BALES/BOLTS/PCS AND BEDSHEETS ETC MADE O",
    label: "Yarn, Thread, Fibers in Bales, Bolts, Pieces, and Bed Sheets",
    airline: [
      { airline: "EK", commodityCode: "2192", product: "GCR" },
      { airline: "EK", commodityCode: "2192", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2192", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YARN,THREAD,FIBRE,TEXTILE,EXCL.WEARING A",
    label: "Yarn, Thread, Fibre, Textile, excluding Wearing Apparel",
    airline: [
      { airline: "EK", commodityCode: "2198", product: "GCR" },
      { airline: "EK", commodityCode: "2198", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2198", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YARN,THREAD,FIBRES, TEXTILE MANUFACTURES",
    label: "Yarn, Thread, Fibres, Textile Manufactures",
    airline: [
      { airline: "EK", commodityCode: "2001", product: "GCR" },
      { airline: "EK", commodityCode: "2001", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2001", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YARN,THREAD,FIBRES,CLOTH-NOT FURTHER PROCESSED OR MANUFACTUR",
    label: "Yarn, thread, fibers, cloth - not further processed or manufactured.",
    airline: [
      { airline: "EK", commodityCode: "2197", product: "GCR" },
      { airline: "EK", commodityCode: "2197", product: "AXA", productSHC: "AXA" },
      { airline: "QR", commodityCode: "2197", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
    ],
  },
  {
    value: "YARNTHREADFIBRES IN BALES EXCL CLOTHINGFOOTWEAROUTW",
    label: "Yarn, Thread, Fibres",
    airline: [
      { airline: "QR", commodityCode: "2196", product: "GCR", productSHC: "GCR", commoditySHC: "GCR" },
      { airline: "EK", commodityCode: "2002", product: "GCR" },
      { airline: "EK", commodityCode: "2002", product: "AXA", productSHC: "AXA" },
    ],
  },
  {
    value: "YEAST",
    label: "Yeast",
    airline: [
      { airline: "EK", commodityCode: "0899", product: "PXS" },
      { airline: "EK", commodityCode: "0899", product: "PXD" },
    ],
  },
  {
    value: "YUCA CUTTINGS",
    label: "Yuca Cuttings",
    airline: [
      { airline: "EK", commodityCode: "1472", product: "PXD" },
      { airline: "EK", commodityCode: "1472", product: "PXS" },
    ],
  }
];
